(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sorting"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    const sort = document.getElementById('sortBy');
    if (!sort) return;
    sort.value = sort.dataset.currentSort;
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.assign(url.toString());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-views"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => document.querySelectorAll('.change-view[data-view]').forEach(link => {
    const url = new URL(window.location.href);
    url.searchParams.set('view', link.dataset.view);
    link.href = url.toString();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-approved-videos"] && !Shopify.designMode) return;
  try {
    (function () {
  function prepareVideos() {
    var root = document.getElementById('ProductSection');
    if (!root) return;
    root.querySelectorAll('video').forEach(function (video) {
      if (video.closest('[data-sc-video-accordion]')) return;
      var box = document.createElement('details');
      box.className = 'sc-approved-video sc-video-accordion';
      box.setAttribute('data-sc-video-accordion', '');
      var summary = document.createElement('summary');
      summary.className = 'sc-video-summary';
      var label = video.getAttribute('aria-label');
      var labelled = video.getAttribute('aria-labelledby');
      if (!label && labelled) label = labelled.split(/\s+/).map(function (id) { var el = document.getElementById(id); return el ? el.textContent.trim() : ''; }).join(' ').trim();
      summary.textContent = label || root.getAttribute('data-sc-video-title');
      var content = document.createElement('div');
      content.className = 'sc-video-content';
      video.parentNode.insertBefore(box, video);
      box.appendChild(summary);
      box.appendChild(content);
      content.appendChild(video);
      video.pause();
      video.preload = 'none';
      if (video.hasAttribute('src')) { video.setAttribute('data-src', video.getAttribute('src')); video.removeAttribute('src'); }
      if (video.hasAttribute('poster')) { video.setAttribute('data-poster', video.getAttribute('poster')); video.removeAttribute('poster'); }
      video.querySelectorAll('source[src], track[src]').forEach(function (source) { source.setAttribute('data-src', source.getAttribute('src')); source.removeAttribute('src'); });
      video.setAttribute('data-sc-video-deferred', '');
    });
  }
  document.addEventListener('toggle', function (event) {
    var box = event.target;
    if (!box.matches || !box.matches('[data-sc-video-accordion]')) return;
    box.querySelectorAll('video').forEach(function (video) {
      if (!box.open) { video.pause(); return; }
      if (video.getAttribute('data-sc-video-loaded')) return;
      var poster = video.getAttribute('data-poster');
      if (poster) video.setAttribute('poster', poster);
      if (video.getAttribute('data-src')) video.setAttribute('src', video.getAttribute('data-src'));
      video.querySelectorAll('source[data-src], track[data-src]').forEach(function (source) { source.setAttribute('src', source.getAttribute('data-src')); });
      video.preload = 'metadata';
      video.load();
      video.setAttribute('data-sc-video-loaded', 'true');
    });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareVideos);
  else prepareVideos();
  document.addEventListener('shopify:section:load', prepareVideos);
  var root = document.getElementById('ProductSection');
  if (root) new MutationObserver(prepareVideos).observe(root, { childList: true, subtree: true });
})();

(function () {
  function bindOpeningGuide() {
    var box = document.querySelector('[data-sc-opening-guide]');
    var root = document.getElementById('ProductSection');
    if (!box || !root || box.dataset.scOpeningBound) return;
    box.dataset.scOpeningBound = 'true';
    function sync() {
      var panel = document.getElementById('sc-door-width');
      var selector = document.getElementById('sc-door-opening');
      var available = Boolean(panel && !panel.hidden && selector && !selector.disabled);
      if (box.hidden === available) box.hidden = !available;
      if (!available && box.open) {
        box.open = false;
        box.querySelectorAll('video').forEach(function (video) { video.pause(); });
      }
    }
    sync();
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['hidden', 'disabled'], childList: true, subtree: true });
    root.addEventListener('change', function () { requestAnimationFrame(sync); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindOpeningGuide);
  else bindOpeningGuide();
  document.addEventListener('shopify:section:load', bindOpeningGuide);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-barrel-cushion-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const root = document.getElementById('sc-cushion-root');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const product = root.closest('#ProductSection');
    const form = product?.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const s = JSON.parse(root.querySelector('#sc-cushion-strings').textContent);
    const palette = {"3b1ac705241534d7faf7989ab7e3129ef6cd8aebd4be705f9afb579c9b3b2dd2":[183,161,152],"4993f5928d722966a61ed0c77d863bfa16fc6f9c547224f2237aec61c8ca2e5b":[10,9,12],"936246084800b4b853806562458fe8d7e4ad42a359c93f03e5da273853eef778":[138,17,24],"0edcebba2e4158055f58939a6bb922e1375943cb92e20112655ca867f37fcc8c":[9,38,37],"e4caf498dcaa51a9dfb009045ea3c5c495461edc77f994b32f8d411994df6bf4":[30,53,98],"51c1fd35a470d9a42dad9c166b71d0f7e256f8182a91b7d5aba3b8d0753079b8":[82,102,93],"9c51ac1f9052598894d6fa3fe2182ac32d5c0684990954aeec0386e42ab2e80d":[3,49,119],"de226fc33c86ba0c2da0b73ee7398f351586256989dbaf7fa73ae41a6638253b":[18,26,59],"e33078d104b9d548c261d07ad6827f5c18ce7acfae2f99aa494dc65c1e6815cb":[223,214,208],"597267393684189e66c892d703c6446c36d64a45f67de291da2344137939b616":[173,147,140],"c8dc7c7f4fedc740e2c7ad31489a3cf5e73b8d5b845cb0d984276c494dc0fb61":[225,221,223],"893c892fb7b7f1de1e078a41dbf7ad1b59108bb03ae3f9b3a71e189fceb5e9bf":[96,19,25],"50a79498418fc8cfc9853c2fec0a31df4826640b798a733f66363d470653af31":[202,187,184],"0c4d880fd718bc488e34ab240b5b1f7e5341eabb2acadef261c62fdc03d0fb36":[155,130,126],"85e7d8c9bf2207ccda22778a67c78f4deb879c6222d2ad1ab98f528c5ee78cae":[118,92,88],"b2dbdb2e947a4e1b87bb500b80869454fe20ee0f673d4204093242b038c44303":[71,66,74],"1528cd387c1c4792124047580b3a96615392b28ca05e294a08abf028c6614cb5":[101,87,88],"9e449ca37b0aef068e196426216e8b18a7f138b0eca4ad64ff178e314751656a":[26,15,17],"ea547ffe82f5639f5d1faa48f2425bdd696241d210fc0f070a219a483700e012":[151,146,157],"8ba8315a8dbc104f92da48f7119905c01862f27ad920718904dac2507f84f1c6":[64,60,68],"d88972def3b27d60e3930922f94d3e9e344c33ec7d923865753d2504574ee444":[118,110,114],"850a1716cc753a1d7d577f4b234dd0a6b1eaa951f5c0eeea2daa6c1c1da0d32a":[94,74,74],"981605903608fe6799dc304ce14364f93f92194878ba2a01dd0b195e69347b0e":[41,36,40],"004efc15b58256ec7fd9d76861c56d25a92a4648066f37a60f61c619e46f38ac":[14,55,55],"659694e7c4a252d37f02e4ae4da258035fd77bfa581d1ba2c49d17b142338ef1":[207,187,160],"9618484c6575795e4885e8755054cf093c0f0950df53d6dd9ce22e73f95467db":[22,22,24],"9b2fc6c9563b0d4d05e762152ff7e3246c39d89d7bfa7e5ede7993a2c8b32051":[120,103,87],"5377f9d65d69ea31d97b79bbc6e53f9afcf583dbccfb2ffd0fc91474d3e2e060":[126,127,141],"1e3d896bd7ff048ed69a81c1e1d6f5ab22a35df88f013be9e0cf9ea174927b25":[33,42,57],"f056861206fdd288e67203deebcee5708409cf58ae5d7b9dc41acb05c19f679a":[2,83,182],"e8a54a6de54985e762c1ba170e5687dbcc6b6b9d1791b013610c0f339d3ff6bf":[14,63,124],"9ed9dd48be8548cc19f81cd31dc197ff9cd6807566cda227d3b771134e30176b":[209,5,32],"82ad9c9e7f4b64308945a6b026aa35cd0eb993fc9f3e9910fedad843118dfffb":[11,54,109],"ba1c0ec85fa7c24cbab6de001b59c2f3f63867a01fde5dccf536d77bc90a88c6":[242,241,239],"8ebafe82b9ec7eac6de1dfece0abe870d5a5610b934a0e9a281b31059ff3312f":[96,27,35],"5ab3bd80c80e98a2612fc748e6fd98a89a212cb597b0e96e855131a4446ddd19":[179,180,174],"f7e6569fd4e52bab4461069d8d78931a20e7b1d8b6f0dcd1bc0cfca090c1de36":[236,203,158],"d364138b017e0d61ae6d5166c95bab3ea4934676c7a14e5ac2f43a7ce38c4072":[244,237,221],"c6768fe738ed6b27239c0fdba20975c90e9b5f0e0d08bd5d637ab290c8e6b78c":[193,194,196]};
    const photoTemplate = root.querySelector('#sc-cushion-photo-template');
    const colorPanel = root.querySelector('#sc-cushion-color');
    const gallery = root.closest('.sc-product-gallery');
    const imageModal = root.querySelector('#sc-cushion-image-dialog');
    const imageOpen = gallery?.querySelector('[data-sc-cushion-image-open]');
    if(imageOpen){
      imageOpen.addEventListener('click',()=>{
        const selected=gallery.querySelector('.product__image-wrapper:not(.hide) img[data-sc-full-image]');
        if(!selected)return;
        const large=imageModal.querySelector('[data-sc-cushion-large-image]');
        large.src=selected.dataset.scFullImage;large.alt=selected.alt;
        imageModal.querySelector('[data-sc-cushion-image-caption]').textContent=selected.alt;
        imageModal.showModal();imageModal.querySelector('button').focus();
      });
      imageModal.querySelector('[data-sc-cushion-image-close]').addEventListener('click',()=>imageModal.close());
      imageModal.addEventListener('close',()=>imageOpen.focus());
      imageModal.addEventListener('click',event=>{if(event.target===imageModal){const rect=imageModal.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)imageModal.close();}});
    }
    const colorNote = document.createElement('p');
    colorNote.className = 'sc-cushion-mobile-note';
    colorNote.textContent = s.color_note;
    const finish = root.querySelector('#sc-cushion-finished');
    const countGuide = root.querySelector('#sc-cushion-count');
    const measureGuide = root.querySelector('#sc-cushion-measure');
    const modal = root.querySelector('#sc-cushion-dialog');
    const openButton = finish.querySelector('button');
    const media = matchMedia('(max-width:768px)');
    let serial = 0, signature = '', queued = false, state;
    let colorPhoto;
    const visible = el => el && !el.closest('[hidden]') && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    const block = id => product.querySelector('#o_'+id);
    // Locate the one real native color swatch option, including an APO clone.
    // Never rewrite native IDs, input values or prices.
    const colorOption = () => {
      const matches = [...form.querySelectorAll('.mw-option')].filter(option =>
        option.querySelector('.mw-text--style-strong')?.textContent.replace(/\s+/g,' ').trim() === 'Choose Your Cushion Color');
      return matches.length === 1 && matches[0].querySelector('input[type="radio"]') ? matches[0] : null;
    };

    const select = id => block(id)?.querySelector('select');
    const textInput = id => block(id)?.querySelector('input[type="text"]');
    const selectedLabel = control => control?.value ? control.options[control.selectedIndex]?.textContent.trim().replace(/\s*\(\+[^)]*\)\s*$/,'') || '' : '';
    const label = id => block(id)?.querySelector('.mw-text--style-strong')?.textContent.trim().replace(/\s*\*$/,'') || '';
    const measurement = raw => {
      const n = /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(raw) ? Number(raw) : NaN;
      return Number.isFinite(n) && n>0 && Math.abs(n*4-Math.round(n*4))<1e-8?n:null;
    };
    const number = id => measurement(textInput(id)?.value.trim() || '');
    const makePhoto = (color, width=50, depth=20) => {
      const svg = photoTemplate.content.querySelector('svg').cloneNode(true);
      const suffix = '-'+(++serial);
      svg.querySelectorAll('[id]').forEach(el => el.id += suffix);
      svg.querySelector('image').setAttribute('clip-path','url(#sc-cushion-clip'+suffix+')');
      svg.querySelector('image').setAttribute('filter','url(#sc-cushion-tint'+suffix+')');
      svg.style.width = Math.min(100,Math.max(34,width/Math.max(50,state?.first?.width||50,state?.second?.width||0)*100))+'%';
      svg.style.aspectRatio = String(Math.max(1.3,Math.min(8,width/(depth*.52+3))));
      svg.setAttribute('preserveAspectRatio','none');
      svg.querySelector('title').textContent = s.photo_alt;
      tint(svg,color);
      return svg;
    };
    const tint = (svg,color) => {
      if (!color) return;
      ['R','G','B'].forEach((channel,i) => {
        const c=color[i]/255;
        const values=[0,c*.36,c*.88,Math.min(1,c*1.28+.045),Math.min(1,c*1.5+.14)];
        const f=svg.querySelector('feFunc'+channel);
        f.setAttribute('type','table');
        f.setAttribute('tableValues',values.map(n=>n.toFixed(4)).join(' '));
      });
    };
    const formatMeasurement = value => Number.isInteger(value)?String(value):value.toFixed(2);
    const dimensions = size => `${formatMeasurement(size.width)} × ${formatMeasurement(size.depth)} × 3 ${s.inch}`;
    const tierLimit = value => {
      const match=(value||'').match(/Up to\s+(\d+(?:\.\d+)?)/i);
      return match?Number(match[1]):null;
    };
    const applyLimit = (input,limit,message,id) => {
      if(!input)return;
      input.inputMode='decimal';
      input.removeAttribute('maxlength');
      input.setAttribute('step','0.25');
      input.setAttribute('pattern','(?:\\d+(?:\\.(?:00?|25|5(?:0)?|75))?|\\.(?:25|5(?:0)?|75))');
      const option=input.closest('.mw-option');
      const counter=option?.querySelector('[data-mw-text-max-length]');
      if(counter){counter.dataset.mwTextMaxLength='6';counter.textContent='6';counter.closest('.mw-option__helptext')?.remove();}
      option?.querySelector('[data-helptext-type="length_range"]')?.remove();
      let helper=product.querySelector('#'+id);
      if(!helper){helper=document.createElement('p');helper.id=id;helper.className='sc-cushion-field-limit';input.closest('.mw-option')?.append(helper);}
      const described=(input.getAttribute('aria-describedby')||'').split(/\s+/).filter(Boolean).filter(value=>value!==id);
      if(!limit){helper.hidden=true;input.removeAttribute('max');input.setAttribute('aria-describedby',described.join(' '));input.setCustomValidity('');return;}
      input.setAttribute('max',String(limit));
      helper.hidden=false;
      helper.textContent=message.replace('__MAX__',String(limit));
      described.push(id);input.setAttribute('aria-describedby',described.join(' '));
      const raw=input.value.trim();
      const value=measurement(raw);
      if(!raw)input.setCustomValidity('');
      else if(value===null)input.setCustomValidity(s.quarter_error);
      else if(value>limit){input.value=String(limit);input.setCustomValidity('');}
      else if(value>limit)input.setCustomValidity(`Enter a measurement up to ${limit} inches.`);
      else input.setCustomValidity('');
    };
    const syncLimits = () => {
      const countLabel=selectedLabel(select(1989400));
      const count=/^two$/i.test(countLabel)?2:/^one$/i.test(countLabel)?1:0;
      applyLimit(textInput(1989404),tierLimit(selectedLabel(select(count===2?1989402:1989401))),s.width_limit,'sc-barrel-width-limit');
      applyLimit(textInput(1989407),tierLimit(selectedLabel(select(count===2?1989406:1989405))),s.depth_limit,'sc-barrel-depth-limit');
    };
    const inputLimit = input => {
      const rawLimit = input?.getAttribute('max');
      if (rawLimit === null || rawLimit === '') return null;
      const limit = Number(rawLimit);
      return Number.isFinite(limit) ? limit : null;
    };
    const proposedMeasurement = (input, insertedText) => {
      const start = Number.isInteger(input.selectionStart) ? input.selectionStart : input.value.length;
      const end = Number.isInteger(input.selectionEnd) ? input.selectionEnd : start;
      return `${input.value.slice(0,start)}${insertedText}${input.value.slice(end)}`;
    };
    const preventOverLimitInput = event => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'text' || !Number.isFinite(inputLimit(input))) return;
      if (!event.inputType?.startsWith('insert') || typeof event.data !== 'string') return;
      const value = measurement(proposedMeasurement(input,event.data));
      const limit = inputLimit(input);
      if (value !== null && Number.isFinite(limit) && value > limit) event.preventDefault();
    };
    const preventOverLimitPaste = event => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'text' || !Number.isFinite(inputLimit(input))) return;
      const pasted = event.clipboardData?.getData('text');
      if (typeof pasted !== 'string') return;
      const value = measurement(proposedMeasurement(input,pasted));
      const limit = inputLimit(input);
      if (value !== null && Number.isFinite(limit) && value > limit) event.preventDefault();
    };
    const clampOverLimitInput = event => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'text') return;
      const limit = inputLimit(input);
      const value = measurement(input.value.trim());
      if (!Number.isFinite(limit) || value === null || value <= limit) return;
      input.value = String(limit);
      input.setCustomValidity('');
    };
    const read = () => {
      const countSelect=select(1989400);
      const countLabel=selectedLabel(countSelect);
      const count=/^two$/i.test(countLabel)?2:/^one$/i.test(countLabel)?1:0;
      const modelId=({1:1989401,2:1989402})[count];
      const model=selectedLabel(select(modelId));
      const first={width:number(1989404),depth:number(1989407)};
      const secondVisible=false;
      const second=null;
      const radio=colorOption()?.querySelector('input[type="radio"]:checked');
      const img=radio?.parentElement.querySelector('img');
      const swatch=img?.getAttribute('src')||'';
      const hash=swatch.split('/').pop()?.split('?')[0];
      const fabric=radio?.getAttribute('aria-label')?.replace(/\s*\(In Stock\).*$/i,'').trim()||'';
      const color=palette[hash]||null;
      const depthRange=selectedLabel(select(count===2?1989406:1989405));
      const missing=[];
      if(!count)missing.push(label(1989400));
      if(count&&!model)missing.push(s.size_choice);
      if(!first.width||!textInput(1989404)?.checkValidity())missing.push(label(1989404));
      if(!first.depth||!textInput(1989407)?.checkValidity())missing.push(label(1989407));
      if(visible(block(count===2?1989406:1989405))&&!depthRange)missing.push(s.depth_choice);
      if(!fabric)missing.push(s.color);
      const options=[...form.querySelectorAll('.mw-option')].filter(visible).map(el=>{
        const title=el.querySelector('.mw-text--style-strong')?.textContent.trim();
        const control=el.querySelector('select')||el.querySelector('input[type="radio"]:checked')||el.querySelector('input[type="text"]');
        const value=control?.tagName==='SELECT'?selectedLabel(control):control?.type==='radio'?control.getAttribute('aria-label'):control?.value.trim();
        return title&&value?{label:title,value}:null;
      }).filter(Boolean);
      return {count,model,first,second,secondVisible,fabric,color,swatch,missing,options};
    };
    const updateStickyTop = () => {
      const headerBottom = Math.max(0,...['#qab_background','#mobileNavBar'].map(selector => {
        const element = document.querySelector(selector);
        return element && getComputedStyle(element).position === 'fixed' ? element.getBoundingClientRect().bottom : 0;
      }));
      colorPanel.style.setProperty('--sc-cushion-mobile-top',`${Math.max(104,Math.ceil(headerBottom+8))}px`);
    };
    const mount = () => {
      const colors=colorOption(), count=block(1989400), width=block(1989404);
      if(!colors||!count)return false;
      root.hidden=false;
      const summary=form.querySelector('#sc-build-summary');
      if(summary&&finish.nextElementSibling!==summary)summary.before(finish);
      if(countGuide.parentElement!==count){count.append(countGuide);countGuide.hidden=false;}
      if(width&&measureGuide.parentElement!==width){width.append(measureGuide);measureGuide.hidden=false;}
      if(colorNote.parentElement!==colors)colors.append(colorNote);
      if(media.matches){if(colorPanel.parentElement!==colors)colors.prepend(colorPanel);}else if(gallery&&colorPanel.parentElement!==gallery)gallery.append(colorPanel);
      updateStickyTop();
      return true;
    };
    const renderModal = () => {
      modal.querySelector('[data-sc-cushion-set-title]').textContent=state.count+' '+(state.count===1?s.unit_single:s.unit_plural)+' · '+state.fabric;
      const cards=modal.querySelector('[data-sc-cushion-cards]');
      cards.replaceChildren();
      const card=document.createElement('figure');card.className='sc-cushion-card';
      const heading=document.createElement('h3');heading.textContent=state.count===1?s.single:state.count+' '+s.unit_plural;
      const visual=document.createElement('div');visual.className='sc-cushion-card-visual';
      for(let i=0;i<state.count;i++)visual.append(makePhoto(state.color,state.first.width,state.first.depth));
      const caption=document.createElement('figcaption');
      caption.textContent=state.count===1?dimensions(state.first):state.count+' '+s.unit_plural+' · '+dimensions(state.first)+' '+s.same_note;
      card.append(heading,visual,caption);cards.append(card);
      const list=modal.querySelector('[data-sc-cushion-summary]');list.replaceChildren();
      state.options.forEach(option=>{const group=document.createElement('div');const dt=document.createElement('dt');dt.textContent=option.label;const dd=document.createElement('dd');dd.textContent=option.value;group.append(dt,dd);list.append(group);});
    };
    const refresh = () => {
      queued=false;
      if(!mount())return;
      syncLimits();
      state=read();
      const next=JSON.stringify(state);
      if(next===signature)return;
      signature=next;
      if(!colorPhoto){colorPhoto=makePhoto();colorPanel.querySelector('[data-sc-cushion-photo]').append(colorPhoto);}
      if(state.color)tint(colorPhoto,state.color);
      else colorPhoto.querySelectorAll('feComponentTransfer>*').forEach(el=>el.setAttribute('type','identity'));
      colorPanel.querySelector('[data-sc-cushion-color-name]').textContent=state.fabric||s.unselected;
      colorPanel.querySelector('[data-sc-cushion-color-status]').textContent=state.fabric&&!state.color?s.color_unavailable:'';
      const swatch=colorPanel.querySelector('[data-sc-cushion-swatch]');
      swatch.hidden=!state.swatch;if(state.swatch)swatch.src=state.swatch;
      const visual=countGuide.querySelector('[data-sc-cushion-count-visual]');visual.replaceChildren();
      for(let i=0;i<state.count;i++){const mini=makePhoto(state.color);mini.style.width='';mini.style.aspectRatio='';mini.setAttribute('aria-hidden','true');visual.append(mini);}
      countGuide.querySelector('[data-sc-cushion-count-copy]').textContent=state.count?state.count+' '+(state.count===1?s.unit_single:s.unit_plural)+' — '+s.count_help:s.count_help;
      openButton.disabled=state.missing.length>0;
      finish.querySelector('#sc-cushion-status').textContent=state.missing.length?s.missing+' '+[...new Set(state.missing)].filter(Boolean).join(', ')+'.':s.ready;
      if(modal.open){if(state.missing.length)modal.close();else renderModal();}
    };
    const schedule = () => {if(!queued){queued=true;requestAnimationFrame(refresh);}};
    form.addEventListener('beforeinput',preventOverLimitInput,true);
    form.addEventListener('paste',preventOverLimitPaste,true);
    form.addEventListener('input',clampOverLimitInput,true);
    form.addEventListener('change',clampOverLimitInput,true);
    form.addEventListener('blur',clampOverLimitInput,true);
    const isOurs = node => [root,colorPanel,colorNote,finish,countGuide,measureGuide,modal].some(el=>el===node||el.contains(node));
    new MutationObserver(mutations=>{if(mutations.some(m=>!isOurs(m.target)))schedule();}).observe(product,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','disabled','checked']});
    product.addEventListener('input',schedule);product.addEventListener('change',schedule);media.addEventListener('change',schedule);
    form.addEventListener('submit',event=>{
      syncLimits();
      const invalid=[textInput(1989404),textInput(1989407)].some(input=>visible(input)&&!input.checkValidity());
      if(!invalid)return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },true);
    window.addEventListener('resize',updateStickyTop);
    let scrollPending = false;
    window.addEventListener('scroll',()=>{if(!media.matches||scrollPending)return;scrollPending=true;requestAnimationFrame(()=>{scrollPending=false;updateStickyTop();});},{passive:true});
    openButton.addEventListener('click',()=>{state=read();if(state.missing.length){refresh();return;}renderModal();modal.showModal();modal.querySelector('[data-sc-cushion-close]').focus();});
    modal.querySelectorAll('[data-sc-cushion-close]').forEach(button=>button.addEventListener('click',()=>modal.close()));
    modal.addEventListener('click',event=>{if(event.target===modal){const r=modal.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)modal.close();}});
    modal.addEventListener('close',()=>openButton.focus());
    refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-barrel-options"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const store = document.querySelector('[data-sc-barrel-help-store]');
      const form = document.getElementById('addToCartForm-product-template');
      if (!store || !form || store.dataset.initialized) return;
      store.dataset.initialized = 'true';
      const measuring = store.querySelector('[data-sc-barrel-measuring]');
      const snaps = store.querySelector('[data-sc-barrel-snaps]');
      const attach = () => {
        const size = form.querySelector('#o_1989409');
        const snapOption = form.querySelector('#o_1989413');
        if (size && measuring.parentElement !== size) size.append(measuring);
        if (snapOption && snaps.parentElement !== snapOption) snapOption.append(snaps);
        const select = snapOption?.querySelector('select');
        const label = select?.selectedOptions[0]?.textContent || '';
        const extra = /12\s*inches/i.test(label);
        const status = !select?.value ? snaps.dataset.empty : extra ? snaps.dataset.extra : snaps.dataset.standard;
        const current = snaps.querySelector('[data-sc-barrel-spacing]');
        if (current.textContent !== status) current.textContent = status;
        snaps.querySelector('[data-sc-spacing-standard]').toggleAttribute('hidden', extra);
        snaps.querySelector('[data-sc-spacing-extra]').toggleAttribute('hidden', !extra);
      };
      form.addEventListener('change', attach);
      new MutationObserver(attach).observe(form, {childList:true, subtree:true});
      attach();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-barrel-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const preview = document.getElementById('sc-barrel-preview');
    const product = document.getElementById('ProductSection');
    if (!preview || !product || preview.dataset.initialized) return;
    preview.dataset.initialized = 'true';
    const palette = {
      v_17273933: '#cfbba0', v_17273934: '#0e3737', v_17273935: '#161618', v_17273936: '#7e7f8d',
      v_17273937: '#786757', v_17273938: '#0e3f7c', v_17273939: '#0253b6', v_17273940: '#212a39',
      v_17273941: '#601b23', v_17273942: '#f2f1ef', v_17273943: '#0b366d', v_17273944: '#d10520',
      v_17273945: '#b3b4ae', v_17273946: '#eccb9e', v_17273947: '#f4eddd', v_17273948: '#c1c2c4'
    };
    const option = () => product.querySelector('#o_1989421');
    const gallery = product.querySelector('.sc-product-gallery');
    const builder = product.querySelector('#sc-build');
    const mobile = window.matchMedia('(max-width: 768px)');
    const home = document.createElement('span');
    home.hidden = true;
    home.setAttribute('aria-hidden', 'true');
    preview.before(home);
    const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const selected = () => {
      const input = option()?.querySelector('input[type="radio"]:checked');
      if (!input) return null;
      const keys = [input.value, input.id, input.name, input.dataset.value, input.dataset.optionValue];
      const color = keys.map(key => palette[key]).find(Boolean);
      const label = (input.getAttribute('aria-label') || input.labels?.[0]?.textContent || input.closest('label')?.textContent || '').replace(/\s*\(In Stock\).*$/i, '').trim();
      return { name: label || preview.dataset.unselected, color: color || null };
    };
    const updateStickyGeometry = () => {
      if (!mobile.matches || !builder) return;
      const fixedBottom = Math.max(0, ...['#qab_background', '#mobileNavBar'].map(selector => {
        const header = document.querySelector(selector);
        return header && getComputedStyle(header).position === 'fixed' ? header.getBoundingClientRect().bottom : 0;
      }));
      const top = Math.max(110, Math.ceil(fixedBottom + 8));
      builder.style.setProperty('--sc-barrel-sticky-top', `${top}px`);
      builder.style.setProperty('--sc-barrel-preview-height', `${Math.ceil(preview.getBoundingClientRect().height)}px`);
    };
    const place = () => {
      if (preview.closest('#sc-approved-shape-color-group')) return;
      if (mobile.matches) {
        if (!builder) return;
        const intro = builder.querySelector('.sc-build-intro');
        if (intro && preview.previousElementSibling !== intro) intro.after(preview);
        else if (!intro && preview.parentElement !== builder) builder.prepend(preview);
      } else if (home.parentElement) {
        if (home.nextElementSibling !== preview) home.after(preview);
      } else {
        gallery?.append(preview);
      }
    };
    const update = () => {
      const wrapper = option();
      if (!visible(wrapper)) {
        preview.hidden = true;
        return;
      }
      preview.hidden = false;
      place();
      const choice = selected();
      const name = preview.querySelector('[data-sc-barrel-name]');
      const dot = preview.querySelector('[data-sc-barrel-dot]');
      const status = preview.querySelector('[data-sc-barrel-status]');
      const colorizedPhoto = preview.querySelector('.sc-barrel-preview__colorized-photo');
      const colorMatrix = preview.querySelector('.sc-barrel-preview__color-matrix');
      const showColorization = Boolean(choice?.color);
      colorizedPhoto.style.opacity = showColorization ? '1' : '0';
      name.textContent = choice?.name || preview.dataset.unselected;
      dot.style.backgroundColor = choice?.color || '#d1ceca';
      if (choice?.color) {
        const hex = choice.color.slice(1);
        const rgb = [0, 2, 4].map(index => Number.parseInt(hex.slice(index, index + 2), 16) / 255);
        colorMatrix.setAttribute('values', [
          [rgb[0], 0, 0, 0, 0],
          [0, rgb[1], 0, 0, 0],
          [0, 0, rgb[2], 0, 0],
          [0, 0, 0, 1, 0]
        ].flat().join(' '));
        preview.style.setProperty('--sc-barrel-roof', choice.color);
        status.textContent = `${preview.dataset.summaryPrefix} ${choice.name}`;
      } else {
        preview.style.setProperty('--sc-barrel-roof', '#d1ceca');
        status.textContent = choice ? preview.dataset.unavailable : preview.dataset.empty;
      }
      updateStickyGeometry();
    };
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        update();
      });
    };
    product.addEventListener('change', schedule);
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !mutation.target.closest?.('#sc-barrel-preview'))) schedule();
    }).observe(product, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'class', 'disabled', 'aria-checked'] });
    mobile.addEventListener('change', () => { place(); updateStickyGeometry(); schedule(); });
    window.addEventListener('resize', updateStickyGeometry);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-color-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const preview = document.getElementById('sc-color-preview');
    if (!preview || preview.dataset.initialized) return;
    preview.dataset.initialized = 'true';
    const product = document.getElementById('ProductSection');
    const gallery = product?.querySelector('.sc-product-gallery');
    if (!product || !gallery) return;
    const palette = {"3b1ac705241534d7faf7989ab7e3129ef6cd8aebd4be705f9afb579c9b3b2dd2":[183,161,152],"4993f5928d722966a61ed0c77d863bfa16fc6f9c547224f2237aec61c8ca2e5b":[10,9,12],"936246084800b4b853806562458fe8d7e4ad42a359c93f03e5da273853eef778":[138,17,24],"0edcebba2e4158055f58939a6bb922e1375943cb92e20112655ca867f37fcc8c":[9,38,37],"e4caf498dcaa51a9dfb009045ea3c5c495461edc77f994b32f8d411994df6bf4":[30,53,98],"51c1fd35a470d9a42dad9c166b71d0f7e256f8182a91b7d5aba3b8d0753079b8":[82,102,93],"9c51ac1f9052598894d6fa3fe2182ac32d5c0684990954aeec0386e42ab2e80d":[3,49,119],"de226fc33c86ba0c2da0b73ee7398f351586256989dbaf7fa73ae41a6638253b":[18,26,59],"e33078d104b9d548c261d07ad6827f5c18ce7acfae2f99aa494dc65c1e6815cb":[223,214,208],"597267393684189e66c892d703c6446c36d64a45f67de291da2344137939b616":[173,147,140],"c8dc7c7f4fedc740e2c7ad31489a3cf5e73b8d5b845cb0d984276c494dc0fb61":[225,221,223],"893c892fb7b7f1de1e078a41dbf7ad1b59108bb03ae3f9b3a71e189fceb5e9bf":[96,19,25],"50a79498418fc8cfc9853c2fec0a31df4826640b798a733f66363d470653af31":[202,187,184],"0c4d880fd718bc488e34ab240b5b1f7e5341eabb2acadef261c62fdc03d0fb36":[155,130,126],"85e7d8c9bf2207ccda22778a67c78f4deb879c6222d2ad1ab98f528c5ee78cae":[118,92,88],"b2dbdb2e947a4e1b87bb500b80869454fe20ee0f673d4204093242b038c44303":[71,66,74],"1528cd387c1c4792124047580b3a96615392b28ca05e294a08abf028c6614cb5":[101,87,88],"9e449ca37b0aef068e196426216e8b18a7f138b0eca4ad64ff178e314751656a":[26,15,17],"ea547ffe82f5639f5d1faa48f2425bdd696241d210fc0f070a219a483700e012":[151,146,157],"8ba8315a8dbc104f92da48f7119905c01862f27ad920718904dac2507f84f1c6":[64,60,68],"d88972def3b27d60e3930922f94d3e9e344c33ec7d923865753d2504574ee444":[118,110,114],"850a1716cc753a1d7d577f4b234dd0a6b1eaa951f5c0eeea2daa6c1c1da0d32a":[94,74,74],"981605903608fe6799dc304ce14364f93f92194878ba2a01dd0b195e69347b0e":[41,36,40],"004efc15b58256ec7fd9d76861c56d25a92a4648066f37a60f61c619e46f38ac":[14,55,55],"659694e7c4a252d37f02e4ae4da258035fd77bfa581d1ba2c49d17b142338ef1":[207,187,160],"9618484c6575795e4885e8755054cf093c0f0950df53d6dd9ce22e73f95467db":[22,22,24],"9b2fc6c9563b0d4d05e762152ff7e3246c39d89d7bfa7e5ede7993a2c8b32051":[120,103,87],"5377f9d65d69ea31d97b79bbc6e53f9afcf583dbccfb2ffd0fc91474d3e2e060":[126,127,141],"1e3d896bd7ff048ed69a81c1e1d6f5ab22a35df88f013be9e0cf9ea174927b25":[33,42,57],"f056861206fdd288e67203deebcee5708409cf58ae5d7b9dc41acb05c19f679a":[2,83,182],"e8a54a6de54985e762c1ba170e5687dbcc6b6b9d1791b013610c0f339d3ff6bf":[14,63,124],"9ed9dd48be8548cc19f81cd31dc197ff9cd6807566cda227d3b771134e30176b":[209,5,32],"82ad9c9e7f4b64308945a6b026aa35cd0eb993fc9f3e9910fedad843118dfffb":[11,54,109],"ba1c0ec85fa7c24cbab6de001b59c2f3f63867a01fde5dccf536d77bc90a88c6":[242,241,239],"8ebafe82b9ec7eac6de1dfece0abe870d5a5610b934a0e9a281b31059ff3312f":[96,27,35],"5ab3bd80c80e98a2612fc748e6fd98a89a212cb597b0e96e855131a4446ddd19":[179,180,174],"f7e6569fd4e52bab4461069d8d78931a20e7b1d8b6f0dcd1bc0cfca090c1de36":[236,203,158],"d364138b017e0d61ae6d5166c95bab3ea4934676c7a14e5ac2f43a7ce38c4072":[244,237,221],"c6768fe738ed6b27239c0fdba20975c90e9b5f0e0d08bd5d637ab290c8e6b78c":[193,194,196]};
    const mobile = window.matchMedia('(max-width:768px)');
    let signature = '';
    let group;
    let mounted = false;
    let scheduled = false;
    const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const option = labels => {
      const accepted = (Array.isArray(labels) ? labels : [labels]).map(label => label.trim().toLowerCase());
      return [...product.querySelectorAll('.mw-option')].find(element => {
        const label = element.querySelector('.mw-label .mw-text--style-strong')?.textContent.trim().toLowerCase();
        return accepted.includes(label);
      });
    };
    const selected = element => {
      const input = element.querySelector('input[type="radio"]:checked');
      if (!input) return null;
      const label = input.getAttribute('aria-label') || input.labels?.[0]?.textContent.trim() || '';
      const image = input.parentElement.querySelector('img');
      const hash = image?.getAttribute('src')?.split('/').pop()?.split('?')[0];
      return {label:label.replace(/\s*\(In Stock\).*$/i, '').trim(), color:palette[hash]};
    };
    const paint = (part, choice) => {
      preview.dataset[part+'Rgb'] = choice?.color?.join(',') || '';
      const name = preview.querySelector(`[data-sc-${part}-name]`);
      const dot = preview.querySelector(`[data-sc-${part}-dot]`);
      const layer = preview.querySelector(`[data-sc-${part}-layer]`);
      name.textContent = choice?.label || preview.dataset.unselected;
      layer.setAttribute('visibility', choice?.color ? 'visible' : 'hidden');
      if (part === 'side') preview.querySelector('[data-sc-valance-layer]').setAttribute('visibility',choice?.color ? 'visible' : 'hidden');
      dot.style.backgroundColor = choice?.color ? `rgb(${choice.color.join(',')})` : '#d1ceca';
      if (!choice?.color) return;
      ['R','G','B'].forEach((channel,index) => {
        const c = choice.color[index] / 255;
        const values = [0, c*.36, c*.88, Math.min(1,c*1.28+.045), Math.min(1,c*1.5+.14)];
        const f = preview.querySelector(`#sc-color-${part}-filter feFunc${channel}`);
        f.setAttribute('type','table');
        f.setAttribute('tableValues',values.map(n=>n.toFixed(4)).join(' '));
      });
    };
    const updateTop = () => {
      const headerBottom = Math.max(0,...['#qab_background','#mobileNavBar'].map(selector => {
        const element = document.querySelector(selector);
        return element && getComputedStyle(element).position === 'fixed' ? element.getBoundingClientRect().bottom : 0;
      }));
      preview.style.setProperty('--sc-color-mobile-top',`${Math.max(104,Math.ceil(headerBottom+8))}px`);
    };
    const place = () => {
      if (!group) return;
      updateTop();
      const ordering = document.getElementById('sc-custom-ordering-design');
      const mobileHost = ordering && !ordering.hidden ? ordering.querySelector('.sc-order-panel') : group;
      const destination = mobile.matches ? mobileHost : gallery;
      if (preview.parentElement !== destination) {
        if (mobile.matches) destination.prepend(preview);
        else if (ordering && !ordering.hidden) destination.prepend(preview);
        else destination.append(preview);
      } else if (!mobile.matches && ordering && !ordering.hidden && destination.firstElementChild !== preview) {
        destination.prepend(preview);
      }
    };
    const refresh = () => {
      scheduled = false;
      const side = option(['Side Color','Side Material Color']);
      const roof = option('Roof Color');
      if (!visible(side) || !visible(roof)) { preview.hidden = true; return; }
      if (!mounted || !group?.isConnected || !group.contains(side) || !group.contains(roof)) {
        if (side.parentElement !== roof.parentElement) return;
        group = document.createElement('div');
        group.className = 'sc-color-choices';
        side.before(group);
        group.append(side,roof);
        const note = document.createElement('p');
        note.className = 'sc-color-mobile-note';
        note.textContent = preview.querySelector('.sc-color-note').textContent;
        group.append(note);
        mounted = true;
        place();
      }
      preview.hidden = false;
      const choices = {side:selected(side),roof:selected(roof)};
      const next = JSON.stringify(choices);
      if (signature === next) return;
      signature = next;
      paint('side',choices.side);
      paint('roof',choices.roof);
      product.dispatchEvent(new CustomEvent('sc:colors',{detail:choices}));
      const count = Number(Boolean(choices.side)) + Number(Boolean(choices.roof));
      const unknown = Object.values(choices).some(choice=>choice&&!choice.color);
      preview.querySelector('[data-sc-color-status]').textContent = unknown ? preview.dataset.unavailable : count === 2 ? preview.dataset.ready : count === 1 ? preview.dataset.partial : preview.dataset.empty;
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(refresh);
    };
    product.addEventListener('change',schedule);
    new MutationObserver(mutations => {
      if (mutations.some(mutation=>!preview.contains(mutation.target))) schedule();
    }).observe(product,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','class','disabled']});
    mobile.addEventListener('change',place);
    product.addEventListener('sc:ordering-step',place);
    window.addEventListener('resize',updateTop);
    let scrollPending = false;
    window.addEventListener('scroll',() => {
      if (!mobile.matches || scrollPending) return;
      scrollPending = true;
      window.requestAnimationFrame(() => { scrollPending = false; updateTop(); });
    },{passive:true});
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-cover-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const root = document.querySelector('.sc-cover-gallery');
      if (!root || root.dataset.initialized) return;
      root.dataset.initialized = 'true';

      const open = root.querySelector('[data-sc-cover-image-open]');
      const dialog = root.querySelector('#sc-cover-image-dialog');
      const close = root.querySelector('[data-sc-cover-image-close]');
      const gallery = root.closest('.sc-product-gallery');
      const largeImage = root.querySelector('[data-sc-cover-large-image]');
      const caption = root.querySelector('[data-sc-cover-image-caption]');
      if (!open || !dialog || !close || !gallery || !largeImage || !caption) return;

      open.addEventListener('click', () => {
        const selected = gallery.querySelector('.product__image-wrapper:not(.hide) img[data-sc-full-image]');
        if (!selected) return;
        largeImage.src = selected.dataset.scFullImage;
        largeImage.alt = selected.alt;
        caption.textContent = selected.alt;
        dialog.showModal();
        close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => open.focus());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-cover-lead-time"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('sc-cover-lead-time');
  if (!config) return;
  const originalMessage = 'Due to High Demand - CURRENT LEAD TIME IS 14-16 WEEKS for Covers (Updated 2nd Quarter of 2026)';
  const template = config.dataset.messageTemplate;
  let lastMessage = '';
  let queued = false;
  const visible = element => {
    if (!element || !element.isConnected || !element.textContent.trim() || !element.getClientRects().length) return false;
    for (let node = element; node && node.nodeType === 1; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    return true;
  };
  const updateAnnouncement = () => {
    let month = config.dataset.fallbackMonth;
    try {
      month = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        year: 'numeric',
        timeZone: 'America/Los_Angeles'
      }).format(new Date());
    } catch {}
    const message = template.replace('__MONTH__', month);
    for (const id of ['qab_message', 'qab_sr_summary']) {
      const element = document.getElementById(id);
      if (!element) continue;
      const current = element.textContent.trim();
      const datedTemplate = current.replace(/^(?:January|February|March|April|May|June|July|August|September|October|November|December) \d{4}(?=\s|$)/, '__MONTH__');
      if ((current === originalMessage || current === lastMessage || datedTemplate === template) && current !== message) {
        element.textContent = message;
      }
    }
    lastMessage = message;
    const fallback = document.getElementById('sc-native-lead-time');
    if (fallback) {
      if (fallback.textContent !== message) fallback.textContent = message;
      const vendorVisible = visible(document.getElementById('qab_message'));
      if (fallback.hidden !== vendorVisible) fallback.hidden = vendorVisible;
    }
  };
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; updateAnnouncement(); }); }
  };
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class','style','hidden'] });
  updateAnnouncement();
  window.setInterval(updateAnnouncement, 60000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-cushion-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const root = document.getElementById('sc-cushion-root');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const product = root.closest('#ProductSection');
    const form = product?.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const s = JSON.parse(root.querySelector('#sc-cushion-strings').textContent);
    const palette = {"3b1ac705241534d7faf7989ab7e3129ef6cd8aebd4be705f9afb579c9b3b2dd2":[183,161,152],"4993f5928d722966a61ed0c77d863bfa16fc6f9c547224f2237aec61c8ca2e5b":[10,9,12],"936246084800b4b853806562458fe8d7e4ad42a359c93f03e5da273853eef778":[138,17,24],"0edcebba2e4158055f58939a6bb922e1375943cb92e20112655ca867f37fcc8c":[9,38,37],"e4caf498dcaa51a9dfb009045ea3c5c495461edc77f994b32f8d411994df6bf4":[30,53,98],"51c1fd35a470d9a42dad9c166b71d0f7e256f8182a91b7d5aba3b8d0753079b8":[82,102,93],"9c51ac1f9052598894d6fa3fe2182ac32d5c0684990954aeec0386e42ab2e80d":[3,49,119],"de226fc33c86ba0c2da0b73ee7398f351586256989dbaf7fa73ae41a6638253b":[18,26,59],"e33078d104b9d548c261d07ad6827f5c18ce7acfae2f99aa494dc65c1e6815cb":[223,214,208],"597267393684189e66c892d703c6446c36d64a45f67de291da2344137939b616":[173,147,140],"c8dc7c7f4fedc740e2c7ad31489a3cf5e73b8d5b845cb0d984276c494dc0fb61":[225,221,223],"893c892fb7b7f1de1e078a41dbf7ad1b59108bb03ae3f9b3a71e189fceb5e9bf":[96,19,25],"50a79498418fc8cfc9853c2fec0a31df4826640b798a733f66363d470653af31":[202,187,184],"0c4d880fd718bc488e34ab240b5b1f7e5341eabb2acadef261c62fdc03d0fb36":[155,130,126],"85e7d8c9bf2207ccda22778a67c78f4deb879c6222d2ad1ab98f528c5ee78cae":[118,92,88],"b2dbdb2e947a4e1b87bb500b80869454fe20ee0f673d4204093242b038c44303":[71,66,74],"1528cd387c1c4792124047580b3a96615392b28ca05e294a08abf028c6614cb5":[101,87,88],"9e449ca37b0aef068e196426216e8b18a7f138b0eca4ad64ff178e314751656a":[26,15,17],"ea547ffe82f5639f5d1faa48f2425bdd696241d210fc0f070a219a483700e012":[151,146,157],"8ba8315a8dbc104f92da48f7119905c01862f27ad920718904dac2507f84f1c6":[64,60,68],"d88972def3b27d60e3930922f94d3e9e344c33ec7d923865753d2504574ee444":[118,110,114],"850a1716cc753a1d7d577f4b234dd0a6b1eaa951f5c0eeea2daa6c1c1da0d32a":[94,74,74],"981605903608fe6799dc304ce14364f93f92194878ba2a01dd0b195e69347b0e":[41,36,40],"004efc15b58256ec7fd9d76861c56d25a92a4648066f37a60f61c619e46f38ac":[14,55,55],"659694e7c4a252d37f02e4ae4da258035fd77bfa581d1ba2c49d17b142338ef1":[207,187,160],"9618484c6575795e4885e8755054cf093c0f0950df53d6dd9ce22e73f95467db":[22,22,24],"9b2fc6c9563b0d4d05e762152ff7e3246c39d89d7bfa7e5ede7993a2c8b32051":[120,103,87],"5377f9d65d69ea31d97b79bbc6e53f9afcf583dbccfb2ffd0fc91474d3e2e060":[126,127,141],"1e3d896bd7ff048ed69a81c1e1d6f5ab22a35df88f013be9e0cf9ea174927b25":[33,42,57],"f056861206fdd288e67203deebcee5708409cf58ae5d7b9dc41acb05c19f679a":[2,83,182],"e8a54a6de54985e762c1ba170e5687dbcc6b6b9d1791b013610c0f339d3ff6bf":[14,63,124],"9ed9dd48be8548cc19f81cd31dc197ff9cd6807566cda227d3b771134e30176b":[209,5,32],"82ad9c9e7f4b64308945a6b026aa35cd0eb993fc9f3e9910fedad843118dfffb":[11,54,109],"ba1c0ec85fa7c24cbab6de001b59c2f3f63867a01fde5dccf536d77bc90a88c6":[242,241,239],"8ebafe82b9ec7eac6de1dfece0abe870d5a5610b934a0e9a281b31059ff3312f":[96,27,35],"5ab3bd80c80e98a2612fc748e6fd98a89a212cb597b0e96e855131a4446ddd19":[179,180,174],"f7e6569fd4e52bab4461069d8d78931a20e7b1d8b6f0dcd1bc0cfca090c1de36":[236,203,158],"d364138b017e0d61ae6d5166c95bab3ea4934676c7a14e5ac2f43a7ce38c4072":[244,237,221],"c6768fe738ed6b27239c0fdba20975c90e9b5f0e0d08bd5d637ab290c8e6b78c":[193,194,196]};
    const photoTemplate = root.querySelector('#sc-cushion-photo-template');
    const colorPanel = root.querySelector('#sc-cushion-color');
    const gallery = root.closest('.sc-product-gallery');
    const imageModal = root.querySelector('#sc-cushion-image-dialog');
    const imageOpen = gallery?.querySelector('[data-sc-cushion-image-open]');
    if(imageOpen){
      imageOpen.addEventListener('click',()=>{
        const selected=gallery.querySelector('.product__image-wrapper:not(.hide) img[data-sc-full-image]');
        if(!selected)return;
        const large=imageModal.querySelector('[data-sc-cushion-large-image]');
        large.src=selected.dataset.scFullImage;large.alt=selected.alt;
        imageModal.querySelector('[data-sc-cushion-image-caption]').textContent=selected.alt;
        imageModal.showModal();imageModal.querySelector('button').focus();
      });
      imageModal.querySelector('[data-sc-cushion-image-close]').addEventListener('click',()=>imageModal.close());
      imageModal.addEventListener('close',()=>imageOpen.focus());
      imageModal.addEventListener('click',event=>{if(event.target===imageModal){const rect=imageModal.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)imageModal.close();}});
    }
    const colorNote = document.createElement('p');
    colorNote.className = 'sc-cushion-mobile-note';
    colorNote.textContent = s.color_note;
    const finish = root.querySelector('#sc-cushion-finished');
    const countGuide = root.querySelector('#sc-cushion-count');
    const measureGuide = root.querySelector('#sc-cushion-measure');
    const modal = root.querySelector('#sc-cushion-dialog');
    const openButton = finish.querySelector('button');
    const media = matchMedia('(max-width:768px)');
    let serial = 0, signature = '', queued = false, state;
    let colorPhoto;
    const visible = el => el && !el.closest('[hidden]') && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    const block = id => product.querySelector('#o_'+id);
    // Locate the one real native color swatch option, including an APO clone.
    // Never rewrite native IDs, input values or prices.
    const colorOption = () => {
      const matches = [...form.querySelectorAll('.mw-option')].filter(option =>
        option.querySelector('.mw-text--style-strong')?.textContent.replace(/\s+/g,' ').trim() === 'Choose Your Cushion Color');
      return matches.length === 1 && matches[0].querySelector('input[type="radio"]') ? matches[0] : null;
    };

    const select = id => block(id)?.querySelector('select');
    const textInput = id => block(id)?.querySelector('input[type="text"]');
    const selectedLabel = control => control?.value ? control.options[control.selectedIndex]?.textContent.trim().replace(/\s*\(\+[^)]*\)\s*$/,'') || '' : '';
    const label = id => block(id)?.querySelector('.mw-text--style-strong')?.textContent.trim().replace(/\s*\*$/,'') || '';
    const optionLabel = option => option?.querySelector('.mw-text--style-strong, label, legend')?.textContent.trim().replace(/\s*\*$/,'') || '';
    const optionFor = matcher => [...form.querySelectorAll('.mw-option')].find(option => matcher.test(optionLabel(option)));
    const cushionSize = ordinal => {
      const prefix = `Cushion\\s*${ordinal}\\s*(?:Size\\s*)?`;
      const width = optionFor(new RegExp(`^${prefix}Width(?!\\s*Tier)\\b`, 'i'));
      const depth = optionFor(new RegExp(`^${prefix}Depth(?!\\s*Tier)\\b`, 'i'));
      const widthTier = optionFor(new RegExp(`^${prefix}Width\\s*Tier\\b`, 'i'));
      const depthTier = optionFor(new RegExp(`^${prefix}Depth\\s*Tier\\b`, 'i'));
      // The independent-size inputs are present in the MageWorx DOM even while
      // their branch is hidden. Only use them after that branch is active so
      // the original same-size checkout path continues to read its own fields.
      if (!width || !depth || !visible(width) || !visible(depth)) return null;
      const numberFrom = option => {
        const raw = option?.querySelector('input[type="text"]')?.value.trim() || '';
        const value = /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(raw) ? Number(raw) : NaN;
        return Number.isFinite(value) && value > 0 ? value : null;
      };
      return { width: numberFrom(width), depth: numberFrom(depth), widthTier, depthTier, widthLabel: optionLabel(width), depthLabel: optionLabel(depth) };
    };
    const number = id => {
      const raw = textInput(id)?.value.trim() || '';
      const n = /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(raw) ? Number(raw) : NaN;
      return Number.isFinite(n) && n > 0 ? n : null;
    };
    const makePhoto = (color, width=50, depth=20) => {
      const svg = photoTemplate.content.querySelector('svg').cloneNode(true);
      const suffix = '-'+(++serial);
      svg.querySelectorAll('[id]').forEach(el => el.id += suffix);
      svg.querySelector('image').setAttribute('clip-path','url(#sc-cushion-clip'+suffix+')');
      svg.querySelector('image').setAttribute('filter','url(#sc-cushion-tint'+suffix+')');
      svg.style.width = Math.min(100,Math.max(34,width/Math.max(50,state?.first?.width||50,state?.second?.width||0)*100))+'%';
      svg.style.aspectRatio = String(Math.max(1.3,Math.min(8,width/(depth*.52+3))));
      svg.setAttribute('preserveAspectRatio','none');
      svg.querySelector('title').textContent = s.photo_alt;
      tint(svg,color);
      return svg;
    };
    const tint = (svg,color) => {
      if (!color) return;
      ['R','G','B'].forEach((channel,i) => {
        const c=color[i]/255;
        const values=[0,c*.36,c*.88,Math.min(1,c*1.28+.045),Math.min(1,c*1.5+.14)];
        const f=svg.querySelector('feFunc'+channel);
        f.setAttribute('type','table');
        f.setAttribute('tableValues',values.map(n=>n.toFixed(4)).join(' '));
      });
    };
    const dimensions = size => `${size.width} × ${size.depth} × 3 ${s.inch}`;
    const read = () => {
      const countSelect=select(1989108);
      const countMap={v_17271833:1,v_17271834:2,v_17271835:3,v_17271836:4};
      const count=countMap[countSelect?.value]||0;
      const modelId=({1:1989109,2:1989110,3:1989111,4:1989112})[count];
      const model=selectedLabel(select(modelId));
      const configuredFirst=cushionSize(1);
      const configuredSecond=cushionSize(2);
      const individualSizes=Boolean(configuredFirst);
      const first=individualSizes?configuredFirst:{width:number(1989114),depth:number(1989115)};
      const secondVisible=individualSizes?Boolean(configuredSecond):visible(block(1989118))&&visible(block(1989119));
      const second=secondVisible?(individualSizes?configuredSecond:{width:number(1989118),depth:number(1989119)}):null;
      const radio=colorOption()?.querySelector('input[type="radio"]:checked');
      const img=radio?.parentElement.querySelector('img');
      const swatch=img?.getAttribute('src')||'';
      const hash=swatch.split('/').pop()?.split('?')[0];
      const fabric=radio?.getAttribute('aria-label')?.replace(/\s*\(In Stock\).*$/i,'').trim()||'';
      const color=palette[hash]||null;
      const depthRange=selectedLabel(select(1989116));
      const missing=[];
      if(!count)missing.push(label(1989108));
      if(count&&!model&&!individualSizes)missing.push(s.size_choice);
      if(!first.width)missing.push(individualSizes?first.widthLabel:label(1989114));
      if(!first.depth)missing.push(individualSizes?first.depthLabel:label(1989115));
      if(individualSizes&&!selectedLabel(first.widthTier?.querySelector('select')))missing.push(optionLabel(first.widthTier));
      if(individualSizes&&!selectedLabel(first.depthTier?.querySelector('select')))missing.push(optionLabel(first.depthTier));
      if(!individualSizes&&visible(block(1989116))&&!depthRange)missing.push(s.depth_choice);
      if(secondVisible&&!second.width)missing.push(individualSizes?second.widthLabel:label(1989118));
      if(secondVisible&&!second.depth)missing.push(individualSizes?second.depthLabel:label(1989119));
      if(secondVisible&&individualSizes&&!selectedLabel(second.widthTier?.querySelector('select')))missing.push(optionLabel(second.widthTier));
      if(secondVisible&&individualSizes&&!selectedLabel(second.depthTier?.querySelector('select')))missing.push(optionLabel(second.depthTier));
      if(!fabric)missing.push(s.color);
      const options=[...form.querySelectorAll('.mw-option')].filter(visible).map(el=>{
        const title=el.querySelector('.mw-text--style-strong')?.textContent.trim();
        const control=el.querySelector('select')||el.querySelector('input[type="radio"]:checked')||el.querySelector('input[type="text"]');
        const value=control?.tagName==='SELECT'?selectedLabel(control):control?.type==='radio'?control.getAttribute('aria-label'):control?.value.trim();
        return title&&value?{label:title,value}:null;
      }).filter(Boolean);
      return {count,model,first,second,secondVisible,individualSizes,fabric,color,swatch,missing,options};
    };
    const updateStickyTop = () => {
      const headerBottom = Math.max(0,...['#qab_background','#mobileNavBar'].map(selector => {
        const element = document.querySelector(selector);
        return element && getComputedStyle(element).position === 'fixed' ? element.getBoundingClientRect().bottom : 0;
      }));
      colorPanel.style.setProperty('--sc-cushion-mobile-top',`${Math.max(104,Math.ceil(headerBottom+8))}px`);
    };
    const mount = () => {
      const colors=colorOption(), count=block(1989108), width=optionFor(/^Cushion\s*1\s*(?:Size\s*)?Width(?!\s*Tier)\b/i)||block(1989114);
      if(!colors||!count)return false;
      root.hidden=false;
      const summary=form.querySelector('#sc-build-summary');
      if(summary&&finish.nextElementSibling!==summary)summary.before(finish);
      if(countGuide.parentElement!==count){count.append(countGuide);countGuide.hidden=false;}
      if(width&&measureGuide.parentElement!==width){width.append(measureGuide);measureGuide.hidden=false;}
      if(colorNote.parentElement!==colors)colors.append(colorNote);
      if(media.matches){if(colorPanel.parentElement!==colors)colors.prepend(colorPanel);}else if(gallery&&colorPanel.parentElement!==gallery)gallery.append(colorPanel);
      updateStickyTop();
      return true;
    };
    const renderModal = () => {
      modal.querySelector('[data-sc-cushion-set-title]').textContent=state.count+' '+(state.count===1?s.unit_single:s.unit_plural)+' · '+state.fabric;
      const cards=modal.querySelector('[data-sc-cushion-cards]');
      cards.replaceChildren();
      const sizes=[{title:state.second?s.first:s.single,...state.first}];
      if(state.second)sizes.push({title:s.second,...state.second});
      sizes.forEach(size=>{
        const card=document.createElement('figure');card.className='sc-cushion-card';
        const heading=document.createElement('h3');heading.textContent=size.title;
        const caption=document.createElement('figcaption');caption.textContent=dimensions(size);
        card.append(heading,makePhoto(state.color,size.width,size.depth),caption);cards.append(card);
      });
      const list=modal.querySelector('[data-sc-cushion-summary]');list.replaceChildren();
      state.options.forEach(option=>{const group=document.createElement('div');const dt=document.createElement('dt');dt.textContent=option.label;const dd=document.createElement('dd');dd.textContent=option.value;group.append(dt,dd);list.append(group);});
    };
    const refresh = () => {
      queued=false;
      if(!mount())return;
      state=read();
      const next=JSON.stringify(state);
      if(next===signature)return;
      signature=next;
      if(!colorPhoto){colorPhoto=makePhoto();colorPanel.querySelector('[data-sc-cushion-photo]').append(colorPhoto);}
      if(state.color)tint(colorPhoto,state.color);
      else colorPhoto.querySelectorAll('feComponentTransfer>*').forEach(el=>el.setAttribute('type','identity'));
      colorPanel.querySelector('[data-sc-cushion-color-name]').textContent=state.fabric||s.unselected;
      colorPanel.querySelector('[data-sc-cushion-color-status]').textContent=state.fabric&&!state.color?s.color_unavailable:'';
      const swatch=colorPanel.querySelector('[data-sc-cushion-swatch]');
      swatch.hidden=!state.swatch;if(state.swatch)swatch.src=state.swatch;
      const visual=countGuide.querySelector('[data-sc-cushion-count-visual]');visual.replaceChildren();
      for(let i=0;i<state.count;i++){const mini=makePhoto(state.color);mini.style.width='';mini.style.aspectRatio='';mini.setAttribute('aria-hidden','true');visual.append(mini);}
      countGuide.querySelector('[data-sc-cushion-count-copy]').textContent=state.count?state.count+' '+(state.count===1?s.unit_single:s.unit_plural)+' — '+s.count_help:s.count_help;
      openButton.disabled=state.missing.length>0;
      finish.querySelector('#sc-cushion-status').textContent=state.missing.length?s.missing+' '+[...new Set(state.missing)].filter(Boolean).join(', ')+'.':s.ready;
      if(modal.open){if(state.missing.length)modal.close();else renderModal();}
    };
    const schedule = () => {if(!queued){queued=true;requestAnimationFrame(refresh);}};
    const isOurs = node => [root,colorPanel,colorNote,finish,countGuide,measureGuide,modal].some(el=>el===node||el.contains(node));
    new MutationObserver(mutations=>{if(mutations.some(m=>!isOurs(m.target)))schedule();}).observe(product,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','disabled','checked']});
    product.addEventListener('input',schedule);product.addEventListener('change',schedule);media.addEventListener('change',schedule);
    window.addEventListener('resize',updateStickyTop);
    let scrollPending = false;
    window.addEventListener('scroll',()=>{if(!media.matches||scrollPending)return;scrollPending=true;requestAnimationFrame(()=>{scrollPending=false;updateStickyTop();});},{passive:true});
    openButton.addEventListener('click',()=>{state=read();if(state.missing.length){refresh();return;}renderModal();modal.showModal();modal.querySelector('[data-sc-cushion-close]').focus();});
    modal.querySelectorAll('[data-sc-cushion-close]').forEach(button=>button.addEventListener('click',()=>modal.close()));
    modal.addEventListener('click',event=>{if(event.target===modal){const r=modal.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)modal.close();}});
    modal.addEventListener('close',()=>openButton.focus());
    refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-dust-valance-option-photos"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const source = document.getElementById('sc-dust-valance-option-photo-templates');
    const product = document.getElementById('ProductSection');
    const dialog = document.getElementById('sc-dust-valance-photo-dialog');
    const sharedPreview = document.getElementById('sc-shared-color-preview');
    if (!source || !product || !dialog || source.dataset.initialized) return;
    source.dataset.initialized = 'true';

    const normalize = value => String(value || '').replace(/\s+/g, ' ').replace(/[:*]/g, '').trim().toLowerCase();
    const exactChoices = new Map([
      ['standard straight valance (front only)', 'straight-front-only'],
      ['wavy valance (front only)', 'wavy-front-only'],
      ['wavy valance (front & both sides)', 'wavy-front-and-sides'],
      ['standard straight valance (front & both sides)', 'straight-front-and-sides']
    ]);
    const visible = element => Boolean(element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const optionFor = select => select.closest('.mw-option') || select.closest('fieldset') || select.parentElement;
    const labelFor = select => normalize(optionFor(select)?.querySelector('.mw-label .mw-text--style-strong, legend, .mw-option-title, .mw-option-label')?.textContent || select.getAttribute('aria-label'));
    const selectedChoice = select => exactChoices.get(normalize(select.selectedOptions?.[0]?.textContent)) || '';
    const genericPanel = option => option?.querySelector(':scope > .sc-shared-option-photos');
    const showGeneric = option => genericPanel(option)?.classList.remove('sc-dust-valance-photo__generic-hidden');
    const hideGeneric = option => genericPanel(option)?.classList.add('sc-dust-valance-photo__generic-hidden');
    const dustColor = () => {
      const raw = product.dataset.scDustCoverRgb || sharedPreview?.dataset.primaryRgb || '';
      const values = raw.split(',').map(Number).filter(Number.isFinite);
      return values.length === 3 ? `rgb(${values.join(',')})` : '';
    };
    const paintTint = panel => panel?.querySelectorAll('[data-sc-dust-valance-tint]').forEach(tint => {
      tint.style.setProperty('--sc-dust-valance-color', dustColor());
    });

    const update = select => {
      if (!visible(select) || labelFor(select) !== 'valance style choice') return;
      const option = optionFor(select);
      if (!option) return;
      let panel = option.querySelector(':scope > .sc-dust-valance-photo');
      if (!panel) {
        const fragment = source.querySelector('template[data-sc-dust-valance-template]')?.content.cloneNode(true);
        panel = fragment?.querySelector('.sc-dust-valance-photo');
        if (!panel) return;
        option.append(fragment);
      }
      const choice = selectedChoice(select);
      panel.dataset.scDustValanceChoice = choice;
      panel.hidden = true;
      panel.querySelectorAll('[data-sc-dust-valance-card]').forEach(card => card.hidden = true);
      paintTint(panel);
      showGeneric(option);
      if (!choice) return;
      const card = panel.querySelector(`[data-sc-dust-valance-card="${choice}"]`);
      const image = card?.querySelector('[data-sc-dust-valance-image]');
      const url = image?.dataset.src;
      if (!card || !image || !url) return;
      const isCurrent = () => panel.dataset.scDustValanceChoice === choice;
      const reveal = () => {
        if (!isCurrent()) return;
        panel.hidden = false;
        card.hidden = false;
        hideGeneric(option);
      };
      image.addEventListener('load', reveal, { once:true });
      image.addEventListener('error', () => { if (isCurrent()) showGeneric(option); }, { once:true });
      if (image.src !== url) image.src = url;
      if (image.complete && image.naturalWidth) reveal();
    };

    const updateAll = () => product.querySelectorAll('select').forEach(update);
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; updateAll(); });
    };
    product.addEventListener('change', event => {
      const select = event.target.closest('select');
      if (select) update(select);
    });
    product.addEventListener('sc:dust-cover-color', () => product.querySelectorAll('.sc-dust-valance-photo').forEach(paintTint));
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !mutation.target.closest?.('.sc-dust-valance-photo'))) schedule();
    }).observe(product, { childList:true, subtree:true, attributes:true, attributeFilter:['class', 'style', 'disabled'] });
    product.addEventListener('click', event => {
      const button = event.target.closest('.sc-dust-valance-photo__open');
      if (!button) return;
      const card = button.closest('.sc-dust-valance-photo__card');
      const image = button.querySelector('img')?.cloneNode(true);
      if (!card || !image) return;
      image.loading = 'eager';
      dialog.querySelector('h2').textContent = card.querySelector('strong')?.textContent || '';
      dialog.querySelector('[data-sc-dust-valance-expanded]').replaceChildren(image);
      dialog.showModal();
    });
    dialog.querySelector('[data-sc-dust-valance-close]').addEventListener('click', () => dialog.close());
    updateAll();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-final-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const panel = document.getElementById('sc-final-preview');
    const product = document.getElementById('ProductSection');
    const summary = document.getElementById('sc-build-summary');
    const dialog = document.getElementById('sc-final-dialog');
    if (!panel || panel.dataset.productHandle !== 'sauna-covers' || !product || !summary || !dialog || panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    summary.before(panel);
    const copy = Object.fromEntries([...panel.querySelectorAll('[data-sc-final-copy]')].map(t=>[t.dataset.scFinalCopy,t.content.textContent.trim()]));
    const button = panel.querySelector('[data-sc-final-open]');
    const stage = dialog.querySelector('[data-sc-final-stage]');
    const status = panel.querySelector('[data-sc-final-status]');
    const visible = el => el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    const ids = ['1988905','1988910','1988911','1988912','1988913','1988902','1988903'];
    const select = id => document.getElementById('o_'+id)?.querySelector('select');
    const selected = id => { const el=document.getElementById('o_'+id); return el?.querySelector('select')?.value || el?.querySelector('input:checked')?.value || ''; };
    const label = id => document.getElementById('o_'+id)?.querySelector('.mw-label .mw-text--style-strong')?.textContent.trim() || '';
    const color = part => {
      const raw = document.getElementById('sc-color-preview')?.dataset[part+'Rgb'];
      const rgb = raw?.split(',').map(Number);
      return rgb?.length===3 && rgb.every(n=>Number.isFinite(n)&&n>=0&&n<=255) ? rgb : null;
    };
    const dimension = id => {
      const option=document.getElementById('o_'+id);
      if (!visible(option)) return null;
      const raw=option.querySelector('input[type="text"]')?.value.trim().replace(/[”″"]/g,'').replace(/\s*(inches|inch|in)\.?$/i,'').trim() || '';
      // Support decimal and common mixed-fraction measurements without guessing other formats.
      const mixed=raw.match(/^(\d+)\s+(\d+)\/(\d+)$/), fraction=raw.match(/^(\d+)\/(\d+)$/);
      const n=mixed ? +mixed[1]+ +mixed[2]/+mixed[3] : fraction ? +fraction[1]/+fraction[2] : /^\d+(\.\d+)?$/.test(raw) ? Number(raw) : NaN;
      return Number.isFinite(n)&&n>0&&n<=300 ? n : null;
    };
    const materialURL=panel.dataset.fabric, saunaURL=panel.dataset.sauna;
    let state, view='front', signature='', pending=false, materialsReady=false, materialLoad;
    const loadMaterials=()=>materialLoad ||= Promise.all([materialURL,saunaURL].map(url=>new Promise((resolve,reject)=>{const picture=new Image();picture.onload=resolve;picture.onerror=reject;picture.src=url;}))).then(()=>{materialsReady=true;}).catch(error=>{materialLoad=null;throw error;});
    const rgb = (c,f=1,light=0)=>`rgb(${c.map(n=>Math.round(Math.min(255,Math.max(0,n*f+light)))).join(',')})`;
    const render = () => {
      if (!state?.ready) { stage.replaceChildren(); return; }
      const cornerActive=window.SCCornerModelPreview?.active()===true;
      const rearButton=dialog.querySelector('[data-sc-final-view="rear"]');if(rearButton)rearButton.hidden=cornerActive;
      if(cornerActive && view==='rear')view='front';
      if(cornerActive && window.SCCornerModelPreview.render(stage,view)){dialog.querySelectorAll('[data-sc-final-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.scFinalView===view)));dialog.querySelector('[data-sc-view-note]').textContent='Illustrative preview.';dialog.querySelector('[data-sc-size-note]').textContent='';dialog.querySelector('[data-sc-snap-note]').textContent=copy[state.snaps==='v_17270461'?'snap_standard':state.snaps==='v_17270462'?'snap_two':'snap_spacing'];return;}
      if(!materialsReady){stage.textContent=copy.loading;return;}
      const {side,roof,valance,door,weather,snaps,peaked}=state;
      const w=state.width || 60, d=state.depth || 50, h=state.height || 80;
      const roofKind=state.roofKind || 'gable';
      const peak=peaked ? (state.peakRise || Math.min(w*.27,h*.3)) : 0;
      const rear=view==='rear', closed=view==='closed';
      const wrap=['v_17270454','v_17270455'].includes(valance);
      const wavy=['v_17270453','v_17270454'].includes(valance);
      const upgrade=door==='v_17270457';
      const hem=Math.min(6,h*.075);
      const doorClearance=Math.min(1.25,Math.max(.65,h*.0125));
      const doorTop=hem+doorClearance;
      const inset=!upgrade&&state.doorMode==='narrow'&&state.openingWidth ? Math.max(0,(w-Math.min(w,state.openingWidth))/2) : upgrade ? Math.min(6,w*.10) : Math.min(2.5,w*.04);
      const p=(x,y,z)=>[4.8*x-3*y,-.6*x-1.5*y-5*z];
      const pt=(x,y,z)=>p(x,y,z).map(n=>n.toFixed(2)).join(' ');
      const poly=points=>'M'+points.map(a=>pt(...a)).join('L')+'Z';
      const front=`matrix(4.8 -.6 0 5 0 ${-5*h})`;
      const left=`matrix(3 1.5 0 5 ${-3*d} ${-1.5*d-5*h})`;
      const path=(d,fill,attrs='')=>`<path d="${d}" fill="${fill}" ${attrs}/>`;
      const fabric=(d,fill,attrs='')=>path(d,fill,attrs)+path(d,'url(#scf-weave)','pointer-events="none"');
      const bounds=[p(0,d,h),p(w,0,0),p(w/2,d,h+peak),p(0,0,0),p(w,0,h+peak)];
      const minX=-3*d-45, minY=Math.min(...bounds.map(a=>a[1]))-38, maxX=4.8*w+40;
      const tint=(id,c,f=1)=>`<filter id="${id}" color-interpolation-filters="sRGB"><feColorMatrix type="saturate" values="0"/><feComponentTransfer>${['R','G','B'].map((channel,i)=>`<feFunc${channel} type="table" tableValues="0 ${(c[i]*f*.55/255).toFixed(4)} ${(c[i]*f/255).toFixed(4)} ${Math.min(1,c[i]*f*1.11/255+.03).toFixed(4)} 1"/>`).join('')}</feComponentTransfer></filter>`;
      const material=(id,filter)=>`<pattern id="${id}" width="1" height="1" patternContentUnits="objectBoundingBox"><image href="${materialURL}" width="1" height="1" preserveAspectRatio="none" filter="url(#${filter})"/><rect width="1" height="1" fill="url(#${id}-light)" opacity=".12"/></pattern>`;
      const defs=`<defs>
        ${tint('scf-side-tint',side,.85)}${tint('scf-front-tint',side)}${tint('scf-roof-tint',roof)}
        ${material('scf-side','scf-side-tint')}${material('scf-front','scf-front-tint')}${material('scf-valance','scf-front-tint')}${material('scf-roof','scf-roof-tint')}

        <pattern id="scf-flap-fabric" width="${w}" height="${h}" patternUnits="userSpaceOnUse"><image href="${materialURL}" width="${w}" height="${h}" preserveAspectRatio="none" filter="url(#scf-front-tint)"/></pattern>
        <linearGradient id="scf-side-light"><stop stop-color="${rgb(side,.73)}"/><stop offset=".38" stop-color="${rgb(side,.90)}"/><stop offset=".7" stop-color="${rgb(side,1.03,5)}"/><stop offset="1" stop-color="${rgb(side,.86)}"/></linearGradient>
        <linearGradient id="scf-front-light"><stop stop-color="${rgb(side,.88)}"/><stop offset=".35" stop-color="${rgb(side,1,7)}"/><stop offset=".85" stop-color="${rgb(side,.97)}"/><stop offset="1" stop-color="${rgb(side,.76)}"/></linearGradient>
        <linearGradient id="scf-valance-light" gradientUnits="userSpaceOnUse" x1="${-3*d}" x2="${4.8*w}"><stop stop-color="${rgb(side,.72)}"/><stop offset="${(3*d/(3*d+4.8*w)).toFixed(3)}" stop-color="${rgb(side,.87)}"/><stop offset=".45" stop-color="${rgb(side,1,8)}"/><stop offset="1" stop-color="${rgb(side,.93)}"/></linearGradient>
        <linearGradient id="scf-roof-light" x2=".8" y2="1"><stop stop-color="${rgb(roof,1,25)}"/><stop offset=".42" stop-color="${rgb(roof,1,8)}"/><stop offset="1" stop-color="${rgb(roof,.74)}"/></linearGradient>
        <linearGradient id="scf-roll" x2="0" y2="1"><stop stop-color="${rgb(side,.65)}"/><stop offset=".4" stop-color="${rgb(side,1,15)}"/><stop offset=".65" stop-color="${rgb(side,.96)}"/><stop offset="1" stop-color="${rgb(side,.58)}"/></linearGradient>
        <linearGradient id="scf-natural"><stop stop-color="#bdb295"/><stop offset=".5" stop-color="#f1e7d0"/><stop offset="1" stop-color="#d6cab0"/></linearGradient>
        <linearGradient id="scf-glass" x2="1" y2="1"><stop stop-color="#182923"/><stop offset=".52" stop-color="#37493e"/><stop offset="1" stop-color="#101d17"/></linearGradient>
        <radialGradient id="scf-metal"><stop stop-color="#dadbd5"/><stop offset=".48" stop-color="#555b59"/><stop offset=".67" stop-color="#eceee7"/><stop offset=".84" stop-color="#858c86"/><stop offset="1" stop-color="#ebede8"/></radialGradient>
        <pattern id="scf-weave" width=".4" height=".4" patternUnits="userSpaceOnUse"><path d="M0 0H.4M0 0V.4" fill="none" stroke="#fff" stroke-opacity=".06" stroke-width=".055"/><path d="M.2 0V.4" fill="none" stroke="#000" stroke-opacity=".04" stroke-width=".055"/></pattern>
        <pattern id="scf-cedar" width="65" height="5.5" patternUnits="userSpaceOnUse"><rect width="65" height="5.5" fill="#b47a40"/><path d="M0 .25H65" stroke="#7b4b28" stroke-width=".25"/><path d="M0 1C18 2 30 .4 65 1.3M0 3.5C20 2.1 45 5 65 3.2" fill="none" stroke="#efc28a" stroke-opacity=".4" stroke-width=".15"/><path d="M0 4.9H65" stroke="#e4ad6b" stroke-width=".2"/></pattern>
        <filter id="scf-shadow" x="-30%" y="-100%" width="160%" height="300%"><feGaussianBlur stdDeviation="9"/></filter>
      </defs>`;
      let drawing=`<ellipse cx="${(4.8*w-3*d)/2}" cy="${-d*.45}" rx="${(4.8*w+3*d)*.5}" ry="35" fill="#3d382c" opacity=".13" filter="url(#scf-shadow)"/>`;
      drawing+=`<g transform="${left}"><rect width="${d}" height="${h}" fill="url(#scf-side)"/><rect width="${d}" height="${h}" fill="url(#scf-weave)"/><path d="M1 1V${h-1}H${d-1}V1" fill="none" stroke="${rgb(side,.60)}" stroke-width=".22"/><path d="M1.5 ${h-2}H${d-1.5}" stroke="${rgb(side,1,30)}" stroke-width=".18" stroke-dasharray=".45 .35"/></g>`;
      drawing+=`<g transform="${front}">`;
      if(!rear&&!closed){
        const dw=Math.min(w*.9,state.actualDoorWidth || w*.39),dx=(w-dw)/2;
        // Keep the photographed door header below the lowest fabric edge.
        // Its top jamb starts 32 pixels down in the 1254-pixel source photo.
        const lowestFabric=Math.max(hem+(wavy?2.5:0),upgrade?0:doorTop+1.3);
        const photoHeader=lowestFabric+doorClearance;
        const photoY=(photoHeader-h*(32/1254))/(1-32/1254);
        const photoHeight=h-photoY;
        const part=(x,width,vx,vw)=>`<svg x="${x}" y="${photoY}" width="${width}" height="${photoHeight}" viewBox="${vx} 0 ${vw} 1254" preserveAspectRatio="none" overflow="hidden"><image href="${saunaURL}" width="1254" height="1254"/></svg>`;
        drawing+=`<rect data-sc-door-header-backing width="${w}" height="${photoY+.1}" fill="url(#scf-cedar)"/>`;
        if(upgrade){
          drawing+=`<image data-sc-single-door-photo="true" href="${saunaURL}" x="0" y="${photoY}" width="${w}" height="${photoHeight}" preserveAspectRatio="none"/>`;
        } else drawing+=part(0,dx,0,385)+part(dx,dw,385,485)+part(dx+dw,w-dx-dw,870,384);
      }
      if (rear || closed) drawing+=`<rect width="${w}" height="${h-1}" fill="url(#scf-front)"/><rect width="${w}" height="${h-1}" fill="url(#scf-weave)"/>`;
      else {
        drawing+=`<path d="M0 0H${w}V${hem}H${w-inset}V${h-1}H${w}V0H${inset}V${h}H0Z" fill="url(#scf-front)"/>`;
        drawing+=`<rect width="${inset}" height="${h}" fill="url(#scf-weave)"/><rect x="${w-inset}" width="${inset}" height="${h-1}" fill="url(#scf-weave)"/>`;
      }
      if(!rear&&!closed) drawing+=`<path d="M${inset+.32} ${doorTop}V${h-1}M${w-inset-.32} ${doorTop}V${h-1}" fill="none" stroke="#181c18" stroke-opacity=".8" stroke-width=".65"/>`;
      if (!rear && !closed) drawing+=`<path data-sc-exposed-zipper d="M${inset} ${doorTop}V${h-1}M${w-inset} ${doorTop}V${h-1}" fill="none" stroke="#c4c6bb" stroke-width=".45" stroke-dasharray=".35 .3"/>`;
      if (!rear && closed) {
        // Both sewn overlaps open toward the door center, covering the zipper teeth.
        const flapWidth=Math.min(1.25,(w-2*inset)*.18),top=doorTop,bottom=h-1.2,length=bottom-top;
        [[inset,1,'left'],[w-inset,-1,'right']].forEach(([zip,direction,edge])=>{
          const x=offset=>zip+direction*offset;
          const edgeLine=offset=>`M${x(offset)} ${top}C${x(offset+.07)} ${top+length*.24} ${x(offset-.08)} ${top+length*.36} ${x(offset)} ${top+length*.52}S${x(offset+.07)} ${top+length*.83} ${x(offset-.03)} ${bottom}`;
          const outline=edgeLine(flapWidth)+`L${x(-.3)} ${bottom}V${top}Z`;
          drawing+=`<g data-sc-zipper-flap="${edge}" data-sc-flap-direction="inward"><path d="${edgeLine(flapWidth+.17)}" fill="none" stroke="#171a16" stroke-opacity=".24" stroke-width=".38"/><path d="${outline}" fill="url(#scf-flap-fabric)"/><path d="${outline}" fill="url(#scf-weave)"/><path d="${outline}" fill="${rgb(side,1,8)}" opacity=".12"/><path d="${edgeLine(flapWidth)}" fill="none" stroke="${rgb(side,.58)}" stroke-opacity=".65" stroke-width=".13"/><path d="${edgeLine(flapWidth-.15)}M${x(-.16)} ${top}V${bottom}" fill="none" stroke="${rgb(side,1,25)}" stroke-opacity=".7" stroke-width=".11" stroke-dasharray=".4 .28"/></g>`;
        });
      }
      if (!rear && !closed && !upgrade) {
        const rollY=doorTop-4.2;
        drawing+=`<rect x="${inset-.5}" y="${rollY}" width="${w-2*inset+1}" height="5.5" rx="2.7" fill="url(#scf-roll)"/>`;
        [inset+(w-2*inset)*.2,w*.50,inset+(w-2*inset)*.8].forEach(x=>{drawing+=`<g data-sc-natural-tie transform="translate(${x} ${doorTop-2.9+(wavy?.8*(1-Math.cos((1-x/w)*Math.PI*2*Math.max(2,Math.round(w/12)))):0)}) scale(.72)" fill="url(#scf-natural)" stroke="#c2b69d" stroke-width=".13"><path d="M-.65 -1H.65V4.8L.25 6.6H-.6L-.85 4.5Z"/><path d="M0 5C-1.8 2.3-4 3.5-3.7 4.7C-3.3 6.1-1.2 6.1 0 5C1.5 2.9 3.6 3.3 3.8 4.5C3.8 6 1.6 6.1 0 5Z"/><path d="M-.1 5.2L-1.7 9.7L-.5 10.1L.5 5.5Z M.3 5.2L2.4 9.4L3.5 8.8L1 5Z"/></g>`;});
      }
      if (!rear && !closed && upgrade) {
        drawing+=`<rect x="${w-inset-2.5}" y="${doorTop+.8}" width="5" height="${h-doorTop-2}" rx="2.1" fill="url(#scf-front)" stroke="${rgb(side,.58)}" stroke-width=".16"/>`;
        [.24,.54,.84].forEach(t=>{drawing+=`<rect x="${w-inset-2.8}" y="${h*t}" width="5.6" height="1.5" rx=".35" fill="${rgb(side,.96,10)}" stroke="${rgb(side,.60)}" stroke-width=".15"/>`;});
      }
      if (rear && weather!=='v_17270458') {
        const wx=weather==='v_17270459' ? w*.79 : w*.21;
        drawing+=`<g data-sc-weather-position="${weather==='v_17270459'?'left-from-front':'right-from-front'}"><path d="M${wx} 12C${wx-2} 15 ${wx+2} 18 ${wx+1} 21" fill="none" stroke="#202627" stroke-width=".7"/><rect x="${wx-4.5}" y="7" width="9" height="6" rx=".6" fill="url(#scf-front)" stroke="${rgb(side,.53)}" stroke-width=".23"/><path d="M${wx-4} 7.6H${wx+4}V12.4H${wx-4}Z" fill="none" stroke="${rgb(side,1,30)}" stroke-width=".14" stroke-dasharray=".3 .25"/></g>`;
      }
      const positions=(length,frontFace)=>{
        const fixedFront=[inset*.48,length-inset*.48];
        // The two front snaps fasten the stationary fabric beside the door.
        if(snaps==='v_17270462')return frontFace&&!rear ? fixedFront : [length*.2,length*.8];
        if(snaps==='v_17270463')return Array.from({length:Math.max(2,Math.ceil(length/18)+1)},(_,i)=>1.5+i*(length-3)/Math.max(1,Math.ceil(length/18)));
        return frontFace&&!rear ? fixedFront : [];
      };
      const studs=(list,y)=>list.map(x=>`<g data-sc-snap-marker transform="translate(${x} ${y})"><circle r=".78" fill="url(#scf-metal)" stroke="#686d66" stroke-width=".12"/><circle r=".36" fill="#5a615b"/><path d="M-.22 0H.22M0 -.22V.22" stroke="#1b231e" stroke-width=".13"/></g>`).join('');
      drawing+=studs(positions(w,true),h-1.6)+'</g>';
      drawing+=`<g transform="${left}">${studs(positions(d,false),h-1.6)}</g>`;
      if (peaked && roofKind==='hip') {
        const apex=[w/2,d/2,h+peak];
        drawing+=fabric(poly([[0,d,h],[w,d,h],apex]),'url(#scf-roof)');
        drawing+=fabric(poly([[0,0,h],[0,d,h],apex]),'url(#scf-roof)');
        drawing+=fabric(poly([[w,0,h],[w,d,h],apex]),'url(#scf-roof)');
        drawing+=fabric(poly([[0,0,h],[w,0,h],apex]),'url(#scf-roof)','stroke="'+rgb(roof,.7)+'" stroke-width=".6"');
      } else if(peaked && roofKind==='sloped') {
        const edge=state.slopeEdge || 'rear';
        const rise=(x,y)=>edge==='front'?(1-y/d)*peak:edge==='left'?(1-x/w)*peak:edge==='right'?x/w*peak:y/d*peak;
        const a=[0,0,h+rise(0,0)],b=[w,0,h+rise(w,0)],c=[w,d,h+rise(w,d)],e=[0,d,h+rise(0,d)];
        drawing+=fabric(poly([[0,0,h],[0,d,h],e,a]),'url(#scf-side)');
        drawing+=fabric(poly([[0,0,h],[w,0,h],b,a]),'url(#scf-front)');
        drawing+=fabric(poly([e,c,b,a]),'url(#scf-roof)','stroke="'+rgb(roof,.7)+'" stroke-width=".6"');
      } else if (peaked) {
        drawing+=fabric(poly([[0,0,h],[w/2,0,h+peak],[w,0,h]]),'url(#scf-front)');
        drawing+=fabric(poly([[0,d,h],[w/2,d,h+peak],[w/2,0,h+peak],[0,0,h]]),'url(#scf-roof)','stroke="'+rgb(roof,.7)+'" stroke-width=".8"');
        drawing+=fabric(poly([[w/2,d,h+peak],[w,d,h],[w,0,h],[w/2,0,h+peak]]),'url(#scf-roof)');
      } else drawing+=fabric(poly([[0,d,h],[w,d,h],[w,0,h],[0,0,h]]),'url(#scf-roof)');
      // A wrapped valance is one closed path. There is deliberately no join at either corner.
      const wave=(length,n,map)=>Array.from({length:n+1},(_,i)=>{
        const t=i/n; return map(length*(1-t),hem+(wavy ? 1.25*(1-Math.cos(t*Math.PI*2*Math.max(2,Math.round(length/12)))) : 0));
      });
      if (!rear) {
        let points=wrap?[[0,d,h],[0,0,h],[w,0,h]]:[[0,0,h],[w,0,h]];
        points=points.concat(wave(w,80,(x,drop)=>[x,0,h-drop]));
        if(wrap) points=points.concat(wave(d,60,(y,drop)=>[0,d-y,h-drop]));
        const outline=poly(points);
        drawing+=fabric(outline,'url(#scf-valance)','data-sc-valance="'+(wrap?'continuous-three-sides':'front-only')+'" stroke="'+rgb(side,.73)+'" stroke-width=".65" stroke-linejoin="round"');
      } else if(wrap) {
        const points=[[0,d,h],[0,0,h],...wave(d,70,(y,drop)=>[0,d-y,h-drop])];
        drawing+=fabric(poly(points),'url(#scf-valance)','stroke="'+rgb(side,.7)+'" stroke-width=".65"');
      }
      stage.innerHTML=`<svg viewBox="${minX} ${minY} ${maxX-minX} ${50-minY}" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="scf-svg-title"><title id="scf-svg-title"></title>${defs}${drawing}</svg>`;
      stage.querySelector('title').textContent=copy.image_title+' — '+copy[view];
      dialog.querySelector('[data-sc-view-note]').textContent=rear ? (weather==='v_17270458'?copy.no_slot:weather==='v_17270459'?copy.left_slot:copy.right_slot) : closed ? (upgrade?copy.closed_upgrade:copy.closed_standard) : !upgrade ? copy.natural : copy.side_roll;
      dialog.querySelector('[data-sc-size-note]').textContent=state.corner ? copy.corner_size : state.width&&state.depth&&state.height ? copy.dimensions_used : copy.sample_size;
      dialog.querySelector('[data-sc-snap-note]').textContent=copy[snaps==='v_17270461'?'snap_standard':snaps==='v_17270462'?'snap_two':'snap_spacing'];
      dialog.querySelectorAll('[data-sc-final-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.scFinalView===view)));
    };
    const refresh = () => {
      pending=false;
      const options=ids.map(id=>selected(id));
      if (!select(ids[0])) return;
      panel.hidden=false;
      const side=color('side'), roof=color('roof');
      const customDoor=document.getElementById('sc-door-width');
      const customRoof=document.getElementById('sc-online-roof');
      const customReady=(!customDoor||customDoor.dataset.complete==='true')&&(!/peaked/i.test(select(ids[0])?.selectedOptions[0]?.textContent||'')||!!document.getElementById('sc-roof-type')?.value||document.getElementById('sc-roof-method')?.value==='manual');
      const ready=options.every(Boolean)&&!!side&&!!roof&&customReady;
      const missing=ids.filter(id=>!selected(id)).map(label);
      state={ready,side,roof,peaked:/peaked/i.test(select(ids[0])?.selectedOptions[0]?.textContent || ''),valance:options[1],door:options[2],weather:options[3],snaps:options[4],width:dimension('1988914'),depth:dimension('1988915'),height:dimension('1988916')};
      state.roofKind=state.peaked?document.getElementById('sc-roof-type')?.value||'gable':'flat';
      state.doorMode=document.getElementById('sc-door-opening')?.selectedOptions[0]?.dataset.mode;
      state.openingWidth=Number(document.getElementById('sc-opening-width')?.value)||null;
      state.actualDoorWidth=state.doorMode==='narrow'?Number(state.openingWidth)-4:null;
      const roofValue=id=>{const field=document.getElementById('sc-measure-'+id);if(!field||field.disabled)return null;const s=field.value.trim(),m=s.match(/^(\d+)\s+(\d+)\/(\d+)$/),f=s.match(/^(\d+)\/(\d+)$/);const n=m?+m[1]+ +m[2]/+m[3]:f?+f[1]/+f[2]:Number(s);return n>0&&Number.isFinite(n)?n:null;};
      state.peakRise=state.roofKind==='gable'?roofValue('G4'):state.roofKind==='sloped'&&roofValue('S3')&&roofValue('S4')?Math.abs(roofValue('S3')-roofValue('S4')):null;
      state.slopeEdge=document.getElementById('sc-slope-edge')?.value||'rear';
      if(state.roofKind==='gable'){state.width=roofValue('G13')||state.width;state.depth=roofValue('G9')||state.depth;state.height=roofValue('G7')||state.height;}
      if(state.roofKind==='hip'){state.width=roofValue('H8')||state.width;state.depth=roofValue('H7')||state.depth;state.height=roofValue('H1')||state.height;}
      if(state.roofKind==='sloped'){state.width=roofValue('S2')||state.width;state.depth=roofValue('S1')||state.depth;state.height=Math.min(roofValue('S3')||80,roofValue('S4')||80);}
      const model=select(state.peaked?'1988907':'1988908');
      state.corner=/corner/i.test(model?.selectedOptions[0]?.textContent || '');
      const rows=[...summary.querySelectorAll('.sc-summary-lines > div')].map(row=>[row.querySelector('dt')?.textContent || '',row.querySelector('dd')?.textContent || '']);
      const total=summary.querySelector('[data-sc-total]')?.textContent || '';
      const next=JSON.stringify({state,rows,total,missing});
      if (next===signature) return;
      signature=next;
      button.disabled=!ready;
      status.textContent=ready?copy.ready:missing.length ? copy.missing+' '+missing.join(', ')+'.':!customReady?copy.custom_missing:copy.color_unknown;
      dialog.querySelector('[data-sc-final-total]').textContent=total;
      const list=dialog.querySelector('[data-sc-final-list]');
      list.replaceChildren(...rows.map(([name,value])=>{const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=name;dd.textContent=value;row.append(dt,dd);return row;}));
      const weatherDetail=dialog.querySelector('[data-sc-final-weather-detail]');
      weatherDetail.hidden=state.weather==='v_17270458';
      if(dialog.open) render();
    };
    const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(refresh);};
    button.addEventListener('click',async()=>{refresh();if(!state?.ready)return;view='front';render();dialog.showModal();if(window.SCCornerModelPreview?.active()&&stage.querySelector('svg[data-model-cover-preview]'))return;try{await loadMaterials();render();}catch(error){if(!stage.querySelector('svg[data-model-cover-preview]'))stage.textContent=copy.image_error;}});
    dialog.querySelector('[data-sc-final-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelectorAll('[data-sc-final-view]').forEach(b=>b.addEventListener('click',()=>{view=b.dataset.scFinalView;render();}));
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();});
    product.addEventListener('input',schedule);
    product.addEventListener('change',schedule);
    product.addEventListener('sc:colors',schedule);
    product.addEventListener('sc:custom-options',schedule);
    new MutationObserver(ms=>{if(ms.some(m=>!panel.contains(m.target)&&!dialog.contains(m.target)))schedule();}).observe(product,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','style','disabled','checked']});
    refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-online-options"] && !Shopify.designMode) return;
  try {
    (() => {
  const start=()=>{
    const product=document.getElementById('ProductSection'),roofPanel=document.getElementById('sc-online-roof'),doorPanel=document.getElementById('sc-door-width');
    if(roofPanel?.dataset.scSharedProductHandle)return;
    if(!product||!roofPanel||!doorPanel||roofPanel.dataset.initialized)return;
    const form=product.querySelector('form[action="/cart/add"]');if(!form)return;
    roofPanel.dataset.initialized='true';
    const copy=Object.fromEntries([...product.querySelectorAll('[data-sc-custom-copy]')].map(t=>[t.dataset.scCustomCopy,t.content.textContent.trim()]));
    const kind=document.getElementById('sc-roof-type'),method=document.getElementById('sc-roof-method'),door=document.getElementById('sc-door-opening'),doorWidth=document.getElementById('sc-front-door-width'),openingWidth=document.getElementById('sc-opening-width');
    const attach=roofPanel.querySelector('[data-sc-attach-roof]'),status=roofPanel.querySelector('[data-sc-attach-status]'),download=roofPanel.querySelector('[data-sc-roof-download]');
    let attachedSignature='',currentFile='',preparedSignature='',busy=false,scheduled=false,downloadURL='',lastSignature='';
    const value=id=>document.getElementById('select_o_'+id)?.value||'';
    const peaked=()=>value('1988905')==='v_17270429';
    const cornerPyramid=()=>kind.value==='corner-pyramid';
    const modelChosen=()=>!!value('1988907');
    const standard=()=>value('1988911')==='v_17270456';
    const mode=()=>door.selectedOptions[0]?.dataset.mode||'';
    const number=raw=>{const s=raw.trim().replace(/[”″"]/g,'').replace(/\s*(inches|inch|in)\.?$/i,'').trim();const m=s.match(/^(\d+)\s+(\d+)\/(\d+)$/),f=s.match(/^(\d+)\/(\d+)$/);const n=m?+m[1]+ +m[2]/+m[3]:f?+f[1]/+f[2]:/^\d+(\.\d+)?$/.test(s)?Number(s):NaN;return Number.isFinite(n)&&n>=0&&n<=600?n:NaN;};
    const clean=n=>String(Math.round(n*10000)/10000);
    const fields=()=>[...roofPanel.querySelectorAll('[data-sc-measure]')].filter(f=>!f.disabled);
    const stamp=()=>JSON.stringify([kind.value,document.getElementById('sc-slope-edge')?.value,fields().map(f=>[f.dataset.scMeasure,f.value.trim()])]);
    const validMeasure=f=>{const n=number(f.value);return Number.isFinite(n)&&(f.dataset.scZero==='true'?n>=0:n>0)&&(!f.dataset.scMeasure.startsWith('C')||Math.abs(n*4-Math.round(n*4))<1e-8);};
    const geometryWarnings=()=>{if(!cornerPyramid())return [];const values=Object.fromEntries(fields().filter(f=>f.dataset.scMeasure.startsWith('C')).map(f=>[f.dataset.scMeasure,number(f.value)])),warnings=[];const finite=(...codes)=>codes.every(code=>Number.isFinite(values[code]));if(finite('C10','C11')&&values.C10!==values.C11)warnings.push('C10 and C11 differ. Confirm the outer roof is square; do not substitute or average either measurement.');if(finite('C6','C4')&&values.C6>values.C4)warnings.push('C6 door frame width is greater than C4 angled door wall width. Confirm both measurements.');if(finite('C8','C3')&&values.C8>values.C3)warnings.push('C8 left window frame width is greater than C3 left window wall width. Confirm both measurements.');if(finite('C9','C5')&&values.C9>values.C5)warnings.push('C9 right window frame width is greater than C5 right window wall width. Confirm both measurements.');if(finite('C20','C1')&&values.C20>=values.C1)warnings.push('C20 roof rise is greater than or equal to C1 overall height. Confirm both vertical measurements.');if(finite('C7','C1','C20')&&values.C7>values.C1-values.C20)warnings.push('C7 door frame height is greater than the roof-edge height implied by C1 minus C20. Confirm all three measurements.');return warnings;};
    const slopeValid=()=>kind.value!=='sloped'||!!document.getElementById('sc-slope-edge')?.value;
    const completed=()=>!!kind.value&&slopeValid()&&fields().every(validMeasure);
    const setDisabled=(el,disabled)=>{if(el.disabled!==disabled)el.disabled=disabled;};
    const refresh=()=>{
      scheduled=false;
      const upload=document.getElementById('o_1988906'),model=document.getElementById('o_1988907'),originalDoor=document.getElementById('o_1988911');
      if(model&&model.nextElementSibling!==roofPanel)model.after(roofPanel);else if(!model&&upload&&roofPanel.nextElementSibling!==upload)upload.before(roofPanel);
      if(originalDoor&&originalDoor.nextElementSibling!==doorPanel)originalDoor.after(doorPanel);
      const currentUpload=currentFile ? [...document.querySelectorAll('#o_1988906 .filepond--item')].find(i=>i.textContent.includes(currentFile)) : null;
      if(currentUpload?.getAttribute('data-filepond-item-state')==='processing-complete'&&preparedSignature)attachedSignature=preparedSignature;
      if(attachedSignature&&!busy&&!currentUpload)attachedSignature='';
      const online=peaked()&&method.value==='online';roofPanel.hidden=!peaked();doorPanel.hidden=!standard();
      roofPanel.querySelector('[data-sc-roof-online]').hidden=!online;setDisabled(kind,!online);kind.required=online;
      roofPanel.querySelectorAll('[data-sc-roof-fields]').forEach(group=>{const enabled=online&&group.dataset.scRoofFields===kind.value&&(!cornerPyramid()||modelChosen());group.hidden=!enabled;group.querySelectorAll('input,select').forEach(f=>{setDisabled(f,!enabled);f.required=enabled;if(!enabled)f.setCustomValidity('');});});
      roofPanel.querySelectorAll('[data-sc-pick-roof]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.scPickRoof===kind.value)));
      const showCorner=online&&cornerPyramid();roofPanel.querySelector('[data-sc-corner-design]').hidden=!showCorner;roofPanel.querySelector('[data-sc-corner-model-notice]').hidden=!(showCorner&&!modelChosen());const warnings=showCorner&&modelChosen()?geometryWarnings():[],warningBox=roofPanel.querySelector('[data-sc-corner-warnings]');warningBox.hidden=!warnings.length;warningBox.replaceChildren(...warnings.map(message=>{const p=document.createElement('p');p.textContent='Fit review: '+message;return p;}));const statusField=roofPanel.querySelector('[data-sc-corner-status]'),flagsField=roofPanel.querySelector('[data-sc-corner-flags]');setDisabled(statusField,!showCorner||!modelChosen());setDisabled(flagsField,!showCorner||!modelChosen()||!warnings.length);statusField.value=showCorner&&modelChosen()?'Measurements received — fit review required':'';flagsField.value=warnings.join(' ');
      setDisabled(door,!standard());door.required=standard();const narrow=standard()&&mode()==='narrow';doorPanel.querySelector('[data-sc-door-measure]').hidden=!narrow;setDisabled(doorWidth,!narrow);setDisabled(openingWidth,!narrow);doorWidth.required=narrow;
      doorWidth.setCustomValidity('');const dw=number(doorWidth.value);const actual=number(document.getElementById('v_17270464')?.value||'');
      const allowed=narrow&&Number.isFinite(dw)&&dw>0&&(!Number.isFinite(actual)||actual<=0||dw+4<=actual);
      if(narrow&&doorWidth.value.trim()&&!allowed)doorWidth.setCustomValidity(Number.isFinite(dw)&&dw>0?copy.width_error:copy.required);
      openingWidth.value=allowed?clean(dw+4):'';doorPanel.querySelector('[data-sc-door-result]').textContent=allowed?`${copy.opening}: ${clean(dw+4)} ${copy.unit_short} (${clean(dw)} + 2 + 2)` : '';
      const examples=doorPanel.querySelector('.sc-door-examples');if(mode())examples.dataset.selected=mode();else delete examples.dataset.selected;examples.querySelectorAll('[data-sc-door-example]').forEach(f=>f.hidden=!!mode()&&f.dataset.scDoorExample!==mode());
      if(!busy&&online){const unchanged=attachedSignature&&attachedSignature===stamp();status.textContent=unchanged?copy.attached:attachedSignature?copy.changed:copy.pending;attach.textContent=attachedSignature?copy.update:copy.attach;}
      roofPanel.dataset.complete=String(!peaked()||method.value==='manual'||(completed()&&(!cornerPyramid()||modelChosen())&&attachedSignature===stamp()));
      doorPanel.dataset.complete=String(!standard()||!!mode()&&(mode()==='full'||allowed));
      const sig=JSON.stringify([peaked(),method.value,kind.value,fields().map(f=>f.value),standard(),mode(),doorWidth.value,openingWidth.value,roofPanel.dataset.complete]);
      if(sig!==lastSignature){lastSignature=sig;product.dispatchEvent(new CustomEvent('sc:custom-options'));}
    };
    const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(refresh);};
    // A small native PDF writer keeps the completed worksheet local until the customer attaches it.
    const pdfEscape=s=>String(s).replace(/[^\x20-\x7e]/g,'-').replace(/([\\()])/g,'\\$1');
    const makePDF=async()=>{
      const active=fields(),pages=[...new Set(active.map(f=>f.dataset.scPage))];
      const objs=[null,'<< /Type /Catalog /Pages 2 0 R >>','', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>'];const pageIds=[];
      const add=o=>{objs.push(o);return objs.length-1;};
      const stream=s=>`<< /Length ${s.length} >>\nstream\n${s}\nendstream`;
      const text=(x,y,size,s)=>`BT /F1 ${size} Tf ${x} ${y} Td (${pdfEscape(s)}) Tj ET\n`;
      const addPage=(content,resources='',pageWidth=960,pageHeight=540)=>{const c=add(stream(content));const id=add(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageWidth} ${pageHeight}] /Resources << /Font << /F1 3 0 R >> ${resources} >> /Contents ${c} 0 R >>`);pageIds.push(id);};
      let summary='0.08 0.18 0.25 rg\n'+text(45,494,22,copy.pdf_title)+text(45,466,14,kind.selectedOptions[0].textContent)+text(45,443,10,copy.pdf_note)+text(45,425,10,'Prepared '+new Date().toISOString().slice(0,10)+(kind.value==='sloped'?' | High edge: '+document.getElementById('sc-slope-edge').selectedOptions[0].textContent:''));
      if(cornerPyramid())summary+=text(45,407,10,'Measurements received - fit review required');
      active.forEach((f,i)=>{const col=i>=10?1:0,row=i%10;summary+=text(45+col*460,cornerPyramid()?369-row*31:389-row*31,11,`${f.dataset.scMeasure}  ${f.dataset.scLabel}: ${f.value.trim()} in`);});
      addPage(summary);
      for(const page of pages){
        const diagram=roofPanel.querySelector(`[data-sc-sheet-page="${page}"]`),img=diagram.querySelector('img');
        if(!img.complete||!img.naturalWidth)await img.decode();const imageWidth=img.naturalWidth,imageHeight=img.naturalHeight,pageWidth=960,pageHeight=pageWidth*imageHeight/imageWidth;const response=await fetch(img.currentSrc||img.src,{credentials:'omit'});if(!response.ok)throw new Error('Diagram unavailable');
        const bytes=new Uint8Array(await response.arrayBuffer());let jpeg='';for(let offset=0;offset<bytes.length;offset+=8192)jpeg+=String.fromCharCode(...bytes.subarray(offset,offset+8192));
        const imageId=add(`<< /Type /XObject /Subtype /Image /Width ${imageWidth} /Height ${imageHeight} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpeg.length} >>\nstream\n${jpeg}\nendstream`);
        let content=`q ${pageWidth} 0 0 ${pageHeight} 0 0 cm /Sheet Do Q\n`;
        active.filter(f=>f.dataset.scPage===page).forEach(f=>{const x=Number(f.dataset.scX)*pageWidth/imageWidth,y=pageHeight-Number(f.dataset.scY)*pageHeight/imageHeight;const label=`${f.dataset.scMeasure}: ${f.value.trim()}`;const width=Math.max(page==='3'?77:49,label.length*5.3+9);content+=`1 1 1 rg ${x-width/2} ${y-7} ${width} 17 re f\n0.05 0.2 0.38 rg\n`+text(x-width/2+4,y-2,9,label);});
        addPage(content,`/XObject << /Sheet ${imageId} 0 R >>`,pageWidth,pageHeight);
      }
      objs[2]=`<< /Type /Pages /Kids [${pageIds.map(id=>id+' 0 R').join(' ')}] /Count ${pageIds.length} >>`;
      let output='%PDF-1.4\n%\xE2\xE3\xCF\xD3\n';const offsets=[0];for(let i=1;i<objs.length;i++){offsets.push(output.length);output+=`${i} 0 obj\n${objs[i]}\nendobj\n`;}
      const xref=output.length;output+=`xref\n0 ${objs.length}\n0000000000 65535 f \n`+offsets.slice(1).map(o=>String(o).padStart(10,'0')+' 00000 n \n').join('')+`trailer\n<< /Size ${objs.length} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`;
      return new Blob([Uint8Array.from(output,c=>c.charCodeAt(0))],{type:'application/pdf'});
    };
    const validateRoof=()=>{if(cornerPyramid()&&!modelChosen()){const model=document.getElementById('select_o_1988907');if(model){model.setCustomValidity('Choose your model size before entering measurements.');model.reportValidity();}else{status.textContent='Choose your model size before attaching measurements.';}return false;}kind.setCustomValidity(kind.value?'':copy.required);const invalid=!kind.value?kind:cornerPyramid()&&!modelChosen()?document.getElementById('select_o_1988907'):!slopeValid()?document.getElementById('sc-slope-edge'):fields().find(f=>!validMeasure(f));if(invalid){invalid.setCustomValidity(invalid.dataset.scMeasure?.startsWith('C')&&invalid.value.trim()?'Enter a positive measurement in quarter-inch increments (.00, .25, .50 or .75).':copy.required);invalid.reportValidity();return false;}return true;};
    attach.addEventListener('click',async()=>{
      refresh();if(busy||!validateRoof())return;busy=true;attach.disabled=true;status.textContent=copy.uploading;const targetStamp=stamp();
      try{
        const blob=await makePDF();if(targetStamp!==stamp())throw new Error('Measurements changed');
        if(downloadURL)URL.revokeObjectURL(downloadURL);downloadURL=URL.createObjectURL(blob);currentFile=`Sauna-roof-${kind.value}-${Date.now()}.pdf`;preparedSignature=targetStamp;download.href=downloadURL;download.download=currentFile;download.hidden=false;
        const input=document.querySelector('#o_1988906 input[type=file]');if(!input)throw new Error('Uploader unavailable');
        const transfer=new DataTransfer();transfer.items.add(new File([blob],currentFile,{type:'application/pdf'}));input.files=transfer.files;
        const uploader=document.getElementById('o_1988906');
        await new Promise((resolve,reject)=>{
          const timeout=setTimeout(()=>finish(new Error('Upload timeout')),60000);
          const observer=new MutationObserver(()=>{const item=[...uploader.querySelectorAll('.filepond--item')].find(i=>i.textContent.includes(currentFile));if(!item)return;const state=item.getAttribute('data-filepond-item-state');if(state==='processing-complete')finish();else if(state?.includes('error'))finish(new Error('Upload failed'));});
          const finish=error=>{clearTimeout(timeout);observer.disconnect();error?reject(error):resolve();};
          observer.observe(uploader,{subtree:true,childList:true,attributes:true,attributeFilter:['data-filepond-item-state']});
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
        attachedSignature=targetStamp;
      }catch(error){status.textContent=copy.failed;}finally{busy=false;attach.disabled=false;const failed=status.textContent===copy.failed;refresh();if(failed)status.textContent=copy.failed;}
    });
    const guard=event=>{
      if(event.type==='click'){const button=event.target.closest?.('button[name=add],input[name=add]');if(!button||!product.contains(button))return;}
      if(event.type==='submit'&&event.target!==form)return;
      refresh();let invalid=null;
      if(standard()){if(!door.value)invalid=door;else if(mode()==='narrow'&&(!openingWidth.value||!doorWidth.checkValidity()))invalid=doorWidth;}
      if(!invalid&&peaked()&&method.value==='online'){
        if(!kind.value)invalid=kind;else if(cornerPyramid()&&!modelChosen())invalid=document.getElementById('select_o_1988907');else if(!slopeValid())invalid=document.getElementById('sc-slope-edge');else invalid=fields().find(f=>!validMeasure(f));
        if(!invalid&&(busy||attachedSignature!==stamp())){event.preventDefault();event.stopImmediatePropagation();status.textContent=copy.upload_required;attach.focus();attach.scrollIntoView({block:'center',behavior:'smooth'});return;}
      }
      if(invalid){event.preventDefault();event.stopImmediatePropagation();if(!invalid.validationMessage)invalid.setCustomValidity(copy.required);invalid.reportValidity();}
    };
    // Check conditional fields before the options app intercepts the cart button.
    window.addEventListener('click',guard,true);window.addEventListener('submit',guard,true);
    product.addEventListener('input',e=>{if(e.target.matches('[data-sc-measure],#sc-front-door-width,#sc-door-opening,#sc-roof-type,#sc-slope-edge,#select_o_1988907'))e.target.setCustomValidity('');schedule();});
    product.addEventListener('change',e=>{if(e.target.matches('#sc-door-opening,#sc-roof-type,#sc-slope-edge,#select_o_1988907'))e.target.setCustomValidity('');schedule();});
    product.addEventListener('FilePond:removefile',()=>{if(attachedSignature&&!document.getElementById('o_1988906')?.textContent.includes(currentFile)){attachedSignature='';schedule();}});
    roofPanel.querySelectorAll('[data-sc-pick-roof]').forEach(b=>b.addEventListener('click',()=>{kind.value=b.dataset.scPickRoof;kind.dispatchEvent(new Event('change',{bubbles:true}));}));
    const diagramDialog=document.getElementById('sc-roof-diagram-dialog');roofPanel.querySelectorAll('[data-sc-expand-page]').forEach(b=>b.addEventListener('click',()=>{diagramDialog.querySelector('[data-sc-large-diagram]').replaceChildren(roofPanel.querySelector(`[data-sc-sheet-page="${b.dataset.scExpandPage}"]`).cloneNode(true));diagramDialog.querySelectorAll('img').forEach(img=>img.loading='eager');diagramDialog.showModal();}));diagramDialog.querySelector('[data-sc-close-diagram]').addEventListener('click',()=>diagramDialog.close());
    new MutationObserver(ms=>{if(ms.some(m=>!roofPanel.contains(m.target)&&!doorPanel.contains(m.target)&&!m.target.closest?.('#sc-build-summary,#sc-final-dialog,#sc-final-preview')))schedule();}).observe(product,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style']});
    refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-option-photos"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const source = document.getElementById('sc-option-photo-templates');
    const product = document.getElementById('ProductSection');
    const dialog = document.getElementById('sc-option-photo-dialog');
    if (!source || !product || !dialog || source.dataset.initialized) return;
    source.dataset.initialized = 'true';
    const templates = [...source.querySelectorAll('[data-sc-option-photos]')];
    const details = new Map([...source.querySelectorAll('[data-sc-option-detail]')].map(t=>[t.dataset.scOptionDetail,t.content.textContent.trim()]));
    const update = (select, panel) => {
      const value = select.value;
      if(value==='v_17270456'&&document.getElementById('sc-door-width')){panel.hidden=true;panel.dataset.value=value;return;}
      if (panel.dataset.value === value) return;
      panel.dataset.value = value;
      panel.querySelectorAll('[data-sc-option-values]').forEach(card => {
        const selected = card.dataset.scOptionValues.split(' ').includes(value);
        card.hidden = !selected;
        card.classList.toggle('is-selected',selected);
      });
      const current = panel.querySelector('.sc-option-photo-current');
      current.textContent = details.get(value) || '';
      current.hidden = !current.textContent;
      const hasImage = Boolean(panel.querySelector('.sc-option-photo-card:not([hidden])'));
      panel.hidden = !value || (!hasImage && !details.has(value));
      panel.querySelector('.sc-option-photo-grid').hidden = !hasImage;
      panel.querySelector('.sc-option-photo-note').hidden = !hasImage;
      panel.querySelector('.sc-option-photo-help').hidden = !hasImage;
    };
    const mount = () => templates.forEach(template => {
      const option = document.getElementById(template.dataset.scOptionPhotos);
      const select = option?.querySelector('select');
      if (!select || !product.contains(option)) return;
      let panel = option.querySelector('.sc-option-photos');
      if (!panel) {
        const fragment = template.content.cloneNode(true);
        panel = fragment.querySelector('.sc-option-photos');
        if (!panel.querySelector('.sc-option-photo-card')) return;
        option.append(fragment);
      }
      update(select,panel);
    });
    product.addEventListener('change',event => {
      const select = event.target.closest('select');
      const panel = select?.closest('.mw-option')?.querySelector('.sc-option-photos');
      if (panel) update(select,panel);
    });
    let pending = false;
    new MutationObserver(mutations => {
      if (pending || !mutations.some(m=>!m.target.closest?.('.sc-option-photos, #sc-option-photo-dialog, #sc-color-preview'))) return;
      pending = true;
      requestAnimationFrame(()=> {pending=false; mount();});
    }).observe(product,{childList:true,subtree:true});
    product.addEventListener('click',event => {
      const button = event.target.closest('.sc-option-photo-open');
      if (!button) return;
      const card = button.closest('.sc-option-photo-card');
      const picture = button.querySelector('img').cloneNode(true);
      picture.loading = 'eager';
      picture.sizes = '90vw';
      dialog.querySelector('h2').textContent = card.querySelector('[data-sc-photo-title]').textContent;
      dialog.querySelector('.sc-option-photo-expanded').replaceChildren(picture);
      dialog.showModal();
    });
    dialog.querySelector('[data-sc-photo-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom) dialog.close();
    });
    mount();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-product-photo-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const panel = document.getElementById('sc-product-photo-preview');
    const product = document.getElementById('ProductSection');
    const sharedPreview = document.getElementById('sc-shared-color-preview');
    const previewAssets = document.getElementById('sc-product-photo-preview-assets');
    if (!panel || !product || panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';

    const text = {
      defaultHeading: panel.dataset.textDefaultHeading,
      defaultStatus: panel.dataset.textDefaultStatus,
      staticPhotoAlt: panel.dataset.textStaticPhotoAlt,
      colorPhotoAlt: panel.dataset.textColorPhotoAlt,
      thermalMaterialHeading: panel.dataset.textThermalMaterialHeading,
      thermalMaterialStatus: panel.dataset.textThermalMaterialStatus,
      standardDoorHeading: panel.dataset.textStandardDoorHeading,
      standardDoorStatus: panel.dataset.textStandardDoorStatus,
      roofHeading: panel.dataset.textRoofHeading,
      roofStatus: panel.dataset.textRoofStatus,
      dustHeading: panel.dataset.textDustHeading,
      dustStatus: panel.dataset.textDustStatus,
      cushionHeading: panel.dataset.textCushionHeading,
      onePersonCushionStatus: panel.dataset.textOnePersonCushionStatus,
      benchCushionStatus: panel.dataset.textBenchCushionStatus,
      pillowHeading: panel.dataset.textPillowHeading,
      lumbarPillowStatus: panel.dataset.textLumbarPillowStatus,
      throwPillowStatus: panel.dataset.textThrowPillowStatus
    };
    // The shared swatch preview initializes independently and can unhide after
    // this verified photo loads. Keep the two previews mutually exclusive while
    // retaining the shared preview as the fallback if this photo cannot load.
    const keepSharedPreviewHidden = () => {
      if (!panel.hidden && sharedPreview && !sharedPreview.hidden) sharedPreview.hidden = true;
    };
    if (sharedPreview && typeof MutationObserver === 'function') {
      new MutationObserver(keepSharedPreviewHidden).observe(sharedPreview, { attributes:true, attributeFilter:['hidden'] });
    }

    const customCushionPhoto = 'https://cdn.shopify.com/s/files/1/2956/5736/files/sc-cushion-preview-neutral-review.webp?v=1789421120';
    const companyCushionConfig = () => ({
      enabled:true, static:true, customCushionModel:true,
      colorSlots:{ primary:['choose your cushion color'] },
      photo:customCushionPhoto, viewBox:'0 285 1536 480', heading:text.cushionHeading,
      status:text.benchCushionStatus, regions:[]
    });
    // Every other enabled entry below uses a reviewed product photo. Color
    // regions contain only fabric; surrounding wood, hardware, glass, and
    // scenery are deliberately left outside the overlay.
    const configurations = {
      'thermal-cover': {
        enabled:true, static:true,
        photo:'https://cdn.shopify.com/s/files/1/2956/5736/products/DSC_0009.png?v=1551417862',
        viewBox:'0 0 2108 2328', regions:[], heading:text.thermalMaterialHeading,
        status:text.thermalMaterialStatus,
        photoStates:[{
          optionLabel:'Door Style Choice', matches:['standard'],
          photo:'https://cdn.shopify.com/s/files/1/2956/5736/products/DSC_0023_6e3a022d-b4a1-4979-a3b4-1a767d14eb9f.png?v=1551417901',
          heading:text.standardDoorHeading,
          status:text.standardDoorStatus
        }]
      },
      'sauna-roof-only-cover': {
        enabled:true, static:true,
        colorSlots:{ primary:['roof color'] },
        photo:previewAssets?.dataset.roofOnlyNoValance,
        viewBox:'0 0 1448 1086', heading:text.roofHeading,
        status:'The selected roof fabric is shown on the actual roof-only cover.',
        // A source-sized alpha mask traces the fabric-to-wood boundary. This
        // deliberately replaces the old SVG polygon, which extended across
        // the wood below the left fabric edge.
        fabricMaskKey:'roofOnlyNoValanceAlpha', regions:[]
      },
      // Dust uses the actual product photo until a valance is selected. Each
      // valance selection supplies its own photographed silhouette and a raster
      // alpha mask, so fabric is never guessed with a loose SVG overlay.
      'dust-cover': {
        enabled:true, static:true,
        photo:panel.dataset.dustCoverPhoto, fabricMaskKey:'dustCoverFabricMask',
        viewBox:'0 0 1448 1086', heading:text.dustHeading,
        status:text.dustStatus,
        colorSlots:{ primary:['sauna dust cover - color','choose your color','color'] },
        regions:[],
        photoStates:[
          { optionLabel:'Valance Style Choice', matches:['standard straight valance (front only)'], photo:panel.dataset.dustCoverStraightFrontOnlyPhoto, fabricMaskKey:'dustCoverStraightFrontOnlyMask', viewBox:'0 0 1254 1254', heading:'Preview your straight front valance color', status:'The selected fabric color is applied only to the photographed cover and straight front valance.' },
          { optionLabel:'Valance Style Choice', matches:['wavy valance (front only)'], photo:panel.dataset.dustCoverWavyFrontOnlyPhoto, fabricMaskKey:'dustCoverWavyFrontOnlyMask', viewBox:'0 0 1254 1254', heading:'Preview your wavy front valance color', status:'The selected fabric color is applied only to the photographed cover and wavy front valance.' },
          { optionLabel:'Valance Style Choice', matches:['wavy valance (front & both sides)'], photo:panel.dataset.dustCoverWavyFrontAndSidesPhoto, fabricMaskKey:'dustCoverWavyFrontAndSidesMask', viewBox:'0 0 1254 1254', heading:'Preview your wavy wraparound valance color', status:'The selected fabric color is applied only to the photographed cover and continuous wavy valance.' },
          { optionLabel:'Valance Style Choice', matches:['standard straight valance (front & both sides)'], photo:panel.dataset.dustCoverStraightFrontAndSidesPhoto, fabricMaskKey:'dustCoverStraightFrontAndSidesMask', viewBox:'0 0 1254 1254', heading:'Preview your straight wraparound valance color', status:'The selected fabric color is applied only to the photographed cover and straight wraparound valance.' }
        ]
      },
      'sauna-floor-mat': {
        enabled:true, static:true,
        photo:'https://cdn.shopify.com/s/files/1/2956/5736/products/DSC_0184.png?v=1536961164',
        viewBox:'0 0 2815 2797', heading:'Preview your floor mat color',
        status:'Your selected fabric color is shown on the actual fitted sauna floor mat.',
        regions:[{ colorSlot:'primary', opacity:.72, path:'M 252 1810 C 665 1775 1170 1758 1650 1765 C 2110 1772 2500 1805 2605 1875 L 2600 2550 C 2510 2675 2220 2722 1760 2750 C 1240 2780 710 2760 320 2705 C 270 2500 250 2180 252 1810 Z' }]
      },
      'one-person-sauna-cushion': {
        enabled:true, static:true,
        photo:'https://cdn.shopify.com/s/files/1/2956/5736/files/one-person-sauna-cushion-two-piece-color-preview-v2.webp?v=1789686361', viewBox:'0 0 1448 1086', heading:text.cushionHeading,
        status:text.onePersonCushionStatus,
        fabricMaskFromPhoto:true, regions:[]
      },
      'sauna-cushion-jacuzzi-saunas-clearlight-saunas': companyCushionConfig(),
      'sauna-cushion-golden-designs': companyCushionConfig(),
      'sauna-cushion-health-mate-saunas': companyCushionConfig(),
      'sauna-cushion-sunlighten': companyCushionConfig(),
      'copy-of-sauna-cushion': {
        enabled:true, static:true,
        photo:'https://cdn.shopify.com/s/files/1/2956/5736/products/cushion3sized_e53f57c6-8086-400f-a5c5-f70d37d91044.png?v=1539385670', viewBox:'0 0 4096 2720', heading:text.cushionHeading,
        status:text.benchCushionStatus,
        alphaMask:true, alphaMaskKey:'alphaMaskBench', regions:[]
      },
      'lumbar-cushions': {
        enabled:true, static:true,
        photo:'https://cdn.shopify.com/s/files/1/2956/5736/files/two-lumbar-pillows-color-preview-v2.webp?v=1789686076', viewBox:'0 0 1536 1024', heading:text.pillowHeading,
        status:text.lumbarPillowStatus,
        fabricMaskFromPhoto:true, regions:[]
      },
      'throw-pillows': {
        enabled:true, static:true,
        photo:'https://cdn.shopify.com/s/files/1/2956/5736/files/two-throw-pillows-square-color-preview-v2.webp?v=1789686069', viewBox:'0 0 1492 1054', heading:text.pillowHeading,
        status:text.throwPillowStatus,
        fabricMaskFromPhoto:true,
        regions:[]
      }
    };
    const config = configurations[panel.dataset.productHandle];
    const readyConfig = value => Boolean(value?.enabled && (value.photo || value.photoStates?.length));
    if (!readyConfig(config)) return;

    const stage = panel.querySelector('[data-sc-product-photo-stage]');
    const status = panel.querySelector('[data-sc-product-photo-status]');
    const normalize = value => String(value || '').replace(/\s+/g, ' ').replace(/[:*]/g, '').trim().toLowerCase();
    // Read the selected MageWorx swatch as a fallback. The shared color
    // illustration can initialize later than this preview (or be unavailable
    // on a product), so no product photo may depend on it for its color data.
    const swatchPalette = {"3b1ac705241534d7faf7989ab7e3129ef6cd8aebd4be705f9afb579c9b3b2dd2":[183,161,152],"4993f5928d722966a61ed0c77d863bfa16fc6f9c547224f2237aec61c8ca2e5b":[10,9,12],"936246084800b4b853806562458fe8d7e4ad42a359c93f03e5da273853eef778":[138,17,24],"0edcebba2e4158055f58939a6bb922e1375943cb92e20112655ca867f37fcc8c":[9,38,37],"e4caf498dcaa51a9dfb009045ea3c5c495461edc77f994b32f8d411994df6bf4":[30,53,98],"51c1fd35a470d9a42dad9c166b71d0f7e256f8182a91b7d5aba3b8d0753079b8":[82,102,93],"9c51ac1f9052598894d6fa3fe2182ac32d5c0684990954aeec0386e42ab2e80d":[3,49,119],"de226fc33c86ba0c2da0b73ee7398f351586256989dbaf7fa73ae41a6638253b":[18,26,59],"e33078d104b9d548c261d07ad6827f5c18ce7acfae2f99aa494dc65c1e6815cb":[223,214,208],"597267393684189e66c892d703c6446c36d64a45f67de291da2344137939b616":[173,147,140],"c8dc7c7f4fedc740e2c7ad31489a3cf5e73b8d5b845cb0d984276c494dc0fb61":[225,221,223],"893c892fb7b7f1de1e078a41dbf7ad1b59108bb03ae3f9b3a71e189fceb5e9bf":[96,19,25],"50a79498418fc8cfc9853c2fec0a31df4826640b798a733f66363d470653af31":[202,187,184],"0c4d880fd718bc488e34ab240b5b1f7e5341eabb2acadef261c62fdc03d0fb36":[155,130,126],"85e7d8c9bf2207ccda22778a67c78f4deb879c6222d2ad1ab98f528c5ee78cae":[118,92,88],"b2dbdb2e947a4e1b87bb500b80869454fe20ee0f673d4204093242b038c44303":[71,66,74],"1528cd387c1c4792124047580b3a96615392b28ca05e294a08abf028c6614cb5":[101,87,88],"9e449ca37b0aef068e196426216e8b18a7f138b0eca4ad64ff178e314751656a":[26,15,17],"ea547ffe82f5639f5d1faa48f2425bdd696241d210fc0f070a219a483700e012":[151,146,157],"8ba8315a8dbc104f92da48f7119905c01862f27ad920718904dac2507f84f1c6":[64,60,68],"d88972def3b27d60e3930922f94d3e9e344c33ec7d923865753d2504574ee444":[118,110,114],"850a1716cc753a1d7d577f4b234dd0a6b1eaa951f5c0eeea2daa6c1c1da0d32a":[94,74,74],"981605903608fe6799dc304ce14364f93f92194878ba2a01dd0b195e69347b0e":[41,36,40],"004efc15b58256ec7fd9d76861c56d25a92a4648066f37a60f61c619e46f38ac":[14,55,55],"659694e7c4a252d37f02e4ae4da258035fd77bfa581d1ba2c49d17b142338ef1":[207,187,160],"9618484c6575795e4885e8755054cf093c0f0950df53d6dd9ce22e73f95467db":[22,22,24],"9b2fc6c9563b0d4d05e762152ff7e3246c39d89d7bfa7e5ede7993a2c8b32051":[120,103,87],"5377f9d65d69ea31d97b79bbc6e53f9afcf583dbccfb2ffd0fc91474d3e2e060":[126,127,141],"1e3d896bd7ff048ed69a81c1e1d6f5ab22a35df88f013be9e0cf9ea174927b25":[33,42,57],"f056861206fdd288e67203deebcee5708409cf58ae5d7b9dc41acb05c19f679a":[2,83,182],"e8a54a6de54985e762c1ba170e5687dbcc6b6b9d1791b013610c0f339d3ff6bf":[14,63,124],"9ed9dd48be8548cc19f81cd31dc197ff9cd6807566cda227d3b771134e30176b":[209,5,32],"82ad9c9e7f4b64308945a6b026aa35cd0eb993fc9f3e9910fedad843118dfffb":[11,54,109],"ba1c0ec85fa7c24cbab6de001b59c2f3f63867a01fde5dccf536d77bc90a88c6":[242,241,239],"8ebafe82b9ec7eac6de1dfece0abe870d5a5610b934a0e9a281b31059ff3312f":[96,27,35],"5ab3bd80c80e98a2612fc748e6fd98a89a212cb597b0e96e855131a4446ddd19":[179,180,174],"f7e6569fd4e52bab4461069d8d78931a20e7b1d8b6f0dcd1bc0cfca090c1de36":[236,203,158],"d364138b017e0d61ae6d5166c95bab3ea4934676c7a14e5ac2f43a7ce38c4072":[244,237,221],"c6768fe738ed6b27239c0fdba20975c90e9b5f0e0d08bd5d637ab290c8e6b78c":[193,194,196],"0e21262c21292643089f361d7c417b956f8802fb44312885d384ebbef6f2549d":[174,150,126],"10f030f43707ed7342fa1317dd3aaa0291c0df0bcd81cc731fa96c40a26697b7":[42,60,60],"12e32fd8f90ee4ec6c71a1ce862f8207fb507cb0e1cbaace1c3f70ec4c5d6208":[68,69,74],"17b61f2712a15fb9b55109fad454717bd66e757070ec456b7850a266a471b048":[82,62,73],"20517c8788457412e0e85fc49df82771ee70edd92cb249ad57d2431612687c64":[163,21,43],"52b1174b43d1f9d0ee359f872a7c64789a2faf041cc6a5eda8fe6a8deab7ef5d":[124,98,85],"6549565f28645a58d6ed23da8136ee933691c07bef08e80d05d944bc66535966":[24,48,52],"6898223bcb85eddbbb4f8c57dcc0dc1757d99f294a8018e0d4a50d4dc17550f5":[155,145,120],"6d95da5a8fd3fc068b04087a304aa651caa074c5d94ee1dbd06efd47aa046291":[23,45,32],"8ccb1a9c34383f430ef22039e41ccfa4678406e9adee70c910d168b0d32635cf":[124,143,160],"8dee53e2bae6de5ce5c0775f8209ce6a8ae13701038d21b2fba353318c0df77a":[224,12,24],"958bd5da901f1eaf05c9bc547c7be0ffc786ed30d358cc32c19734dacdbcc5e5":[26,26,28],"9aa5cb31a8c2f41f61947813741bdae9f312cf74618836c8498bf78a51451a5c":[32,38,64],"a5b8b8e949c96dd7db25c561ac6b118f37e0d6f82cf9828fa91d2a9004473a83":[26,61,161],"b4e950919593e6feb85201f7248655a17ba86a9b3896a07f68ba454ea7347fbb":[25,37,59],"b6082725abf83f951f3420b29f0a7e3c66bfff67a50e180af5d5666501ede9b0":[88,78,89],"f24e3b1e3265c0ebcb5fc5b104c9d6072efb6ccbb6640412489cde837c643de1":[4,76,152]};
    const directSwatchHandles = new Set(['one-person-sauna-cushion', 'throw-pillows', 'lumbar-cushions', 'sauna-cushion-health-mate-saunas', 'sauna-cushion-sunlighten', 'sauna-cushion-jacuzzi-saunas-clearlight-saunas']);
    const directSwatchColorFor = labels => {
      const normalizedLabels = (labels || []).map(normalize);
      const option = [...product.querySelectorAll('.mw-option')].find(element => {
        const optionLabel = normalize(element.querySelector('.mw-label .mw-text--style-strong, legend, .mw-option-title, .mw-option-label')?.textContent);
        return normalizedLabels.length ? normalizedLabels.includes(optionLabel) : /^(?:choose your )?(?:pillow|cushion|fabric )?color$/.test(optionLabel);
      });
      const input = option?.querySelector('input[type="radio"]:checked');
      if (!input) return null;
      // The Dust Black swatch photograph has a cool lighting cast. Keep the
      // product's named black neutral so it cannot be confused with Navy.
      if (panel.dataset.productHandle === 'dust-cover' && /^black\b/i.test(input.getAttribute('aria-label') || '')) return [26,26,28];
      const label = input.closest?.('label') || (input.id ? product.querySelector(`label[for="${input.id}"]`) : null);
      const source = label?.querySelector('img')?.getAttribute('src') || input.parentElement?.querySelector('img')?.getAttribute('src') || '';
      const hash = source.match(/([a-f0-9]{64})(?:\.[a-z0-9]+)?(?:\?|$)/i)?.[1]?.toLowerCase();
      if (hash && swatchPalette[hash]) return swatchPalette[hash];
      const raw = input.dataset.color || input.dataset.rgb || label?.dataset.color || '';
      const values = raw.match(/(?:rgb\()?\s*(\d{1,3})\s*[, ]\s*(\d{1,3})\s*[, ]\s*(\d{1,3})\s*\)?/i);
      return values ? values.slice(1).map(Number) : null;
    };
    const directSwatchColor = () => directSwatchColorFor();
    const visible = element => Boolean(element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const selectedText = label => {
      const labels = (Array.isArray(label) ? label : [label]).map(normalize);
      const heading = element => normalize(element.querySelector('.mw-label .mw-text--style-strong, .mw-text--style-strong, legend, .mw-option-title, .mw-option-label')?.textContent).replace(/^[*\s]+|[*:\s]+$/g,'');
      const option = [...product.querySelectorAll('.mw-option')].find(element => labels.includes(heading(element)));
      // Roof Only's Valance is an optional checkbox alongside a hidden source
      // select. Prefer the actual checked add-on so its selected label drives
      // the paired valance photo rather than the stale "No add-on" select.
      const control = option?.querySelector('input:checked') || option?.querySelector('select');
      if (!control || !visible(option)) return '';
      return normalize(control.selectedOptions?.[0]?.textContent || control.getAttribute?.('aria-label') || control.closest?.('label')?.textContent || '');
    };
    const colors = () => {
      const parse = value => String(value || '').split(',').map(Number).filter(Number.isFinite);
      const selected = directSwatchColor();
      const primary = selected || parse(sharedPreview?.dataset.primaryRgb);
      const hasDirectSlots = Boolean(config.colorSlots);
      const primarySwatch = hasDirectSlots ? directSwatchColorFor(config.colorSlots.primary) : selected;
      const secondarySwatch = hasDirectSlots ? directSwatchColorFor(config.colorSlots.secondary) : null;
      const secondary = secondarySwatch || parse(sharedPreview?.dataset.secondaryRgb);
      const resolvedPrimary = primarySwatch || primary;
      return { primary: resolvedPrimary.length === 3 ? resolvedPrimary : null, secondary: secondary.length === 3 ? secondary : null };
    };
    const rgb = color => `rgb(${color.join(',')})`;
    const customCushionModel = (photo, color, title, serial) => {
      const namespace = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(namespace, 'svg');
      svg.setAttribute('class', 'sc-product-photo-cushion-model');
      svg.setAttribute('viewBox', '0 285 1536 480');
      svg.setAttribute('role', 'img');
      const imageTitle = document.createElementNS(namespace, 'title');
      imageTitle.textContent = title;
      const defs = document.createElementNS(namespace, 'defs');
      const clip = document.createElementNS(namespace, 'clipPath');
      const clipId = `sc-product-photo-cushion-clip-${serial}`;
      clip.setAttribute('id', clipId);
      const clipPath = document.createElementNS(namespace, 'path');
      clipPath.setAttribute('d', 'M22 619L107 355Q116 327 151 327H1375Q1417 327 1430 354L1515 619V653Q1513 706 1478 707H65Q24 705 22 663Z');
      clip.append(clipPath);
      const filter = document.createElementNS(namespace, 'filter');
      const filterId = `sc-product-photo-cushion-tint-${serial}`;
      filter.setAttribute('id', filterId);
      filter.setAttribute('color-interpolation-filters', 'sRGB');
      const matrix = document.createElementNS(namespace, 'feColorMatrix');
      matrix.setAttribute('type', 'saturate');
      matrix.setAttribute('values', '0');
      const transfer = document.createElementNS(namespace, 'feComponentTransfer');
      ['R', 'G', 'B'].forEach((channel, index) => {
        const func = document.createElementNS(namespace, `feFunc${channel}`);
        func.setAttribute('type', 'identity');
        if (color) {
          const value = color[index] / 255;
          const values = [0, value * .36, value * .88, Math.min(1, value * 1.28 + .045), Math.min(1, value * 1.5 + .14)];
          func.setAttribute('type', 'table');
          func.setAttribute('tableValues', values.map(number => number.toFixed(4)).join(' '));
        }
        transfer.append(func);
      });
      filter.append(matrix, transfer);
      defs.append(clip, filter);
      const image = document.createElementNS(namespace, 'image');
      image.setAttribute('href', photo);
      image.setAttribute('x', '0');
      image.setAttribute('y', '0');
      image.setAttribute('width', '1536');
      image.setAttribute('height', '1024');
      image.setAttribute('clip-path', `url(#${clipId})`);
      image.setAttribute('filter', `url(#${filterId})`);
      svg.append(imageTitle, defs, image);
      return svg;
    };
    const photoState = () => (config.photoStates || []).find(state => {
      const value = selectedText(state.optionLabel);
      return state.matches?.some(match => value.includes(normalize(match)));
    }) || null;
    const valanceState = () => {
      const value = selectedText(config.valance?.optionLabel);
      return (config.valance?.regionsBySelection || []).find(rule => rule.matches?.some(match => value.includes(normalize(match))) ) || null;
    };
    const valanceBaseState = () => {
      const value = selectedText(config.valance?.optionLabel);
      return (config.valance?.baseStates || []).find(rule => rule.matches?.some(match => value.includes(normalize(match))) ) || null;
    };
    let buildToken = 0;
    const build = () => {
      const token = ++buildToken;
      const { primary, secondary } = colors();
      if (panel.dataset.productHandle === 'dust-cover') {
        // Make the resolved value available to the Dust valance option-photo
        // runtime even when MageWorx has not initialized the shared preview.
        product.dataset.scDustCoverRgb = primary ? primary.join(',') : '';
        if (typeof CustomEvent === 'function') product.dispatchEvent(new CustomEvent('sc:dust-cover-color', { detail:{ primary } }));
      }
      const selectedState = photoState() || valanceBaseState();
      if (config.hideWithoutState && !selectedState) {
        panel.hidden = true;
        return;
      }
      const current = selectedState || config;
      const photo = current.photo || config.photo;
      const viewBox = current.viewBox || config.viewBox;
      const fabricMaskKey = current.fabricMaskKey || config.fabricMaskKey;
      // Product-specific photo states can store their masks next to their
      // source images. Dust retains its panel data attributes; Roof Only uses
      // the preview-assets element so the source photo and mask resolve as a
      // single state pair.
      const fabricMask = (current.fabricMaskFromPhoto || config.fabricMaskFromPhoto)
        ? photo
        : (fabricMaskKey ? (previewAssets?.dataset[fabricMaskKey] || panel.dataset[fabricMaskKey] || '') : '');
      const title = current.heading || config.heading || text.defaultHeading;
      const message = current.status || config.status || text.defaultStatus;
      if (!photo || !viewBox) { panel.hidden = true; return; }
      if (!config.static && !primary) { panel.hidden = true; return; }
      if (config.customCushionModel) {
        // This is the same clipped, transparent Custom Sauna Cushion model.
        // It is visible immediately in its neutral finish, then the current
        // company page's swatch recolors only the cushion fabric.
        stage.replaceChildren(customCushionModel(photo, primary, title, token));
        panel.hidden = false;
        keepSharedPreviewHidden();
        panel.querySelector('[data-sc-product-photo-heading]').textContent = title;
        status.textContent = message;
        return;
      }
      // A base photo may represent only one valance silhouette. When a future
      // configuration marks that distinction as required, leave the existing
      // preview in place for every unmatched selection instead of showing the
      // wrong outline.
      if (config.valance?.requireSelectionMatch && !valanceState()) {
        panel.hidden = true;
        return;
      }
      const regions = [...(current.regions || config.regions || []), ...(valanceState()?.regions || [])];
      if (!config.static && !regions.length && !config.alphaMask) {
        panel.hidden = true;
        return;
      }
      const image = document.createElement('img');
      image.alt = config.static ? text.staticPhotoAlt : text.colorPhotoAlt;
      image.addEventListener('load', () => {
        if (token !== buildToken || stage.querySelector('img') !== image) return;
        // The generic swatch illustration remains visible unless the verified
        // product photo is available, preventing an empty or inaccurate preview.
        panel.hidden = false;
        keepSharedPreviewHidden();
      }, { once:true });
      image.addEventListener('error', () => { if (token === buildToken) panel.hidden = true; }, { once:true });
      const namespace = 'http://www.w3.org/2000/svg';
      const overlay = document.createElementNS(namespace, 'svg');
      overlay.setAttribute('viewBox', viewBox);
      overlay.setAttribute('preserveAspectRatio', 'none');
      // Dust's photo is recolored by filtering a second copy of the exact
      // pixels, then clipping it with a hand-traced raster alpha mask. This
      // retains fabric weave, folds, and highlights at both light and dark
      // swatches while leaving every pixel outside the fabric untouched.
      if (primary && fabricMask) {
        const [,, width, height] = viewBox.split(' ').map(Number);
        const defs = document.createElementNS(namespace, 'defs');
        const filter = document.createElementNS(namespace, 'filter');
        const filterId = `sc-product-photo-fabric-tint-${token}`;
        filter.setAttribute('id', filterId);
        filter.setAttribute('color-interpolation-filters', 'sRGB');
        const isDustCover = panel.dataset.productHandle === 'dust-cover';
        const isRoofOnlyCover = panel.dataset.productHandle === 'sauna-roof-only-cover';
        const isSoftGoods = new Set(['one-person-sauna-cushion','lumbar-cushions','throw-pillows']).has(panel.dataset.productHandle);
        const grayscale = document.createElementNS(namespace, 'feColorMatrix');
        grayscale.setAttribute('type', 'saturate');
        grayscale.setAttribute('values', '0');
        const lift = document.createElementNS(namespace, 'feComponentTransfer');
        ['R','G','B'].forEach(channel => {
          const func = document.createElementNS(namespace, `feFunc${channel}`);
          func.setAttribute('type', 'table');
          // Lift the very dark source fabric before colorizing it. Without
          // this, a white swatch on a black reference photo stays charcoal.
          const liftLevels = isSoftGoods
            ? Array.from({ length:65 }, (_, index) => Math.pow(index/64, .35).toFixed(4)).join(' ')
            : ((isDustCover || isRoofOnlyCover) ? '0 1' : '0 .65 .85 .95 1');
          func.setAttribute('tableValues', liftLevels);
          lift.append(func);
        });
        const transfer = document.createElementNS(namespace, 'feComponentTransfer');
        primary.forEach((channel, index) => {
          const func = document.createElementNS(namespace, `feFunc${['R','G','B'][index]}`);
          const value = channel / 255;
          // Keep a small neutral exposure floor so near-black swatches retain
          // the original seams, weave, and folds instead of becoming a flat
          // silhouette. Higher-valued swatches still follow their exact RGB.
          // Dust references are black fabric. Normalize that photographed
          // shading before applying the swatch, so white reads as white and
          // black retains its dark material color without a gray exposure floor.
          const levels = isDustCover
            ? Array.from({ length:33 }, (_, index) => Math.min(1, value * Math.pow(index / 32 / (selectedState ? .25 : .40), .30)))
            // Preserve the roof photo's shadows and seams without clipping
            // pale swatches to flat white. A small neutral highlight keeps
            // dark fabrics dimensional rather than a solid silhouette.
            : isRoofOnlyCover
              ? Array.from({ length:65 }, (_, index) => {
                  const luminance=index/64, mid=.68;
                  return luminance<=mid
                    ? value*Math.pow(luminance/mid,.8)
                    : value+(1-value)*(luminance-mid)/(1-mid)*.18;
                })
            // The source cushions and pillows are dark. Rebuild their fabric
            // luminance through the exact alpha mask so pale swatches can become
            // pale while seams, wrinkles, piping, and photographed texture remain.
            : isSoftGoods
              ? Array.from({ length:65 }, (_, index) => {
                  const luminance=index/64;
                  return Math.min(1, .018 + value*(.32 + .68*Math.pow(luminance,.8)) + (1-value)*luminance*.045);
                })
            : [.025 + value * .08, .065 + value * .16, .16 + value * .35, Math.min(1, .32 + value * .65), Math.min(1, .55 + value * .95)];
          func.setAttribute('type', 'table');
          func.setAttribute('tableValues', levels.map(level => level.toFixed(4)).join(' '));
          transfer.append(func);
        });
        const mask = document.createElementNS(namespace, 'mask');
        const maskId = `sc-product-photo-fabric-alpha-${token}`;
        mask.setAttribute('id', maskId);
        mask.setAttribute('maskUnits', 'userSpaceOnUse');
        // The cushion/lumbar masks are deliberately black-and-white images
        // with opaque pixels throughout. Read their luminance so black excludes
        // the sauna photo and white includes only fabric. Other products use
        // true transparent alpha masks.
        const usesBlackWhiteMask = isSoftGoods && !(current.fabricMaskFromPhoto || config.fabricMaskFromPhoto);
        mask.setAttribute('mask-type', usesBlackWhiteMask ? 'luminance' : 'alpha');
        const maskImage = document.createElementNS(namespace, 'image');
        maskImage.setAttribute('href', fabricMask);
        maskImage.setAttribute('x', '0');
        maskImage.setAttribute('y', '0');
        maskImage.setAttribute('width', String(width));
        maskImage.setAttribute('height', String(height));
        maskImage.setAttribute('preserveAspectRatio', 'none');
        mask.append(maskImage);
        filter.append(grayscale, lift, transfer);
        defs.append(filter, mask);
        const tint = document.createElementNS(namespace, 'image');
        tint.setAttribute('href', photo);
        tint.setAttribute('x', '0');
        tint.setAttribute('y', '0');
        tint.setAttribute('width', String(width));
        tint.setAttribute('height', String(height));
        tint.setAttribute('preserveAspectRatio', 'none');
        tint.setAttribute('filter', `url(#${filterId})`);
        tint.setAttribute('mask', `url(#${maskId})`);
        overlay.append(defs, tint);
      }
      regions.forEach((region, index) => {
        const color = region.colorSlot === 'secondary' ? secondary : primary;
        if (!color || !region.path) return;
        const path = document.createElementNS(namespace, 'path');
        path.setAttribute('d', region.path);
        if (region.part) path.setAttribute('data-sc-preview-part', region.part);
        path.setAttribute('fill', rgb(color));
        path.setAttribute('fill-opacity', String(region.opacity ?? .72));
        if (region.fillRule) path.setAttribute('fill-rule', region.fillRule);
        if (region.intersectSourceAlpha) {
          const maskId = `sc-product-photo-source-alpha-${index}`;
          const mask = document.createElementNS(namespace, 'mask');
          const maskImage = document.createElementNS(namespace, 'image');
          mask.setAttribute('id', maskId);
          mask.setAttribute('maskUnits', 'userSpaceOnUse');
          mask.setAttribute('mask-type', 'alpha');
          maskImage.setAttribute('href', photo);
          maskImage.setAttribute('width', viewBox.split(' ')[2]);
          maskImage.setAttribute('height', viewBox.split(' ')[3]);
          maskImage.setAttribute('preserveAspectRatio', 'none');
          mask.append(maskImage);
          overlay.append(mask);
          path.setAttribute('mask', `url(#${maskId})`);
        }
        path.style.mixBlendMode = region.blendMode || 'color';
        overlay.append(path);
      });
      const children = [image, overlay];
      // The throw-pillow source is a transparent PNG. Its own alpha channel is
      // the exact fabric boundary, including the curved corners and fabric loops.
      let alphaMask = null;
      const alphaMaskConfig = current.alphaMask ? current : config;
      if (alphaMaskConfig.alphaMask && primary) {
        const maskUrl = alphaMaskConfig.alphaMaskKey ? panel.dataset[alphaMaskConfig.alphaMaskKey] : photo;
        if (maskUrl) {
          alphaMask = document.createElement('span');
        alphaMask.className = 'sc-product-photo-alpha-mask';
        alphaMask.style.backgroundColor = rgb(primary);
          // Do not tint anything until this standalone mask image has loaded.
        alphaMask.style.opacity = '0';
        alphaMask.style.webkitMaskImage = `url("${maskUrl}")`;
        alphaMask.style.maskImage = `url("${maskUrl}")`;
        alphaMask.style.webkitMaskSize = '100% 100%';
        alphaMask.style.maskSize = '100% 100%';
        alphaMask.style.webkitMaskPosition = 'center';
        alphaMask.style.maskPosition = 'center';
        alphaMask.style.webkitMaskRepeat = 'no-repeat';
        alphaMask.style.maskRepeat = 'no-repeat';
        children.push(alphaMask);
        }
      }
      stage.replaceChildren(...children);
      // Assign after the node is mounted so the initial photo also works when
      // the browser returns it from cache without another change event.
      image.src = photo;
      if (image.complete && image.naturalWidth) {
        panel.hidden = false;
        keepSharedPreviewHidden();
      }
      if (alphaMask) {
        const maskProbe = new Image();
        maskProbe.onload = () => { alphaMask.style.opacity = '.68'; };
        maskProbe.onerror = () => { alphaMask.remove(); };
        maskProbe.src = alphaMaskConfig.alphaMaskKey ? panel.dataset[alphaMaskConfig.alphaMaskKey] : photo;
      }
      panel.querySelector('[data-sc-product-photo-heading]').textContent = title;
      status.textContent = message;
    };
    const refresh = () => requestAnimationFrame(build);
    product.addEventListener('sc:shared-colors', refresh);
    product.addEventListener('change', refresh);
    // MageWorx can update a radio selection after a click before it emits its
    // own change event. Queue one more paint so every chosen swatch is shown.
    product.addEventListener('input', refresh);
    product.addEventListener('click', event => {
      if (event.target.closest?.('input[type="radio"], label')) refresh();
    });
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-product-specific-option-photos"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const source = document.getElementById('sc-product-specific-option-photo-templates');
    const product = document.getElementById('ProductSection');
    const dialog = document.getElementById('sc-product-specific-option-photo-dialog');
    if (!source || !product || !dialog || source.dataset.initialized) return;
    source.dataset.initialized = 'true';
    const supported = new Set(['thermal-cover', 'insulated-thermal-sauna-cover', 'dust-cover']);
    if (!supported.has(source.dataset.productHandle)) return;
    const normalize = value => (value || '').replace(/\s+/g, ' ').replace(/[:*]/g, '').trim().toLowerCase();
    const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const outer = select => select.closest('.mw-option') || select.closest('fieldset') || select.parentElement;
    const labelFor = select => {
      const explicit = select.id ? document.querySelector(`label[for="${select.id}"]`) : null;
      const container = outer(select);
      return normalize(container?.querySelector('.mw-label .mw-text--style-strong, legend, .mw-option-title, .mw-option-label')?.textContent || explicit?.textContent || select.getAttribute('aria-label'));
    };
    const selection = select => normalize(select.selectedOptions?.[0]?.textContent || '');
    const selectedWeather = text => {
      const value = normalize(text);
      return Boolean(value) && !/(?:please\s+select|do\s+not|no\s+weather|without|not\s+included|^none$|^no\b)/.test(value);
    };
    // MageWorx can decorate this label with optional-copy markers. Match the
    // durable words rather than requiring its rendered punctuation to remain
    // byte-for-byte identical.
    const weatherSlotLabel = label => /\b(?:optional\s+)?weather\s+slot\s+for\s+the\s+power\s+cord\b/.test(label);
    const templateKind = label => {
      const handle = source.dataset.productHandle;
      if (weatherSlotLabel(label)) return handle === 'dust-cover' ? 'dust-weather' : 'thermal-weather';
      if (handle === 'dust-cover' && label === 'door style choice') return 'dust-door';
      return '';
    };
    const imageURL = kind => ({
      'thermal-weather': source.dataset.thermalWeatherUrl,
      'dust-weather': source.dataset.dustWeatherUrl,
      'dust-door': source.dataset.dustDoorUrl,
      zipper: source.dataset.dustZipperUrl
    })[kind] || '';
    const genericPanel = option => option.querySelector(':scope > .sc-shared-option-photos');
    const showGeneric = option => genericPanel(option)?.classList.remove('sc-specific-option-photo__generic-hidden');
    const hideGeneric = option => genericPanel(option)?.classList.add('sc-specific-option-photo__generic-hidden');
    const suppressGenericWhenReady = (option, panel, card) => {
      panel.hidden = false;
      card.hidden = false;
      hideGeneric(option);
    };
    const setImage = (image, url, option, panel, card, required) => {
      if (!image || !url || /^https:\/\/cdn\.shopify\.com\/s\/files\/1\/2956\/5736\/files\/REPLACE/i.test(url)) return false;
      if (required) image.loading = 'eager';
      image.addEventListener('load', () => {
        image.dataset.scSpecificReady = 'true';
        if (required) suppressGenericWhenReady(option, panel, card);
      }, { once:true });
      image.addEventListener('error', () => {
        image.dataset.scSpecificFailed = 'true';
        if (required) {
          card.hidden = true;
          panel.hidden = true;
          showGeneric(option);
        } else image.closest('.sc-specific-option-photo__detail')?.setAttribute('hidden', '');
      }, { once:true });
      image.src = url;
      return true;
    };
    const reset = (option, panel) => {
      panel.hidden = true;
      panel.querySelectorAll('[data-sc-specific-card]').forEach(card => card.hidden = true);
      showGeneric(option);
    };
    const mount = select => {
      if (!visible(select)) return;
      const option = outer(select);
      const kind = templateKind(labelFor(select));
      if (!option || !kind) return;
      let panel = option.querySelector(':scope > .sc-specific-option-photo');
      if (!panel) {
        const template = source.querySelector(`template[data-sc-specific-kind="${kind}"]`);
        if (!template) return;
        const fragment = template.content.cloneNode(true);
        panel = fragment.querySelector('.sc-specific-option-photo');
        option.append(fragment);
      }
      reset(option, panel);
      const text = selection(select);
      const choice = kind.includes('weather') ? (selectedWeather(text) ? 'weather' : '') : /\bstandard\b/.test(text) ? 'standard' : '';
      const card = choice && panel.querySelector(`[data-sc-specific-card="${choice}"]`);
      if (!card) return;
      const primary = card.querySelector('[data-sc-specific-image="weather"], [data-sc-specific-image="door"]');
      const primaryURL = imageURL(kind);
      if (!setImage(primary, primaryURL, option, panel, card, true)) return;
      if (kind === 'dust-door') setImage(card.querySelector('[data-sc-specific-image="zipper"]'), imageURL('zipper'), option, panel, card, false);
      if (primary.complete && primary.naturalWidth) suppressGenericWhenReady(option, panel, card);
    };
    const mountAll = () => {
      product.querySelectorAll('select').forEach(mount);
    };
    let queued = false;
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; mountAll(); }); } };
    product.addEventListener('change', event => {
      const select = event.target.closest('select');
      if (select) mount(select);
    });
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !mutation.target.closest?.('.sc-specific-option-photo'))) schedule();
    }).observe(product, { childList:true, subtree:true, attributes:true, attributeFilter:['class', 'style', 'disabled'] });
    product.addEventListener('click', event => {
      const button = event.target.closest('.sc-specific-option-photo__open, .sc-specific-option-photo__detail');
      if (!button) return;
      const image = button.querySelector('img')?.cloneNode(true);
      if (!image) return;
      image.loading = 'eager';
      dialog.querySelector('h2').textContent = button.closest('.sc-specific-option-photo__card')?.querySelector('strong')?.textContent || '';
      dialog.querySelector('[data-sc-specific-expanded]').replaceChildren(image);
      dialog.showModal();
    });
    dialog.querySelector('[data-sc-specific-close]').addEventListener('click', () => dialog.close());
    mountAll();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-review-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const config = document.getElementById('sc-review-config');
    if (!config) return;
    document.querySelectorAll('[data-sc-reading]').forEach((content, contentIndex) => {
      const navigation = content.parentElement.querySelector('[data-sc-contents]');
      if (!navigation || navigation.dataset.ready) return;
      const headings = [...content.querySelectorAll('h2,h3')];
      if (headings.length < 3) return;
      const fragment = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `sc-detail-${contentIndex}-${index}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        fragment.appendChild(link);
      });
      navigation.appendChild(fragment);
      navigation.dataset.ready = 'true';
      navigation.hidden = false;
    });
    const product = document.getElementById('ProductSection');
    const summary = document.getElementById('sc-build-summary');
    if (!product || !summary) return;
    const lines = summary.querySelector('.sc-summary-lines');
    const total = summary.querySelector('[data-sc-total]');
    const empty = summary.querySelector('.sc-summary-empty');
    const colorsLink = product.querySelector('.sc-colors-link');
    let signature = '';
    let pending = false;
    const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    // APO retains its own validation and conditional rules. Also require a deliberate
    // choice for visible dropdowns such as the single available cushion height.
    const requireExplicitChoices = event => {
      if (event.type === 'click' && !event.target.closest('button[name="add"]')) return;
      if (event.type === 'submit' && !event.target.matches('form[action="/cart/add"]')) return;
      const controls = [...product.querySelectorAll('.mw-option select')];
      controls.forEach(control => control.setCustomValidity(''));
      const missing = controls.find(control => control.id !== 'select_o_1989086' && !control.disabled && visible(control) && !control.value && [...control.options].some(option => option.value && !option.disabled));
      if (!missing) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      missing.setCustomValidity(config.dataset.choose);
      missing.reportValidity();
    };
    product.addEventListener('click', requireExplicitChoices, true);
    product.addEventListener('submit', requireExplicitChoices, true);
    product.addEventListener('change', event => {
      if (event.target.matches('.mw-option select')) event.target.setCustomValidity('');
    }, true);
    const selectedText = field => {
      if (field.tagName === 'SELECT') return [...field.selectedOptions].filter(option => option.value).map(option => option.textContent.trim()).join(', ');
      if (field.type === 'radio' || field.type === 'checkbox') {
        if (!field.checked) return '';
        return field.getAttribute('aria-label') || field.labels?.[0]?.textContent.trim() || '';
      }
      if (field.type === 'file') return [...field.files].map(file => file.name).join(', ');
      if (field.type === 'hidden' || field.type === 'button' || field.type === 'submit') return '';
      return field.value.trim();
    };
    const refresh = () => {
      pending = false;
      const rows = [];
      const options = [...product.querySelectorAll('.mw-option')].filter(visible);
      options.forEach(option => {
        const label = option.querySelector('.mw-label .mw-text--style-strong')?.textContent.trim();
        if (!label) return;
        const values = [...option.querySelectorAll('select,input,textarea')].filter(field => !field.disabled).map(selectedText).filter(Boolean);
        if (values.length) rows.push([label, [...new Set(values)].join(' · ')]);
        const hasRushChoice = [...option.querySelectorAll('select option')].some(choice => /rush/i.test(choice.textContent)) || /rush/i.test(label);
        if (hasRushChoice && !option.querySelector('.sc-rush-note')) {
          const note = document.createElement('p');
          note.className = 'sc-rush-note';
          note.textContent = config.dataset.rush;
          option.appendChild(note);
        }
      });
      product.querySelectorAll('[data-sc-property]').forEach(field => {
        if (field.disabled || !field.value.trim()) return;
        const value = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent.trim() : field.value.trim();
        rows.push([field.dataset.scProperty, value]);
      });
      const next = JSON.stringify(rows);
      if (next !== signature) {
        signature = next;
        const fragment = document.createDocumentFragment();
        rows.forEach(([label, value]) => {
          const row = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = label;
          description.textContent = value;
          row.append(term, description);
          fragment.appendChild(row);
        });
        lines.replaceChildren(fragment);
        empty.hidden = rows.length > 0;
      }
      const priceElement = product.querySelector('[id^="productPrice-"]');
      const accessiblePrices = priceElement ? [...priceElement.querySelectorAll(':scope > .visually-hidden')] : [];
      const priceCopy = (accessiblePrices.at(-1) || priceElement)?.cloneNode(true);
      priceCopy?.querySelectorAll('.visually-hidden').forEach(label => label.remove());
      const price = priceCopy?.textContent.replace(/\s+/g, ' ').trim();
      if (price && total.textContent !== price) total.textContent = price;
      const colorOption = options.find(option => /color/i.test(option.querySelector('.mw-label .mw-text--style-strong')?.textContent || '') && option.querySelector('input[type="radio"],select'));
      if (colorsLink && colorOption?.id) {
        const href = `#${colorOption.id}`;
        if (colorsLink.getAttribute('href') !== href) colorsLink.setAttribute('href', href);
        if (colorsLink.hidden) colorsLink.hidden = false;
      }
    };
    const schedule = () => {
      if (pending) return;
      pending = true;
      window.setTimeout(refresh, 120);
    };
    product.addEventListener('input', schedule);
    product.addEventListener('change', schedule);
    product.addEventListener('sc:custom-options', schedule);
    new MutationObserver(schedule).observe(product, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','style','disabled']});
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-route-choice-order"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const marker = document.getElementById('sc-route-choice-order');
    if (!marker || marker.dataset.initialized) return;
    marker.dataset.initialized = 'true';
    const withoutSelector = '.route-continue-without-coverage-link[data-checkout-without-coverage-link]';
    const withSelector = '[data-route-cloned-button="true"]';
    const headerSelector = '[data-route-widget-header]';
    const descriptionSelector = headerSelector + ' .pw-coverage-description';
    const relevantSelector = [withoutSelector, withSelector, headerSelector, descriptionSelector, '.checkout_containers'].join(',');
    let pending = false;

    const branchFor = (button, wrapperSelector, scope) => {
      const wrapper = button.closest(wrapperSelector);
      if (wrapper && scope.contains(wrapper)) return wrapper;
      let branch = button;
      while (branch.parentElement && branch.parentElement !== scope &&
        branch.parentElement.childElementCount === 1 &&
        !['FORM', 'BODY'].includes(branch.parentElement.tagName)) {
        branch = branch.parentElement;
      }
      return branch;
    };

    const arrange = () => {
      pending = false;
      document.querySelectorAll(withSelector).forEach(withButton => {
        const label = marker.dataset.withLabel;
        const text = withButton.querySelector('.route-checkout-text-stacked');
        if (label && text && !text.childElementCount && text.textContent.trim() !== label) {
          text.textContent = label;
        }
      });
      document.querySelectorAll(withoutSelector).forEach(withoutButton => {
        if (marker.dataset.withoutLabel) {
          const label = marker.dataset.withoutLabel;
          if (!withoutButton.childElementCount && withoutButton.textContent.trim() !== label) {
            const text = withoutButton.firstChild;
            if (text && text.nodeType === 3) text.nodeValue = label;
          }
          if (withoutButton.getAttribute('aria-label') !== label) withoutButton.setAttribute('aria-label', label);
        }
        let scope = withoutButton.parentElement;
        while (scope && scope !== document.body) {
          const withButtons = scope.querySelectorAll(withSelector);
          if (withButtons.length > 1 || scope.querySelectorAll(withoutSelector).length > 1) return;
          if (withButtons.length === 1) {
            const withBranch = branchFor(withButtons[0], '[data-route-widget-button]', scope);
            const withoutBranch = branchFor(withoutButton, '[data-route-widget-cwc]', scope);
            if (withBranch.contains(withoutBranch) || withoutBranch.contains(withBranch)) return;
            if (withoutBranch.parentElement !== withBranch.parentElement ||
              withoutBranch.nextElementSibling !== withBranch) {
              withBranch.before(withoutBranch);
            }
            return;
          }
          scope = scope.parentElement;
        }
      });
      document.querySelectorAll('.cart-form .checkout_containers').forEach(checkout => {
        if (!checkout.querySelector(withSelector)) return;
        const headers = checkout.parentElement.querySelectorAll(headerSelector);
        if (headers.length !== 1) return;
        const header = headers[0];
        if (header.contains(checkout)) return;
        if (checkout.nextElementSibling !== header) checkout.after(header);
      });
      if (marker.dataset.protectionMessage) {
        document.querySelectorAll(descriptionSelector).forEach(description => {
          if (description.childElementCount || !/^Your order is protected\.?$/i.test(description.textContent.trim())) return;
          const text = description.firstChild;
          if (text && text.nodeType === 3) text.nodeValue = marker.dataset.protectionMessage;
        });
      }
    };

    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(arrange);
    };
    new MutationObserver(records => {
      if (records.some(record => {
        const textSelector = descriptionSelector + ',' + withoutSelector + ',.route-checkout-text-stacked';
        if (record.type === 'characterData') return record.target.parentElement?.matches(textSelector);
        if (record.target.nodeType === 1 && record.target.matches(textSelector)) return true;
        return [...record.addedNodes].some(node =>
          node.nodeType === 1 && (node.matches(relevantSelector) || node.querySelector(relevantSelector))
        );
      })) schedule();
    }).observe(document.body, {childList: true, subtree: true, characterData: true});
    document.addEventListener('shopify:section:load', schedule);
    arrange();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-sauna-cover-wind-snaps"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const store = document.querySelector('[data-sc-sauna-snap-store]');
      const form = document.getElementById('addToCartForm-product-template') || document.querySelector('#ProductSection form');
      if (!store || !form || store.dataset.initialized) return;
      store.dataset.initialized = 'true';
      const help = store.querySelector('[data-sc-sauna-snap-help]');
      const attach = () => {
        const optionLabel = option => option?.querySelector('.mw-text--style-strong, legend, label')?.textContent || '';
        const option = [...form.querySelectorAll('.mw-option')].find(item => /(?:\bwind\b[\s\S]{0,60}\bsnaps?\b|\bsnaps?\b[\s\S]{0,60}\bwind\b)/i.test(optionLabel(item)));
        const select = option?.querySelector('select');
        if (!option || !select) {
          help.hidden = true;
          return;
        }
        if (help.parentElement !== option) option.append(help);
        option.querySelector('.sc-option-photos .sc-option-photo-card')?.classList.add('sc-sauna-snap-help__old-photo');
        const selected = select.options[select.selectedIndex];
        const value = selected?.textContent?.trim() || '';
        const supported = Boolean(select.value && value);
        help.hidden = !supported;
        if (!supported) return;
        const mode = /(?:18|eighteen)/i.test(value) ? 'eighteen' : /(?:two|2).*(?:side|each)/i.test(value) ? 'two' : 'standard';
        const copy = { standard: help.dataset.standard, two: help.dataset.two, eighteen: help.dataset.eighteen };
        const selection = help.querySelector('[data-sc-sauna-snap-selection]');
        if (selection.textContent !== copy[mode]) selection.textContent = copy[mode];
        help.querySelector('[data-sc-sauna-snap-standard]').toggleAttribute('hidden', mode !== 'standard');
        help.querySelector('[data-sc-sauna-snap-two]').toggleAttribute('hidden', mode !== 'two');
        help.querySelector('[data-sc-sauna-snap-eighteen]').toggleAttribute('hidden', mode !== 'eighteen');
      };
      form.addEventListener('change', attach);
      new MutationObserver(attach).observe(form, { childList:true, subtree:true });
      attach();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-shared-color-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const preview = document.getElementById('sc-shared-color-preview');
    const product = document.getElementById('ProductSection');
    const gallery = product?.querySelector('.sc-product-gallery');
    if (!preview || !product || !gallery || preview.dataset.initialized) return;
    preview.dataset.initialized = 'true';

    const palette = {"3b1ac705241534d7faf7989ab7e3129ef6cd8aebd4be705f9afb579c9b3b2dd2":[183,161,152],"4993f5928d722966a61ed0c77d863bfa16fc6f9c547224f2237aec61c8ca2e5b":[10,9,12],"936246084800b4b853806562458fe8d7e4ad42a359c93f03e5da273853eef778":[138,17,24],"0edcebba2e4158055f58939a6bb922e1375943cb92e20112655ca867f37fcc8c":[9,38,37],"e4caf498dcaa51a9dfb009045ea3c5c495461edc77f994b32f8d411994df6bf4":[30,53,98],"51c1fd35a470d9a42dad9c166b71d0f7e256f8182a91b7d5aba3b8d0753079b8":[82,102,93],"9c51ac1f9052598894d6fa3fe2182ac32d5c0684990954aeec0386e42ab2e80d":[3,49,119],"de226fc33c86ba0c2da0b73ee7398f351586256989dbaf7fa73ae41a6638253b":[18,26,59],"e33078d104b9d548c261d07ad6827f5c18ce7acfae2f99aa494dc65c1e6815cb":[223,214,208],"597267393684189e66c892d703c6446c36d64a45f67de291da2344137939b616":[173,147,140],"c8dc7c7f4fedc740e2c7ad31489a3cf5e73b8d5b845cb0d984276c494dc0fb61":[225,221,223],"893c892fb7b7f1de1e078a41dbf7ad1b59108bb03ae3f9b3a71e189fceb5e9bf":[96,19,25],"50a79498418fc8cfc9853c2fec0a31df4826640b798a733f66363d470653af31":[202,187,184],"0c4d880fd718bc488e34ab240b5b1f7e5341eabb2acadef261c62fdc03d0fb36":[155,130,126],"85e7d8c9bf2207ccda22778a67c78f4deb879c6222d2ad1ab98f528c5ee78cae":[118,92,88],"b2dbdb2e947a4e1b87bb500b80869454fe20ee0f673d4204093242b038c44303":[71,66,74],"1528cd387c1c4792124047580b3a96615392b28ca05e294a08abf028c6614cb5":[101,87,88],"9e449ca37b0aef068e196426216e8b18a7f138b0eca4ad64ff178e314751656a":[26,15,17],"ea547ffe82f5639f5d1faa48f2425bdd696241d210fc0f070a219a483700e012":[151,146,157],"8ba8315a8dbc104f92da48f7119905c01862f27ad920718904dac2507f84f1c6":[64,60,68],"d88972def3b27d60e3930922f94d3e9e344c33ec7d923865753d2504574ee444":[118,110,114],"850a1716cc753a1d7d577f4b234dd0a6b1eaa951f5c0eeea2daa6c1c1da0d32a":[94,74,74],"981605903608fe6799dc304ce14364f93f92194878ba2a01dd0b195e69347b0e":[41,36,40],"004efc15b58256ec7fd9d76861c56d25a92a4648066f37a60f61c619e46f38ac":[14,55,55],"659694e7c4a252d37f02e4ae4da258035fd77bfa581d1ba2c49d17b142338ef1":[207,187,160],"9618484c6575795e4885e8755054cf093c0f0950df53d6dd9ce22e73f95467db":[22,22,24],"9b2fc6c9563b0d4d05e762152ff7e3246c39d89d7bfa7e5ede7993a2c8b32051":[120,103,87],"5377f9d65d69ea31d97b79bbc6e53f9afcf583dbccfb2ffd0fc91474d3e2e060":[126,127,141],"1e3d896bd7ff048ed69a81c1e1d6f5ab22a35df88f013be9e0cf9ea174927b25":[33,42,57],"f056861206fdd288e67203deebcee5708409cf58ae5d7b9dc41acb05c19f679a":[2,83,182],"e8a54a6de54985e762c1ba170e5687dbcc6b6b9d1791b013610c0f339d3ff6bf":[14,63,124],"9ed9dd48be8548cc19f81cd31dc197ff9cd6807566cda227d3b771134e30176b":[209,5,32],"82ad9c9e7f4b64308945a6b026aa35cd0eb993fc9f3e9910fedad843118dfffb":[11,54,109],"ba1c0ec85fa7c24cbab6de001b59c2f3f63867a01fde5dccf536d77bc90a88c6":[242,241,239],"8ebafe82b9ec7eac6de1dfece0abe870d5a5610b934a0e9a281b31059ff3312f":[96,27,35],"5ab3bd80c80e98a2612fc748e6fd98a89a212cb597b0e96e855131a4446ddd19":[179,180,174],"f7e6569fd4e52bab4461069d8d78931a20e7b1d8b6f0dcd1bc0cfca090c1de36":[236,203,158],"d364138b017e0d61ae6d5166c95bab3ea4934676c7a14e5ac2f43a7ce38c4072":[244,237,221],"c6768fe738ed6b27239c0fdba20975c90e9b5f0e0d08bd5d637ab290c8e6b78c":[193,194,196],"0e21262c21292643089f361d7c417b956f8802fb44312885d384ebbef6f2549d":[174,150,126],"10f030f43707ed7342fa1317dd3aaa0291c0df0bcd81cc731fa96c40a26697b7":[42,60,60],"12e32fd8f90ee4ec6c71a1ce862f8207fb507cb0e1cbaace1c3f70ec4c5d6208":[68,69,74],"17b61f2712a15fb9b55109fad454717bd66e757070ec456b7850a266a471b048":[82,62,73],"20517c8788457412e0e85fc49df82771ee70edd92cb249ad57d2431612687c64":[163,21,43],"52b1174b43d1f9d0ee359f872a7c64789a2faf041cc6a5eda8fe6a8deab7ef5d":[124,98,85],"6549565f28645a58d6ed23da8136ee933691c07bef08e80d05d944bc66535966":[24,48,52],"6898223bcb85eddbbb4f8c57dcc0dc1757d99f294a8018e0d4a50d4dc17550f5":[155,145,120],"6d95da5a8fd3fc068b04087a304aa651caa074c5d94ee1dbd06efd47aa046291":[23,45,32],"8ccb1a9c34383f430ef22039e41ccfa4678406e9adee70c910d168b0d32635cf":[124,143,160],"8dee53e2bae6de5ce5c0775f8209ce6a8ae13701038d21b2fba353318c0df77a":[224,12,24],"958bd5da901f1eaf05c9bc547c7be0ffc786ed30d358cc32c19734dacdbcc5e5":[26,26,28],"9aa5cb31a8c2f41f61947813741bdae9f312cf74618836c8498bf78a51451a5c":[32,38,64],"a5b8b8e949c96dd7db25c561ac6b118f37e0d6f82cf9828fa91d2a9004473a83":[26,61,161],"b4e950919593e6feb85201f7248655a17ba86a9b3896a07f68ba454ea7347fbb":[25,37,59],"b6082725abf83f951f3420b29f0a7e3c66bfff67a50e180af5d5666501ede9b0":[88,78,89],"f24e3b1e3265c0ebcb5fc5b104c9d6072efb6ccbb6640412489cde837c643de1":[4,76,152]};
    const exactLabels = new Map([
      ['choose your color', 'single'], ['choose your cushion color', 'single'], ['choose your pillow color', 'single'], ['choose your material color', 'single'], ['color', 'single'], ['cover color', 'single'], ['thermal cover color', 'single'], ['fabric color', 'single'], ['mat color', 'single'], ['sauna dust cover - color', 'single'],
      ['side color', 'primary'], ['roof color', 'secondary']
    ]);
    const twoColorOnlyHandles = new Set(['sauna-cover-clearlight-saunas','sauna-cover-finnmark-designs','sauna-cover-golden-designs','sauna-cover-health-mate-saunas','sauna-cover-medical-saunas','sauna-cover-sunlighten']);
    const shapeForHandle = {
      'sauna-floor-mat':'mat', 'sauna-roof-only-cover':'roof',
      'thermal-cover':'cover', 'insulated-thermal-sauna-cover':'cover', 'sauna-cover-with-thermal-cover':'cover', 'dust-cover':'cover', 'all-in-one-cover':'cover',
      'sauna-cover-clearlight-saunas':'cover', 'sauna-cover-finnmark-designs':'cover', 'sauna-cover-golden-designs':'cover', 'sauna-cover-health-mate-saunas':'cover', 'sauna-cover-medical-saunas':'cover', 'sauna-cover-sunlighten':'cover',
      'one-person-sauna-cushion':'cushion', 'sauna-cushion-jacuzzi-saunas-clearlight-saunas':'cushion', 'sauna-cushion-golden-designs':'cushion', 'sauna-cushion-health-mate-saunas':'cushion', 'sauna-cushion-sunlighten':'cushion', 'copy-of-sauna-cushion':'cushion',
      'lumbar-cushions':'lumbar', 'throw-pillows':'pillow'
    };
    const normalize = value => (value || '').replace(/\s+/g, ' ').replace(/[:*]/g, '').trim().toLowerCase();
    const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const containerFor = input => input.closest('.mw-option') || input.closest('fieldset') || input.parentElement;
    const labelFor = input => {
      const container = containerFor(input);
      const linked = input.id ? document.querySelector(`label[for="${input.id}"]`) : null;
      const groupLabel = container?.querySelector('.mw-label .mw-text--style-strong, legend, .mw-option-title, .mw-option-label')?.textContent;
      return normalize(groupLabel || linked?.closest('.mw-option, [class*="option"], fieldset')?.querySelector('.mw-label .mw-text--style-strong, legend, .mw-option-title, .mw-option-label')?.textContent || input.getAttribute('aria-label'));
    };
    const optionForLabel = label => [...product.querySelectorAll('input[type="radio"]')].map(containerFor).find(container => container && visible(container) && labelFor(container.querySelector('input[type="radio"]')) === label);
    const selected = container => {
      const input = container?.querySelector('input[type="radio"]:checked');
      if (!input) return null;
      const label = input.getAttribute('aria-label') || document.querySelector(`label[for="${input.id}"]`)?.textContent || input.closest('label')?.textContent || '';
      const image = input.closest('label')?.querySelector('img') || document.querySelector(`label[for="${input.id}"] img`) || input.parentElement?.querySelector('img');
      const source = image?.getAttribute('src') || image?.src || '';
      const hash = source.match(/([a-f0-9]{64})(?:\.[a-z0-9]+)?(?:\?|$)/i)?.[1];
      return { name: label.replace(/\s*\(In Stock\).*$/i, '').trim(), rgb:palette[hash] || (preview.dataset.productHandle === 'dust-cover' && /^white(?:\s*\(|$)/i.test(label.trim()) ? [242,241,239] : null) };
    };
    const showShape = kind => preview.querySelectorAll('[data-sc-shared-shape]').forEach(element => { if (element.dataset.scSharedShape === kind) element.removeAttribute('hidden'); else element.setAttribute('hidden', ''); });
    const setChoice = (slot, choice) => {
      const dot = preview.querySelector(`[data-sc-shared-${slot}-dot]`);
      const name = preview.querySelector(`[data-sc-shared-${slot}-name]`);
      name.textContent = choice?.name || 'Choose a color';
      dot.style.backgroundColor = choice?.rgb ? `rgb(${choice.rgb.join(',')})` : '#d1ceca';
      preview.style.setProperty(`--sc-shared-${slot}`, choice?.rgb ? `rgb(${choice.rgb.join(',')})` : '#d1ceca');
      preview.dataset[`${slot}Rgb`] = choice?.rgb ? choice.rgb.join(',') : '';
    };
    const updateTop = () => {
      const fixedBottom = Math.max(0, ...['#qab_background', '#mobileNavBar'].map(selector => { const element = document.querySelector(selector); return element && getComputedStyle(element).position === 'fixed' ? element.getBoundingClientRect().bottom : 0; }));
      preview.style.setProperty('--sc-shared-color-top', `${Math.max(104, Math.ceil(fixedBottom + 8))}px`);
    };
    const place = firstOption => {
      updateTop();
      if (window.matchMedia('(max-width:768px)').matches) {
        if (preview.parentElement !== firstOption.parentElement || preview.nextElementSibling !== firstOption) firstOption.before(preview);
      } else if (preview.parentElement !== gallery) gallery.append(preview);
    };
    const refresh = () => {
      const side = optionForLabel('side color');
      const roof = optionForLabel('roof color');
      const single = ['choose your color','choose your cushion color','choose your pillow color','choose your material color','color','cover color','thermal cover color','fabric color','mat color','sauna dust cover - color'].map(optionForLabel).find(Boolean);
      const isTwoColor = Boolean(side && roof);
      const requiresTwoColor = twoColorOnlyHandles.has(preview.dataset.productHandle);
      const first = isTwoColor ? side : requiresTwoColor ? null : single || roof || side;
      if (!first) { preview.hidden = true; return; }
      const shape = isTwoColor ? 'two-color' : shapeForHandle[preview.dataset.productHandle] || 'cover';
      preview.querySelector('#sc-shared-color-heading').textContent = shape === 'cushion' ? 'Preview your cushion color' : ['lumbar','pillow'].includes(shape) ? 'Preview your pillow color' : 'Preview your color';
      const primary = selected(first);
      const secondary = isTwoColor ? selected(roof) : null;
      showShape(shape);
      preview.querySelector('[data-sc-shared-primary-row]').hidden = false;
      preview.querySelector('[data-sc-shared-secondary-row]').hidden = !isTwoColor;
      setChoice('primary', primary);
      if (isTwoColor) setChoice('secondary', secondary);
      const choices = isTwoColor ? [primary, secondary] : [primary];
      const known = choices.filter(choice => choice?.rgb).length;
      const selectedCount = choices.filter(Boolean).length;
      const status = preview.querySelector('[data-sc-shared-color-status]');
      status.textContent = selectedCount === 0 ? 'Choose a color to see the preview.' : known !== selectedCount ? 'Your selected swatch is shown in the choice above. A color illustration is not available for that swatch.' : selectedCount === choices.length ? 'Your selected color is shown in the illustration.' : 'Choose the remaining color to complete the preview.';
      preview.hidden = false;
      product.dispatchEvent(new CustomEvent('sc:shared-colors', { detail: { primary, secondary } }));
      place(first);
    };
    const schedule = () => requestAnimationFrame(refresh);
    product.addEventListener('change', schedule);
    let pending = false;
    new MutationObserver(mutations => {
      const hasExternalAddition = mutations.some(m => [...m.addedNodes].some(node => node.nodeType === 1 && !node.matches?.('.sc-shared-color-preview') && !node.closest?.('.sc-shared-color-preview')));
      if (!hasExternalAddition || pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; refresh(); });
    }).observe(product, { childList:true, subtree:true });
    window.addEventListener('resize', updateTop);
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-shared-final-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const panel = document.getElementById('sc-final-preview');
    const product = document.getElementById('ProductSection');
    const summary = document.getElementById('sc-build-summary');
    const dialog = document.getElementById('sc-final-dialog');
    const sharedHandles = new Set(['sauna-cover-with-thermal-cover', 'all-in-one-cover']);
    if (!panel || !sharedHandles.has(panel.dataset.productHandle) || !product || !summary || !dialog || panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    summary.before(panel);
    const copy = Object.fromEntries([...panel.querySelectorAll('[data-sc-final-copy]')].map(t=>[t.dataset.scFinalCopy,t.content.textContent.trim()]));
    const button = panel.querySelector('[data-sc-final-open]');
    const stage = dialog.querySelector('[data-sc-final-stage]');
    const status = panel.querySelector('[data-sc-final-status]');
    const visible = el => el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    const productOptionIds = {
      'sauna-cover-with-thermal-cover': { roof:'1989014', valance:'1989031', door:'1989030', weather:'1989032', snaps:'1989033', width:'1989034', depth:'1989035', height:'1989036', overhang:'1989037', sideColor:'1988902', roofColor:'1988903' },
      'all-in-one-cover': { roof:'1989014', valance:'1989031', door:'1989030', weather:'1989032', snaps:'1989033', width:'1989034', depth:'1989035', height:'1989036', overhang:'1989037', sideColor:'1988902', roofColor:'1988903' }
    };
    const previewConfigs = Object.freeze({
      'sauna-cover-with-thermal-cover': Object.freeze({ renderer:'custom-sauna-cover-v1', exterior:'outer-cover-only', valance:'continuous-three-sides', defaultView:'closed', zipperFlaps:'inward' }),
      'all-in-one-cover': Object.freeze({ renderer:'custom-sauna-cover-v1', exterior:'outer-cover-only', valance:'continuous-three-sides', defaultView:'closed', zipperFlaps:'inward' })
    });
    const optionIds = productOptionIds[panel.dataset.productHandle];
    const previewConfig = previewConfigs[panel.dataset.productHandle];
    if (!optionIds || !previewConfig || panel.dataset.renderer !== previewConfig.renderer) return;
    const option = key => document.getElementById('o_'+optionIds[key]);
    const select = key => option(key)?.querySelector('select');
    const selected = key => { const el=option(key); return el?.querySelector('select')?.value || el?.querySelector('input:checked')?.value || ''; };
    const label = key => option(key)?.querySelector('.mw-label .mw-text--style-strong')?.textContent.trim() || '';
    const selectedText = key => {
      const el = option(key);
      const control = el?.querySelector('select') || el?.querySelector('input:checked');
      const linkedLabel = control?.id ? document.querySelector(`label[for="${control.id}"]`)?.textContent : '';
      const text = control?.selectedOptions?.[0]?.textContent || control?.getAttribute('aria-label') || linkedLabel || control?.closest('label')?.textContent || control?.labels?.[0]?.textContent || '';
      return text.replace(/\s*\(In Stock\).*$/i, '').trim().toLowerCase();
    };
    const colorPreview = document.getElementById('sc-color-preview') || document.getElementById('sc-shared-color-preview');
    const color = key => {
      const slot = colorPreview?.id === 'sc-color-preview'
        ? (key === 'sideColor' ? 'sideRgb' : 'roofRgb')
        : (key === 'sideColor' ? 'primaryRgb' : 'secondaryRgb');
      const raw = colorPreview?.dataset[slot];
      const values = raw?.split(',').map(Number);
      return values?.length === 3 && values.every(Number.isFinite) ? values : null;
    };
    const dimension = key => {
      const optionElement = option(key);
      if (!visible(optionElement)) return null;
      const raw = optionElement.querySelector('input[type="text"]')?.value.trim().replace(/[”″"]/g, '').replace(/\s*(inches|inch|in)\.?$/i, '').trim() || '';
      // Support decimal and common mixed-fraction measurements without guessing other formats.
      const mixed=raw.match(/^(\d+)\s+(\d+)\/(\d+)$/), fraction=raw.match(/^(\d+)\/(\d+)$/);
      const n=mixed ? +mixed[1]+ +mixed[2]/+mixed[3] : fraction ? +fraction[1]/+fraction[2] : /^\d+(\.\d+)?$/.test(raw) ? Number(raw) : NaN;
      return Number.isFinite(n)&&n>0&&n<=300 ? n : null;
    };
    const dimensionField = key => {
      const optionElement = option(key);
      const field = optionElement?.querySelector('input[type="text"]');
      return field && visible(optionElement) && !field.disabled ? field : null;
    };
    const validDimension = key => {
      const field = dimensionField(key);
      if (!field) return { visible:false, value:null, valid:true };
      const value = dimension(key);
      return { visible:true, value, valid:Boolean(field.value.trim()) && field.checkValidity() && value !== null };
    };
    const modelSelection = () => {
      const labels = /(?:sauna\s*(?:brand|company|maker|model)|brand\s*(?:\/|and)?\s*model|company\s*(?:\/|and)?\s*model)/i;
      const groups = [...product.querySelectorAll('.mw-option')].filter(element => labels.test(element.querySelector('.mw-label .mw-text--style-strong')?.textContent || ''));
      const group = groups.find(visible);
      if (!group) return { label:'', dimensions:null, corner:false };
      const control = group.querySelector('select') || group.querySelector('input:checked');
      const selectedOption = control?.selectedOptions?.[0] || control;
      const text = (selectedOption?.textContent || selectedOption?.getAttribute('aria-label') || selectedOption?.labels?.[0]?.textContent || '').replace(/\s*\(In Stock\).*$/i, '').trim();
      const generic = /^(?:custom\s*(?:size|dimensions?)|other|none|--.*--|please\s+select.*|select.*)$/i.test(text);
      const numeric = name => Number(selectedOption?.dataset?.[name] || group.dataset?.[name]);
      const width = numeric('width'), depth = numeric('depth'), height = numeric('height');
      const dimensions = [width, depth, height].every(value => Number.isFinite(value) && value > 0) ? { width, depth, height } : null;
      return { label:generic ? '' : text, dimensions, corner:/corner/i.test(text) };
    };
    const customCompletion = () => {
      const doorPanel = document.getElementById('sc-door-width');
      const roofPanel = document.getElementById('sc-online-roof');
      const required = [];
      if (doorPanel && !doorPanel.hidden && doorPanel.dataset.complete !== 'true') required.push('Standard front-door opening');
      if (roofPanel && !roofPanel.hidden && roofPanel.dataset.complete !== 'true') required.push('Peaked roof worksheet');
      return required;
    };
    const materialURL=panel.dataset.fabric, saunaURL=panel.dataset.sauna;
    let state, view=previewConfig.defaultView, signature='', pending=false, materialsReady=false, materialLoad;
    const loadMaterials=()=>materialLoad ||= Promise.all([materialURL,saunaURL].map(url=>new Promise((resolve,reject)=>{const picture=new Image();picture.onload=resolve;picture.onerror=reject;picture.src=url;}))).then(()=>{materialsReady=true;}).catch(error=>{materialLoad=null;throw error;});
    const rgb = (c,f=1,light=0)=>`rgb(${c.map(n=>Math.round(Math.min(255,Math.max(0,n*f+light)))).join(',')})`;
    const render = () => {
      if (!state?.ready) { stage.replaceChildren(); return; }
      if(!materialsReady){stage.textContent=copy.loading;return;}
      const {side,roof,valance,door,weather,snaps,peaked}=state;
      const w=state.width || 60, d=state.depth || 50, h=state.height || 80;
      const roofKind=state.roofKind || 'gable';
      const peak=peaked ? (state.peakRise || Math.min(w*.27,h*.3)) : 0;
      const rear=view==='rear', closed=view==='closed';
      const wrap=['v_17270454','v_17270455'].includes(valance);
      const wavy=['v_17270453','v_17270454'].includes(valance);
      const upgrade=door==='v_17270457';
      const hem=Math.min(6,h*.075);
      const doorClearance=Math.min(1.25,Math.max(.65,h*.0125));
      const doorTop=hem+doorClearance;
      const inset=!upgrade&&state.doorMode==='narrow'&&state.openingWidth ? Math.max(0,(w-Math.min(w,state.openingWidth))/2) : upgrade ? Math.min(6,w*.10) : Math.min(2.5,w*.04);
      const p=(x,y,z)=>[4.8*x-3*y,-.6*x-1.5*y-5*z];
      const pt=(x,y,z)=>p(x,y,z).map(n=>n.toFixed(2)).join(' ');
      const poly=points=>'M'+points.map(a=>pt(...a)).join('L')+'Z';
      const front=`matrix(4.8 -.6 0 5 0 ${-5*h})`;
      const left=`matrix(3 1.5 0 5 ${-3*d} ${-1.5*d-5*h})`;
      const path=(d,fill,attrs='')=>`<path d="${d}" fill="${fill}" ${attrs}/>`;
      const fabric=(d,fill,attrs='')=>path(d,fill,attrs)+path(d,'url(#scf-weave)','pointer-events="none"');
      const bounds=[p(0,d,h),p(w,0,0),p(w/2,d,h+peak),p(0,0,0),p(w,0,h+peak)];
      const minX=-3*d-45, minY=Math.min(...bounds.map(a=>a[1]))-38, maxX=4.8*w+40;
      const tint=(id,c,f=1)=>`<filter id="${id}" color-interpolation-filters="sRGB"><feColorMatrix type="saturate" values="0"/><feComponentTransfer>${['R','G','B'].map((channel,i)=>`<feFunc${channel} type="table" tableValues="0 ${(c[i]*f*.55/255).toFixed(4)} ${(c[i]*f/255).toFixed(4)} ${Math.min(1,c[i]*f*1.11/255+.03).toFixed(4)} 1"/>`).join('')}</feComponentTransfer></filter>`;
      const material=(id,filter)=>`<pattern id="${id}" width="1" height="1" patternContentUnits="objectBoundingBox"><image href="${materialURL}" width="1" height="1" preserveAspectRatio="none" filter="url(#${filter})"/><rect width="1" height="1" fill="url(#${id}-light)" opacity=".12"/></pattern>`;
      const defs=`<defs>
        ${tint('scf-side-tint',side,.85)}${tint('scf-front-tint',side)}${tint('scf-roof-tint',roof)}
        ${material('scf-side','scf-side-tint')}${material('scf-front','scf-front-tint')}${material('scf-valance','scf-front-tint')}${material('scf-roof','scf-roof-tint')}

        <pattern id="scf-flap-fabric" width="${w}" height="${h}" patternUnits="userSpaceOnUse"><image href="${materialURL}" width="${w}" height="${h}" preserveAspectRatio="none" filter="url(#scf-front-tint)"/></pattern>
        <linearGradient id="scf-side-light"><stop stop-color="${rgb(side,.73)}"/><stop offset=".38" stop-color="${rgb(side,.90)}"/><stop offset=".7" stop-color="${rgb(side,1.03,5)}"/><stop offset="1" stop-color="${rgb(side,.86)}"/></linearGradient>
        <linearGradient id="scf-front-light"><stop stop-color="${rgb(side,.88)}"/><stop offset=".35" stop-color="${rgb(side,1,7)}"/><stop offset=".85" stop-color="${rgb(side,.97)}"/><stop offset="1" stop-color="${rgb(side,.76)}"/></linearGradient>
        <linearGradient id="scf-valance-light" gradientUnits="userSpaceOnUse" x1="${-3*d}" x2="${4.8*w}"><stop stop-color="${rgb(side,.72)}"/><stop offset="${(3*d/(3*d+4.8*w)).toFixed(3)}" stop-color="${rgb(side,.87)}"/><stop offset=".45" stop-color="${rgb(side,1,8)}"/><stop offset="1" stop-color="${rgb(side,.93)}"/></linearGradient>
        <linearGradient id="scf-roof-light" x2=".8" y2="1"><stop stop-color="${rgb(roof,1,25)}"/><stop offset=".42" stop-color="${rgb(roof,1,8)}"/><stop offset="1" stop-color="${rgb(roof,.74)}"/></linearGradient>
        <linearGradient id="scf-roll" x2="0" y2="1"><stop stop-color="${rgb(side,.65)}"/><stop offset=".4" stop-color="${rgb(side,1,15)}"/><stop offset=".65" stop-color="${rgb(side,.96)}"/><stop offset="1" stop-color="${rgb(side,.58)}"/></linearGradient>
        <linearGradient id="scf-natural"><stop stop-color="#bdb295"/><stop offset=".5" stop-color="#f1e7d0"/><stop offset="1" stop-color="#d6cab0"/></linearGradient>
        <linearGradient id="scf-glass" x2="1" y2="1"><stop stop-color="#182923"/><stop offset=".52" stop-color="#37493e"/><stop offset="1" stop-color="#101d17"/></linearGradient>
        <radialGradient id="scf-metal"><stop stop-color="#dadbd5"/><stop offset=".48" stop-color="#555b59"/><stop offset=".67" stop-color="#eceee7"/><stop offset=".84" stop-color="#858c86"/><stop offset="1" stop-color="#ebede8"/></radialGradient>
        <pattern id="scf-weave" width=".4" height=".4" patternUnits="userSpaceOnUse"><path d="M0 0H.4M0 0V.4" fill="none" stroke="#fff" stroke-opacity=".06" stroke-width=".055"/><path d="M.2 0V.4" fill="none" stroke="#000" stroke-opacity=".04" stroke-width=".055"/></pattern>
        <pattern id="scf-cedar" width="65" height="5.5" patternUnits="userSpaceOnUse"><rect width="65" height="5.5" fill="#b47a40"/><path d="M0 .25H65" stroke="#7b4b28" stroke-width=".25"/><path d="M0 1C18 2 30 .4 65 1.3M0 3.5C20 2.1 45 5 65 3.2" fill="none" stroke="#efc28a" stroke-opacity=".4" stroke-width=".15"/><path d="M0 4.9H65" stroke="#e4ad6b" stroke-width=".2"/></pattern>
        <filter id="scf-shadow" x="-30%" y="-100%" width="160%" height="300%"><feGaussianBlur stdDeviation="9"/></filter>
      </defs>`;
      let drawing=`<ellipse cx="${(4.8*w-3*d)/2}" cy="${-d*.45}" rx="${(4.8*w+3*d)*.5}" ry="35" fill="#3d382c" opacity=".13" filter="url(#scf-shadow)"/>`;
      drawing+=`<g transform="${left}"><rect width="${d}" height="${h}" fill="url(#scf-side)"/><rect width="${d}" height="${h}" fill="url(#scf-weave)"/><path d="M1 1V${h-1}H${d-1}V1" fill="none" stroke="${rgb(side,.60)}" stroke-width=".22"/><path d="M1.5 ${h-2}H${d-1.5}" stroke="${rgb(side,1,30)}" stroke-width=".18" stroke-dasharray=".45 .35"/></g>`;
      drawing+=`<g transform="${front}">`;
      if(!rear&&!closed){
        const dw=Math.min(w*.9,state.actualDoorWidth || w*.39),dx=(w-dw)/2;
        // Keep the photographed door header below the lowest fabric edge.
        // Its top jamb starts 32 pixels down in the 1254-pixel source photo.
        const lowestFabric=Math.max(hem+(wavy?2.5:0),upgrade?0:doorTop+1.3);
        const photoHeader=lowestFabric+doorClearance;
        const photoY=(photoHeader-h*(32/1254))/(1-32/1254);
        const photoHeight=h-photoY;
        const part=(x,width,vx,vw)=>`<svg x="${x}" y="${photoY}" width="${width}" height="${photoHeight}" viewBox="${vx} 0 ${vw} 1254" preserveAspectRatio="none" overflow="hidden"><image href="${saunaURL}" width="1254" height="1254"/></svg>`;
        drawing+=`<rect data-sc-door-header-backing width="${w}" height="${photoY+.1}" fill="url(#scf-cedar)"/>`;
        if(upgrade){
          drawing+=`<image data-sc-single-door-photo="true" href="${saunaURL}" x="0" y="${photoY}" width="${w}" height="${photoHeight}" preserveAspectRatio="none"/>`;
        } else drawing+=part(0,dx,0,385)+part(dx,dw,385,485)+part(dx+dw,w-dx-dw,870,384);
      }
      if (rear || closed) drawing+=`<rect width="${w}" height="${h-1}" fill="url(#scf-front)"/><rect width="${w}" height="${h-1}" fill="url(#scf-weave)"/>`;
      else {
        drawing+=`<path d="M0 0H${w}V${hem}H${w-inset}V${h-1}H${w}V0H${inset}V${h}H0Z" fill="url(#scf-front)"/>`;
        drawing+=`<rect width="${inset}" height="${h}" fill="url(#scf-weave)"/><rect x="${w-inset}" width="${inset}" height="${h-1}" fill="url(#scf-weave)"/>`;
      }
      if(!rear&&!closed) drawing+=`<path d="M${inset+.32} ${doorTop}V${h-1}M${w-inset-.32} ${doorTop}V${h-1}" fill="none" stroke="#181c18" stroke-opacity=".8" stroke-width=".65"/>`;
      if (!rear && !closed) drawing+=`<path data-sc-exposed-zipper d="M${inset} ${doorTop}V${h-1}M${w-inset} ${doorTop}V${h-1}" fill="none" stroke="#c4c6bb" stroke-width=".45" stroke-dasharray=".35 .3"/>`;
      if (!rear && closed) {
        // Both sewn overlaps open toward the door center, covering the zipper teeth.
        const flapWidth=Math.min(1.25,(w-2*inset)*.18),top=doorTop,bottom=h-1.2,length=bottom-top;
        [[inset,1,'left'],[w-inset,-1,'right']].forEach(([zip,direction,edge])=>{
          const x=offset=>zip+direction*offset;
          const edgeLine=offset=>`M${x(offset)} ${top}C${x(offset+.07)} ${top+length*.24} ${x(offset-.08)} ${top+length*.36} ${x(offset)} ${top+length*.52}S${x(offset+.07)} ${top+length*.83} ${x(offset-.03)} ${bottom}`;
          const outline=edgeLine(flapWidth)+`L${x(-.3)} ${bottom}V${top}Z`;
          drawing+=`<g data-sc-zipper-flap="${edge}" data-sc-flap-direction="inward"><path d="${edgeLine(flapWidth+.17)}" fill="none" stroke="#171a16" stroke-opacity=".24" stroke-width=".38"/><path d="${outline}" fill="url(#scf-flap-fabric)"/><path d="${outline}" fill="url(#scf-weave)"/><path d="${outline}" fill="${rgb(side,1,8)}" opacity=".12"/><path d="${edgeLine(flapWidth)}" fill="none" stroke="${rgb(side,.58)}" stroke-opacity=".65" stroke-width=".13"/><path d="${edgeLine(flapWidth-.15)}M${x(-.16)} ${top}V${bottom}" fill="none" stroke="${rgb(side,1,25)}" stroke-opacity=".7" stroke-width=".11" stroke-dasharray=".4 .28"/></g>`;
        });
      }
      if (!rear && !closed && !upgrade) {
        const rollY=doorTop-4.2;
        drawing+=`<rect x="${inset-.5}" y="${rollY}" width="${w-2*inset+1}" height="5.5" rx="2.7" fill="url(#scf-roll)"/>`;
        [inset+(w-2*inset)*.2,w*.50,inset+(w-2*inset)*.8].forEach(x=>{drawing+=`<g data-sc-natural-tie transform="translate(${x} ${doorTop-2.9+(wavy?.8*(1-Math.cos((1-x/w)*Math.PI*2*Math.max(2,Math.round(w/12)))):0)}) scale(.72)" fill="url(#scf-natural)" stroke="#c2b69d" stroke-width=".13"><path d="M-.65 -1H.65V4.8L.25 6.6H-.6L-.85 4.5Z"/><path d="M0 5C-1.8 2.3-4 3.5-3.7 4.7C-3.3 6.1-1.2 6.1 0 5C1.5 2.9 3.6 3.3 3.8 4.5C3.8 6 1.6 6.1 0 5Z"/><path d="M-.1 5.2L-1.7 9.7L-.5 10.1L.5 5.5Z M.3 5.2L2.4 9.4L3.5 8.8L1 5Z"/></g>`;});
      }
      if (!rear && !closed && upgrade) {
        drawing+=`<rect x="${w-inset-2.5}" y="${doorTop+.8}" width="5" height="${h-doorTop-2}" rx="2.1" fill="url(#scf-front)" stroke="${rgb(side,.58)}" stroke-width=".16"/>`;
        [.24,.54,.84].forEach(t=>{drawing+=`<rect x="${w-inset-2.8}" y="${h*t}" width="5.6" height="1.5" rx=".35" fill="${rgb(side,.96,10)}" stroke="${rgb(side,.60)}" stroke-width=".15"/>`;});
      }
      if (rear && weather!=='v_17270458') {
        const wx=weather==='v_17270459' ? w*.79 : w*.21;
        drawing+=`<g data-sc-weather-position="${weather==='v_17270459'?'left-from-front':'right-from-front'}"><path d="M${wx} 12C${wx-2} 15 ${wx+2} 18 ${wx+1} 21" fill="none" stroke="#202627" stroke-width=".7"/><rect x="${wx-4.5}" y="7" width="9" height="6" rx=".6" fill="url(#scf-front)" stroke="${rgb(side,.53)}" stroke-width=".23"/><path d="M${wx-4} 7.6H${wx+4}V12.4H${wx-4}Z" fill="none" stroke="${rgb(side,1,30)}" stroke-width=".14" stroke-dasharray=".3 .25"/></g>`;
      }
      const positions=(length,frontFace)=>{
        const fixedFront=[inset*.48,length-inset*.48];
        // The two front snaps fasten the stationary fabric beside the door.
        if(snaps==='v_17270462')return frontFace&&!rear ? fixedFront : [length*.2,length*.8];
        if(snaps==='v_17270463')return Array.from({length:Math.max(2,Math.ceil(length/18)+1)},(_,i)=>1.5+i*(length-3)/Math.max(1,Math.ceil(length/18)));
        return frontFace&&!rear ? fixedFront : [];
      };
      const studs=(list,y)=>list.map(x=>`<g data-sc-snap-marker transform="translate(${x} ${y})"><circle r=".78" fill="url(#scf-metal)" stroke="#686d66" stroke-width=".12"/><circle r=".36" fill="#5a615b"/><path d="M-.22 0H.22M0 -.22V.22" stroke="#1b231e" stroke-width=".13"/></g>`).join('');
      drawing+=studs(positions(w,true),h-1.6)+'</g>';
      drawing+=`<g transform="${left}">${studs(positions(d,false),h-1.6)}</g>`;
      if (peaked && roofKind==='hip') {
        const apex=[w/2,d/2,h+peak];
        drawing+=fabric(poly([[0,d,h],[w,d,h],apex]),'url(#scf-roof)');
        drawing+=fabric(poly([[0,0,h],[0,d,h],apex]),'url(#scf-roof)');
        drawing+=fabric(poly([[w,0,h],[w,d,h],apex]),'url(#scf-roof)');
        drawing+=fabric(poly([[0,0,h],[w,0,h],apex]),'url(#scf-roof)','stroke="'+rgb(roof,.7)+'" stroke-width=".6"');
      } else if(peaked && roofKind==='sloped') {
        const edge=state.slopeEdge || 'rear';
        const rise=(x,y)=>edge==='front'?(1-y/d)*peak:edge==='left'?(1-x/w)*peak:edge==='right'?x/w*peak:y/d*peak;
        const a=[0,0,h+rise(0,0)],b=[w,0,h+rise(w,0)],c=[w,d,h+rise(w,d)],e=[0,d,h+rise(0,d)];
        drawing+=fabric(poly([[0,0,h],[0,d,h],e,a]),'url(#scf-side)');
        drawing+=fabric(poly([[0,0,h],[w,0,h],b,a]),'url(#scf-front)');
        drawing+=fabric(poly([e,c,b,a]),'url(#scf-roof)','stroke="'+rgb(roof,.7)+'" stroke-width=".6"');
      } else if (peaked) {
        drawing+=fabric(poly([[0,0,h],[w/2,0,h+peak],[w,0,h]]),'url(#scf-front)');
        drawing+=fabric(poly([[0,d,h],[w/2,d,h+peak],[w/2,0,h+peak],[0,0,h]]),'url(#scf-roof)','stroke="'+rgb(roof,.7)+'" stroke-width=".8"');
        drawing+=fabric(poly([[w/2,d,h+peak],[w,d,h],[w,0,h],[w/2,0,h+peak]]),'url(#scf-roof)');
      } else drawing+=fabric(poly([[0,d,h],[w,d,h],[w,0,h],[0,0,h]]),'url(#scf-roof)');
      // A wrapped valance is one closed path. There is deliberately no join at either corner.
      const wave=(length,n,map)=>Array.from({length:n+1},(_,i)=>{
        const t=i/n; return map(length*(1-t),hem+(wavy ? 1.25*(1-Math.cos(t*Math.PI*2*Math.max(2,Math.round(length/12)))) : 0));
      });
      if (!rear) {
        let points=wrap?[[0,d,h],[0,0,h],[w,0,h]]:[[0,0,h],[w,0,h]];
        points=points.concat(wave(w,80,(x,drop)=>[x,0,h-drop]));
        if(wrap) points=points.concat(wave(d,60,(y,drop)=>[0,d-y,h-drop]));
        const outline=poly(points);
        drawing+=fabric(outline,'url(#scf-valance)','data-sc-valance="'+(wrap?'continuous-three-sides':'front-only')+'" stroke="'+rgb(side,.73)+'" stroke-width=".65" stroke-linejoin="round"');
      } else if(wrap) {
        const points=[[0,d,h],[0,0,h],...wave(d,70,(y,drop)=>[0,d-y,h-drop])];
        drawing+=fabric(poly(points),'url(#scf-valance)','stroke="'+rgb(side,.7)+'" stroke-width=".65"');
      }
      stage.innerHTML=`<svg viewBox="${minX} ${minY} ${maxX-minX} ${50-minY}" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="scf-svg-title"><title id="scf-svg-title"></title>${defs}${drawing}</svg>`;
      stage.querySelector('title').textContent=copy.image_title+' — '+copy[view];
      dialog.querySelector('[data-sc-view-note]').textContent=rear ? (weather==='v_17270458'?copy.no_slot:weather==='v_17270459'?copy.left_slot:copy.right_slot) : closed ? (upgrade?copy.closed_upgrade:copy.closed_standard) : !upgrade ? copy.natural : copy.side_roll;
      dialog.querySelector('[data-sc-size-note]').textContent=state.corner ? copy.corner_size : state.width&&state.depth&&state.height ? copy.dimensions_used : copy.sample_size;
      dialog.querySelector('[data-sc-snap-note]').textContent=copy[snaps==='v_17270461'?'snap_standard':snaps==='v_17270462'?'snap_two':'snap_spacing'];
      dialog.querySelectorAll('[data-sc-final-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.scFinalView===view)));
    };
    const refresh = () => {
      pending=false;
      if (!option('roof')) return;
      panel.hidden=false;
      const required=['roof','valance','door','weather','snaps','sideColor','roofColor'];
      const selectionMissing=required.filter(key=>!selected(key)).map(label);
      const side=color('sideColor'), roof=color('roofColor');
      const dimensions=Object.fromEntries(['width','depth','height'].map(key=>[key,validDimension(key)]));
      const visibleDimensions=Object.entries(dimensions).filter(([, detail])=>detail.visible);
      const model=modelSelection();
      const dimensionMissing=visibleDimensions.filter(([, detail])=>!detail.valid).map(([key])=>label(key));
      const hasActualDimensions=visibleDimensions.length===3&&dimensionMissing.length===0;
      const derivedDimensions=dimensionMissing.length===0 ? model.dimensions : null;
      const illustrative=!hasActualDimensions&&!derivedDimensions&&Boolean(model.label);
      const customMissing=customCompletion();
      const missing=[...selectionMissing,...dimensionMissing,...customMissing];
      if (!hasActualDimensions&&!derivedDimensions&&!illustrative) missing.push('Sauna company / model');
      const valanceText=selectedText('valance'), doorText=selectedText('door'), weatherText=selectedText('weather'), snapText=selectedText('snaps'), roofText=selectedText('roof');
      const features={
        wrap:/side/.test(valanceText) && !/(no\s*valance|none|front\s*only)/.test(valanceText),
        wavy:/wavy|scallop/.test(valanceText),
        upgrade:/upgrade/.test(doorText),
        weather:/(do\s*not|none|no\s*weather|without)/.test(weatherText) ? 'none' : /left/.test(weatherText) ? 'left' : 'right',
        snaps:/\b18\b|every\s*18|spacing/.test(snapText) ? 'spacing' : /\btwo\b|2\s*(per|on|snap)/.test(snapText) ? 'two' : 'standard'
      };
      const customRendererValues={
        valance:features.wavy ? 'v_17270454' : 'v_17270455',
        door:features.upgrade ? 'v_17270457' : 'v_17270456',
        weather:features.weather==='none' ? 'v_17270458' : features.weather==='left' ? 'v_17270459' : 'v_17270460',
        snaps:features.snaps==='two' ? 'v_17270462' : features.snaps==='spacing' ? 'v_17270463' : 'v_17270461'
      };
      const ready=missing.length===0&&!!side&&!!roof;
      const doorOpening = document.getElementById('sc-door-opening');
      const doorMode = doorOpening?.selectedOptions?.[0]?.dataset.mode || '';
      const openingWidth = Number(document.getElementById('sc-opening-width')?.value) || null;
      const actualDoorWidth = doorMode === 'narrow' && openingWidth ? Math.max(0, openingWidth - 4) : null;
      const peaked=/peaked/i.test(roofText);
      const roofKind=peaked ? document.getElementById('sc-roof-type')?.value || 'gable' : 'flat';
      const roofValue=id=>{
        const field=document.getElementById('sc-measure-'+id);
        if(!field||field.disabled)return null;
        const s=field.value.trim(),mixed=s.match(/^(\d+)\s+(\d+)\/(\d+)$/),fraction=s.match(/^(\d+)\/(\d+)$/);
        const value=mixed ? +mixed[1]+ +mixed[2]/+mixed[3] : fraction ? +fraction[1]/+fraction[2] : Number(s);
        return Number.isFinite(value)&&value>0 ? value : null;
      };
      const slopeEdge=document.getElementById('sc-slope-edge')?.value || 'rear';
      const peakRise=roofKind==='gable' ? roofValue('G4') : roofKind==='sloped'&&roofValue('S3')&&roofValue('S4') ? Math.abs(roofValue('S3')-roofValue('S4')) : null;
      state={
        ready,
        side,
        roof,
        peaked,
        valance:customRendererValues.valance,
        door:customRendererValues.door,
        weather:customRendererValues.weather,
        snaps:customRendererValues.snaps,
        width:dimensions.width.value || derivedDimensions?.width || 60,
        depth:dimensions.depth.value || derivedDimensions?.depth || 50,
        height:dimensions.height.value || derivedDimensions?.height || 80,
        illustrative,
        modelLabel:model.label,
        corner:model.corner,
        roofKind,
        doorMode,
        openingWidth,
        actualDoorWidth,
        peakRise,
        slopeEdge
      };
      if(state.roofKind==='gable'){
        state.width=roofValue('G13')||state.width;
        state.depth=roofValue('G9')||state.depth;
        state.height=roofValue('G7')||state.height;
      }
      if(state.roofKind==='hip'){
        state.width=roofValue('H8')||state.width;
        state.depth=roofValue('H7')||state.depth;
        state.height=roofValue('H1')||state.height;
      }
      if(state.roofKind==='sloped'){
        state.width=roofValue('S2')||state.width;
        state.depth=roofValue('S1')||state.depth;
        state.height=Math.min(roofValue('S3')||state.height,roofValue('S4')||state.height);
      }
      const rows=[...summary.querySelectorAll('.sc-summary-lines > div')].map(row=>[row.querySelector('dt')?.textContent || '',row.querySelector('dd')?.textContent || '']);
      const total=summary.querySelector('[data-sc-total]')?.textContent || '';
      const next=JSON.stringify({state,rows,total,missing});
      if (next===signature) return;
      signature=next;
      button.disabled=!ready;
      status.textContent=ready?copy.ready:missing.length ? copy.missing+' '+missing.join(', ')+'.':copy.color_unknown;
      dialog.querySelector('[data-sc-final-total]').textContent=total;
      const list=dialog.querySelector('[data-sc-final-list]');
      list.replaceChildren(...rows.map(([name,value])=>{const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=name;dd.textContent=value;row.append(dt,dd);return row;}));
      const weatherDetail=dialog.querySelector('[data-sc-final-weather-detail]');
      weatherDetail.hidden=state.weather==='v_17270458';
      if(dialog.open) render();
    };
    const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(refresh);};
    button.addEventListener('click',async()=>{refresh();if(!state?.ready)return;view=previewConfig.defaultView;render();dialog.showModal();try{await loadMaterials();render();}catch(error){stage.textContent=copy.image_error;}});
    dialog.querySelector('[data-sc-final-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelectorAll('[data-sc-final-view]').forEach(b=>b.addEventListener('click',()=>{view=b.dataset.scFinalView;render();}));
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();});
    product.addEventListener('input',schedule);
    product.addEventListener('change',schedule);
    product.addEventListener('sc:colors',schedule);
    product.addEventListener('sc:shared-colors',schedule);
    product.addEventListener('sc:custom-options',schedule);
    new MutationObserver(ms=>{if(ms.some(m=>!panel.contains(m.target)&&!dialog.contains(m.target)))schedule();}).observe(product,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','style','disabled','checked']});
    refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-shared-online-options"] && !Shopify.designMode) return;
  try {
    (() => {
  const sharedHandles=new Set(['thermal-cover','insulated-thermal-sauna-cover','sauna-cover-with-thermal-cover','dust-cover','sauna-roof-only-cover','all-in-one-cover','custom-barrel-sauna-cover','sauna-cover-clearlight-saunas','sauna-cover-finnmark-designs','sauna-cover-golden-designs','sauna-cover-health-mate-saunas','sauna-cover-medical-saunas','sauna-cover-sunlighten']);
  const start=()=>{
    const product=document.getElementById('ProductSection'),roofPanel=document.getElementById('sc-online-roof'),doorPanel=document.getElementById('sc-door-width');
    if(!sharedHandles.has(roofPanel?.dataset.scSharedProductHandle))return;
    if(!product||!roofPanel||!doorPanel||roofPanel.dataset.initialized)return;
    const form=product.querySelector('form[action="/cart/add"]');if(!form)return;
    roofPanel.dataset.initialized='true';
    const copy=Object.fromEntries([...product.querySelectorAll('[data-sc-custom-copy]')].map(t=>[t.dataset.scCustomCopy,t.content.textContent.trim()]));
    const normalize=text=>String(text||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    const headingKey=text=>normalize(text).replace(/\bnone$/,'').trim();
    const isVisible=element=>Boolean(element&&!element.closest('[hidden]')&&element.getClientRects().length&&getComputedStyle(element).visibility!=='hidden');
    const optionByHeading=heading=>[...product.querySelectorAll('.mw-option')].find(option=>headingKey(option.querySelector('.mw-text--style-strong')?.textContent)===headingKey(heading))||null;
    const modelWidth=text=>{const match=String(text||'').match(/(\d+(?:\.\d+)?)\s*(?:["”″]|in(?:ches)?)\s*w\b/i);return match?Number(match[1]):NaN;};
    let roofOption=null,doorOption=null,uploadOption=null,widthOption=null,modelChoice=null,modelSelectedWidth=NaN,roofChoice=null,doorChoice=null,actualWidth=null,uploader=null,worksheetAvailable=false,doorAvailable=false;
    const resolveOptions=()=>{
      roofOption=optionByHeading('Flat or Peaked Roof');
      doorOption=optionByHeading('Door Style Choice')||optionByHeading('Door');
      uploadOption=optionByHeading('Attach Filled in Peaked Roof Dimension Sheet (Find Blank Sheet Below)');
      widthOption=[...product.querySelectorAll('.mw-option')].find(option=>/^(?:dimensions )?width (?:inches|in)\b/.test(headingKey(option.querySelector('.mw-text--style-strong')?.textContent)))||null;
      roofChoice=roofOption?.querySelector('select')||null;
      doorChoice=doorOption?.querySelector('select')||null;
      actualWidth=widthOption?.querySelector('input[type="text"]')||null;
      modelChoice=[...product.querySelectorAll('.mw-option select')].find(select=>isVisible(select.closest('.mw-option'))&&Number.isFinite(modelWidth(selectedText(select))))||null;
      modelSelectedWidth=modelWidth(selectedText(modelChoice));
      uploader=uploadOption||null;
      worksheetAvailable=Boolean(roofChoice&&uploader&&isVisible(roofOption)&&isVisible(uploader));
      doorAvailable=Boolean(doorChoice&&isVisible(doorOption)&&((actualWidth&&isVisible(widthOption))||Number.isFinite(modelSelectedWidth)));
    };
    const disablePanel=panel=>panel.querySelectorAll('input,select,button').forEach(field=>{field.disabled=true;field.required=false;field.setCustomValidity?.('');});
    const kind=document.getElementById('sc-roof-type'),method=document.getElementById('sc-roof-method'),door=document.getElementById('sc-door-opening'),doorWidth=document.getElementById('sc-front-door-width'),openingWidth=document.getElementById('sc-opening-width');
    const attach=roofPanel.querySelector('[data-sc-attach-roof]'),status=roofPanel.querySelector('[data-sc-attach-status]'),download=roofPanel.querySelector('[data-sc-roof-download]');
    let attachedSignature='',currentFile='',preparedSignature='',busy=false,scheduled=false,downloadURL='',lastSignature='';
    const selectedText=select=>select?.selectedOptions?.[0]?.textContent||'';
    const peaked=()=>worksheetAvailable&&/\bpeaked\s*roof\b/i.test(selectedText(roofChoice));
    const standard=()=>doorAvailable&&/\bstandard(?:\s+front)?\s+door\b/i.test(selectedText(doorChoice));
    const mode=()=>door.selectedOptions[0]?.dataset.mode||'';
    const number=raw=>{const s=raw.trim().replace(/[”″"]/g,'').replace(/\s*(inches|inch|in)\.?$/i,'').trim();const m=s.match(/^(\d+)\s+(\d+)\/(\d+)$/),f=s.match(/^(\d+)\/(\d+)$/);const n=m?+m[1]+ +m[2]/+m[3]:f?+f[1]/+f[2]:/^\d+(\.\d+)?$/.test(s)?Number(s):NaN;return Number.isFinite(n)&&n>=0&&n<=600?n:NaN;};
    const clean=n=>String(Math.round(n*10000)/10000);
    const quarterIncrement=n=>Number.isFinite(n)&&Math.abs(n*4-Math.round(n*4))<1e-8;
    const quarterError=zeroAllowed=>zeroAllowed?'Enter zero or a positive measurement in ¼-inch increments.':'Enter a positive measurement in ¼-inch increments.';
    const fields=()=>[...roofPanel.querySelectorAll('[data-sc-measure]')].filter(f=>!f.disabled);
    const stamp=()=>JSON.stringify([kind.value,document.getElementById('sc-slope-edge')?.value,fields().map(f=>[f.dataset.scMeasure,f.value.trim()])]);
    const validMeasure=f=>{const n=number(f.value);return quarterIncrement(n)&&(f.dataset.scZero==='true'?n>=0:n>0);};
    const measureError=f=>f.value.trim()?quarterError(f.dataset.scZero==='true'):copy.required;
    const slopeValid=()=>kind.value!=='sloped'||!!document.getElementById('sc-slope-edge')?.value;
    const completed=()=>!!kind.value&&slopeValid()&&fields().every(validMeasure);
    const setDisabled=(el,disabled)=>{if(el.disabled!==disabled)el.disabled=disabled;};
    const refresh=()=>{
      scheduled=false;
      resolveOptions();
      if(!worksheetAvailable){roofPanel.hidden=true;disablePanel(roofPanel);}
      if(!doorAvailable){doorPanel.hidden=true;disablePanel(doorPanel);}
      const upload=uploader,originalDoor=doorOption;
      if(worksheetAvailable&&upload&&roofPanel.nextElementSibling!==upload)upload.before(roofPanel);
      if(doorAvailable&&originalDoor&&originalDoor.nextElementSibling!==doorPanel)originalDoor.after(doorPanel);
      const currentUpload=currentFile&&upload ? [...upload.querySelectorAll('.filepond--item')].find(item=>item.textContent.includes(currentFile)) : null;
      if(currentUpload?.getAttribute('data-filepond-item-state')==='processing-complete'&&preparedSignature)attachedSignature=preparedSignature;
      if(attachedSignature&&!busy&&!currentUpload)attachedSignature='';
      const online=worksheetAvailable&&peaked()&&method.value==='online';roofPanel.hidden=!worksheetAvailable||!peaked();doorPanel.hidden=!doorAvailable||!standard();
      setDisabled(method,!worksheetAvailable||!peaked());
      roofPanel.querySelector('[data-sc-roof-online]').hidden=!online;setDisabled(kind,!online);kind.required=online;
      roofPanel.querySelectorAll('[data-sc-pick-roof],[data-sc-expand-page]').forEach(button=>setDisabled(button,!online));
      setDisabled(attach,!online||busy);
      roofPanel.querySelectorAll('[data-sc-roof-fields]').forEach(group=>{const enabled=online&&group.dataset.scRoofFields===kind.value;group.hidden=!enabled;group.querySelectorAll('input,select').forEach(f=>{setDisabled(f,!enabled);f.required=enabled;if(!enabled)f.setCustomValidity('');});});
      roofPanel.querySelectorAll('[data-sc-pick-roof]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.scPickRoof===kind.value)));
      setDisabled(door,!standard());door.required=standard();const narrow=doorAvailable&&standard()&&mode()==='narrow';doorPanel.querySelector('[data-sc-door-measure]').hidden=!narrow;setDisabled(doorWidth,!narrow);setDisabled(openingWidth,!narrow);doorWidth.required=narrow;
      doorWidth.setCustomValidity('');const dw=number(doorWidth.value);const enteredWidth=number(actualWidth?.value||'');const actual=Number.isFinite(enteredWidth)&&enteredWidth>0?enteredWidth:modelSelectedWidth;
      const allowed=narrow&&quarterIncrement(dw)&&dw>0&&Number.isFinite(actual)&&actual>0&&dw+4<=actual;
      if(narrow&&doorWidth.value.trim()&&!allowed)doorWidth.setCustomValidity(quarterIncrement(dw)&&dw>0?copy.width_error:quarterError(false));
      openingWidth.value=allowed?clean(dw+4):'';doorPanel.querySelector('[data-sc-door-result]').textContent=allowed?`${copy.opening}: ${clean(dw+4)} ${copy.unit_short} (${clean(dw)} + 2 + 2)` : '';
      const examples=doorPanel.querySelector('.sc-door-examples');if(examples){if(mode())examples.dataset.selected=mode();else delete examples.dataset.selected;examples.querySelectorAll('[data-sc-door-example]').forEach(f=>f.hidden=!!mode()&&f.dataset.scDoorExample!==mode());}
      if(!busy&&online){const unchanged=attachedSignature&&attachedSignature===stamp();status.textContent=unchanged?copy.attached:attachedSignature?copy.changed:copy.pending;attach.textContent=attachedSignature?copy.update:copy.attach;}
      roofPanel.dataset.complete=String(!worksheetAvailable||!peaked()||method.value==='manual'||(completed()&&attachedSignature===stamp()));
      doorPanel.dataset.complete=String(!doorAvailable||!standard()||!!mode()&&(mode()==='full'||allowed));
      const sig=JSON.stringify([worksheetAvailable,peaked(),method.value,kind.value,fields().map(f=>f.value),doorAvailable,standard(),mode(),doorWidth.value,openingWidth.value,roofPanel.dataset.complete]);
      if(sig!==lastSignature){lastSignature=sig;product.dispatchEvent(new CustomEvent('sc:custom-options'));}
    };
    const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(refresh);};
    // A small native PDF writer keeps the completed worksheet local until the customer attaches it.
    const pdfEscape=s=>String(s).replace(/[^\x20-\x7e]/g,'-').replace(/([\\()])/g,'\\$1');
    const makePDF=async()=>{
      const active=fields(),pages=[...new Set(active.map(f=>f.dataset.scPage))];
      const objs=[null,'<< /Type /Catalog /Pages 2 0 R >>','', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>'];const pageIds=[];
      const add=o=>{objs.push(o);return objs.length-1;};
      const stream=s=>`<< /Length ${s.length} >>\nstream\n${s}\nendstream`;
      const text=(x,y,size,s)=>`BT /F1 ${size} Tf ${x} ${y} Td (${pdfEscape(s)}) Tj ET\n`;
      const addPage=(content,resources='')=>{const c=add(stream(content));const id=add(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 960 540] /Resources << /Font << /F1 3 0 R >> ${resources} >> /Contents ${c} 0 R >>`);pageIds.push(id);};
      let summary='0.08 0.18 0.25 rg\n'+text(45,494,22,copy.pdf_title)+text(45,466,14,kind.selectedOptions[0].textContent)+text(45,443,10,copy.pdf_note)+text(45,425,10,'Prepared '+new Date().toISOString().slice(0,10)+(kind.value==='sloped'?' | High edge: '+document.getElementById('sc-slope-edge').selectedOptions[0].textContent:''));
      active.forEach((f,i)=>{const col=i>=10?1:0,row=i%10;summary+=text(45+col*460,389-row*31,11,`${f.dataset.scMeasure}  ${f.dataset.scLabel}: ${f.value.trim()} in`);});
      addPage(summary);
      for(const page of pages){
        const diagram=roofPanel.querySelector(`[data-sc-sheet-page="${page}"]`),img=diagram.querySelector('img');
        const response=await fetch(img.currentSrc||img.src,{credentials:'omit'});if(!response.ok)throw new Error('Diagram unavailable');
        const bytes=new Uint8Array(await response.arrayBuffer());let jpeg='';for(let offset=0;offset<bytes.length;offset+=8192)jpeg+=String.fromCharCode(...bytes.subarray(offset,offset+8192));
        const imageId=add(`<< /Type /XObject /Subtype /Image /Width 1536 /Height 864 /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpeg.length} >>\nstream\n${jpeg}\nendstream`);
        let content='q 960 0 0 540 0 0 cm /Sheet Do Q\n';
        active.filter(f=>f.dataset.scPage===page).forEach(f=>{const x=Number(f.dataset.scX)*.625,y=540-Number(f.dataset.scY)*.625;const label=`${f.dataset.scMeasure}: ${f.value.trim()}`;const width=Math.max(page==='3'?77:49,label.length*5.3+9);content+=`1 1 1 rg ${x-width/2} ${y-7} ${width} 17 re f\n0.05 0.2 0.38 rg\n`+text(x-width/2+4,y-2,9,label);});
        addPage(content,`/XObject << /Sheet ${imageId} 0 R >>`);
      }
      objs[2]=`<< /Type /Pages /Kids [${pageIds.map(id=>id+' 0 R').join(' ')}] /Count ${pageIds.length} >>`;
      let output='%PDF-1.4\n%\xE2\xE3\xCF\xD3\n';const offsets=[0];for(let i=1;i<objs.length;i++){offsets.push(output.length);output+=`${i} 0 obj\n${objs[i]}\nendobj\n`;}
      const xref=output.length;output+=`xref\n0 ${objs.length}\n0000000000 65535 f \n`+offsets.slice(1).map(o=>String(o).padStart(10,'0')+' 00000 n \n').join('')+`trailer\n<< /Size ${objs.length} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`;
      return new Blob([Uint8Array.from(output,c=>c.charCodeAt(0))],{type:'application/pdf'});
    };
    const validateRoof=()=>{kind.setCustomValidity(kind.value?'':copy.required);const invalid=!kind.value?kind:!slopeValid()?document.getElementById('sc-slope-edge'):fields().find(f=>!validMeasure(f));if(invalid){invalid.setCustomValidity(invalid.dataset?.scMeasure?measureError(invalid):copy.required);invalid.reportValidity();return false;}return true;};
    attach.addEventListener('click',async()=>{
      refresh();if(busy||!validateRoof())return;busy=true;attach.disabled=true;status.textContent=copy.uploading;const targetStamp=stamp();
      try{
        const blob=await makePDF();if(targetStamp!==stamp())throw new Error('Measurements changed');
        if(downloadURL)URL.revokeObjectURL(downloadURL);downloadURL=URL.createObjectURL(blob);currentFile=`Sauna-roof-${kind.value}-${Date.now()}.pdf`;preparedSignature=targetStamp;download.href=downloadURL;download.download=currentFile;download.hidden=false;
        const input=uploader?.querySelector('input[type=file]');if(!input)throw new Error('Uploader unavailable');
        const transfer=new DataTransfer();transfer.items.add(new File([blob],currentFile,{type:'application/pdf'}));input.files=transfer.files;
        if(!uploader)throw new Error('Uploader unavailable');
        await new Promise((resolve,reject)=>{
          const timeout=setTimeout(()=>finish(new Error('Upload timeout')),60000);
          const observer=new MutationObserver(()=>{const item=[...uploader.querySelectorAll('.filepond--item')].find(i=>i.textContent.includes(currentFile));if(!item)return;const state=item.getAttribute('data-filepond-item-state');if(state==='processing-complete')finish();else if(state?.includes('error'))finish(new Error('Upload failed'));});
          const finish=error=>{clearTimeout(timeout);observer.disconnect();error?reject(error):resolve();};
          observer.observe(uploader,{subtree:true,childList:true,attributes:true,attributeFilter:['data-filepond-item-state']});
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
        attachedSignature=targetStamp;
      }catch(error){status.textContent=copy.failed;}finally{busy=false;attach.disabled=false;const failed=status.textContent===copy.failed;refresh();if(failed)status.textContent=copy.failed;}
    });
    const guard=event=>{
      if(event.type==='click'){const button=event.target.closest?.('button[name=add],input[name=add]');if(!button||!product.contains(button))return;}
      if(event.type==='submit'&&event.target!==form)return;
      refresh();let invalid=null;
      if(doorAvailable&&standard()){if(!door.value)invalid=door;else if(mode()==='narrow'&&(!openingWidth.value||!doorWidth.checkValidity()))invalid=doorWidth;}
      if(!invalid&&worksheetAvailable&&peaked()&&method.value==='online'){
        if(!kind.value)invalid=kind;else if(!slopeValid())invalid=document.getElementById('sc-slope-edge');else invalid=fields().find(f=>!validMeasure(f));
        if(!invalid&&(busy||attachedSignature!==stamp())){event.preventDefault();event.stopImmediatePropagation();status.textContent=copy.upload_required;attach.focus();attach.scrollIntoView({block:'center',behavior:'smooth'});return;}
      }
      if(invalid){event.preventDefault();event.stopImmediatePropagation();if(!invalid.validationMessage)invalid.setCustomValidity(invalid.dataset?.scMeasure?measureError(invalid):copy.required);invalid.reportValidity();}
    };
    // Check conditional fields before the options app intercepts the cart button.
    window.addEventListener('click',guard,true);window.addEventListener('submit',guard,true);
    product.addEventListener('input',e=>{if(e.target.matches('[data-sc-measure],#sc-front-door-width,#sc-door-opening,#sc-roof-type,#sc-slope-edge'))e.target.setCustomValidity('');schedule();});
    product.addEventListener('change',e=>{if(e.target.matches('#sc-door-opening,#sc-roof-type,#sc-slope-edge'))e.target.setCustomValidity('');schedule();});
    product.addEventListener('FilePond:removefile',()=>{if(attachedSignature&&!uploader?.textContent.includes(currentFile)){attachedSignature='';schedule();}});
    roofPanel.querySelectorAll('[data-sc-pick-roof]').forEach(b=>b.addEventListener('click',()=>{kind.value=b.dataset.scPickRoof;kind.dispatchEvent(new Event('change',{bubbles:true}));}));
    const diagramDialog=document.getElementById('sc-roof-diagram-dialog');roofPanel.querySelectorAll('[data-sc-expand-page]').forEach(b=>b.addEventListener('click',()=>{diagramDialog.querySelector('[data-sc-large-diagram]').replaceChildren(roofPanel.querySelector(`[data-sc-sheet-page="${b.dataset.scExpandPage}"]`).cloneNode(true));diagramDialog.querySelectorAll('img').forEach(img=>img.loading='eager');diagramDialog.showModal();}));diagramDialog.querySelector('[data-sc-close-diagram]').addEventListener('click',()=>diagramDialog.close());
    new MutationObserver(ms=>{if(ms.some(m=>!roofPanel.contains(m.target)&&!doorPanel.contains(m.target)&&!m.target.closest?.('#sc-build-summary,#sc-final-dialog,#sc-final-preview')))schedule();}).observe(product,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style']});
    refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-shared-option-photos"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const source = document.getElementById('sc-shared-option-photo-templates');
    const product = document.getElementById('ProductSection');
    const dialog = document.getElementById('sc-shared-option-photo-dialog');
    if (!source || !product || !dialog || source.dataset.initialized) return;
    source.dataset.initialized = 'true';

    const supportedHandles = new Set(['sauna-cover-with-thermal-cover', 'dust-cover', 'sauna-roof-only-cover', 'all-in-one-cover', 'copy-of-sauna-cover-rocky-mountain-saunas', 'sauna-cover-clearlight-saunas', 'sauna-cover-finnmark-designs', 'sauna-cover-golden-designs', 'sauna-cover-health-mate-saunas', 'sauna-cover-medical-saunas', 'sauna-cover-sunlighten']);
    if (!supportedHandles.has(source.dataset.productHandle)) return;
    const exactLabels = new Map([
      ['valance style choice', 'valance'],
      ['door style choice', 'door'],
      ['weather slot for the power cord', 'weather'],
      ['snaps for wind (bottom of cover)', 'snaps']
    ]);
    const normalize = value => (value || '').replace(/\s+/g, ' ').replace(/[:*]/g, '').trim().toLowerCase();
    const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const labelFor = select => {
      const forLabel = select.id ? document.querySelector(`label[for="${select.id}"]`) : null;
      const container = select.closest('.mw-option') || select.closest('fieldset') || select.parentElement;
      return normalize(container?.querySelector('.mw-label .mw-text--style-strong, legend, .mw-option-title, .mw-option-label')?.textContent || forLabel?.textContent || select.getAttribute('aria-label'));
    };
    const outer = select => select.closest('.mw-option') || select.closest('fieldset') || select.parentElement;
    const selectedText = select => normalize(select.selectedOptions?.[0]?.textContent || '');
    const noChoice = (select, text) => !select.value || /(?:please\s+select|do\s+not|no\s+weather|without|not\s+included|^none$|^no\b)/.test(text);
    const templates = new Map([...source.querySelectorAll('template[data-sc-shared-kind]')].map(template => [template.dataset.scSharedKind, template]));

    const update = (select, panel) => {
      const value = selectedText(select);
      const cards = [...panel.querySelectorAll('.sc-shared-option-photo-card')];
      cards.forEach(card => {
        const selected = card.dataset.scSharedMatch === 'selected'
          ? Boolean(value) && !noChoice(select, value)
          : panel.dataset.scSharedKind === 'valance'
            ? value.includes(card.dataset.scSharedStyle) && card.dataset.scSharedLocation === (value.includes('both sides') ? 'side' : 'front')
            : value.includes(card.dataset.scSharedMatch);
        card.hidden = !selected;
        card.classList.toggle('is-selected', selected);
      });
      panel.hidden = !cards.some(card => !card.hidden);
    };
    const mount = () => {
      [...product.querySelectorAll('select')].forEach(select => {
        if (!visible(select)) return;
        const kind = exactLabels.get(labelFor(select));
        const option = outer(select);
        if (!kind || !option) return;
        let panel = option.querySelector(':scope > .sc-shared-option-photos');
        if (!panel) {
          const template = templates.get(kind);
          if (!template) return;
          const fragment = template.content.cloneNode(true);
          panel = fragment.querySelector('.sc-shared-option-photos');
          panel.dataset.scSharedKind = kind;
          option.append(fragment);
        }
        update(select, panel);
      });
    };
    let pending = false;
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; mount(); });
    };
    product.addEventListener('change', event => {
      const select = event.target.closest('select');
      const panel = select && outer(select)?.querySelector(':scope > .sc-shared-option-photos');
      if (panel) update(select, panel);
      else schedule();
    });
    new MutationObserver(mutations => {
      const externalChange = mutations.some(mutation => {
        if (mutation.target.closest?.('.sc-shared-option-photos')) return false;
        if (mutation.type === 'attributes') return true;
        return [...mutation.addedNodes].some(node => node.nodeType === 1 && !node.matches?.('.sc-shared-option-photos') && !node.closest?.('.sc-shared-option-photos'));
      });
      if (externalChange) schedule();
    }).observe(product, { childList:true, subtree:true, attributes:true, attributeFilter:['class','style','disabled'] });
    product.addEventListener('click', event => {
      const button = event.target.closest('.sc-shared-option-photo-open');
      if (!button) return;
      const card = button.closest('.sc-shared-option-photo-card');
      const image = button.querySelector('img').cloneNode(true);
      image.loading = 'eager';
      dialog.querySelector('h2').textContent = card.querySelector('strong').textContent;
      dialog.querySelector('[data-sc-shared-photo-expanded]').replaceChildren(image);
      dialog.showModal();
    });
    dialog.querySelector('[data-sc-shared-photo-close]').addEventListener('click', () => dialog.close());
    mount();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-thermal-door-option-photo"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const source = document.getElementById('sc-thermal-door-photo-template');
    const product = document.getElementById('ProductSection');
    const dialog = document.getElementById('sc-thermal-door-photo-dialog');
    if (!source || !product || !dialog || source.dataset.initialized) return;
    source.dataset.initialized = 'true';
    const supported = new Set(['thermal-cover', 'insulated-thermal-sauna-cover']);
    if (!supported.has(source.dataset.productHandle)) return;
    const normalize = value => (value || '').replace(/\s+/g, ' ').replace(/[:*]/g, '').trim().toLowerCase();
    const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const optionContainer = select => select.closest('.mw-option') || select.closest('fieldset') || select.parentElement;
    const labelFor = select => {
      const explicit = select.id ? document.querySelector(`label[for="${select.id}"]`) : null;
      const container = optionContainer(select);
      return normalize(container?.querySelector('.mw-label .mw-text--style-strong, legend, .mw-option-title, .mw-option-label')?.textContent || explicit?.textContent || select.getAttribute('aria-label'));
    };
    const isDoorStyle = select => /\bdoor style\b/.test(labelFor(select));
    const selection = select => normalize(select.selectedOptions?.[0]?.textContent || '');
    const openingMode = () => document.getElementById('sc-door-opening')?.selectedOptions?.[0]?.dataset.mode || '';
    const update = (select, panel) => {
      const value = selection(select);
      const door = /\bupgraded\b/.test(value) ? 'upgraded' : /\bstandard\b/.test(value) ? 'standard' : '';
      const mode = openingMode();
      panel.querySelectorAll('[data-sc-thermal-door]').forEach(card => card.hidden = card.dataset.scThermalDoor !== door || (door === 'standard' && !!mode));
      panel.querySelectorAll('[data-sc-thermal-door-opening]').forEach(card => card.hidden = door !== 'standard' || mode !== card.dataset.scThermalDoorOpening);
      panel.hidden = !door;
    };
    const mount = () => {
      product.querySelectorAll('select').forEach(select => {
        if (!visible(select) || !isDoorStyle(select)) return;
        const option = optionContainer(select);
        if (!option) return;
        let panel = option.querySelector(':scope > .sc-thermal-door-photo');
        if (!panel) {
          const fragment = source.querySelector('template').content.cloneNode(true);
          panel = fragment.querySelector('.sc-thermal-door-photo');
          option.append(fragment);
        }
        option.querySelector(':scope > .sc-shared-option-photos')?.classList.add('sc-thermal-door-photo__shared-door-panel');
        update(select, panel);
      });
    };
    let queued = false;
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; mount(); }); } };
    product.addEventListener('change', event => {
      const select = event.target.closest('select');
      if (!select || !isDoorStyle(select)) return;
      const panel = optionContainer(select)?.querySelector(':scope > .sc-thermal-door-photo');
      if (panel) update(select, panel); else schedule();
    });
    product.addEventListener('change', schedule);
    new MutationObserver(mutations => {
      if (mutations.some(m => !m.target.closest?.('.sc-thermal-door-photo'))) schedule();
    }).observe(product, {childList:true, subtree:true});
    product.addEventListener('click', event => {
      const button = event.target.closest('.sc-thermal-door-photo__open');
      if (!button) return;
      const card = button.closest('.sc-thermal-door-photo__card');
      const image = button.querySelector('img').cloneNode(true);
      image.loading = 'eager';
      dialog.querySelector('h2').textContent = card.querySelector('strong').textContent;
      dialog.querySelector('[data-sc-thermal-door-photo-expanded]').replaceChildren(image);
      dialog.showModal();
    });
    dialog.querySelector('[data-sc-thermal-door-photo-close]').addEventListener('click', () => dialog.close());
    mount();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

})();
